export default {
	cadAeronave: {
		aviao: 'Avião',
		cadastroDeAeronave: 'Cadastro de Aeronave',
		ciclosT1: 'Ciclos Voados NF',
		ciclosVoados: 'Ciclos Voados',
		codinome: 'Codinome',
		dadosAeroanve: 'Dados da aeronave',
		dadosMotor: 'Dados do motor',
		dataFabricacao: 'Data de Fabricação',
		dataUltima: 'Data da Ultima Manutenção',
		etiqueta: 'Etiqueta',
		fabricante: 'Fabricante',
		helicoptero: 'helicóptero',
		horasVoadas: 'Horas Voadas',
		imei: 'imei',
		modelo: 'Modelo',
		modeloMotor: 'Modelo Motor',
		motor: 'Motor',
		msgAtualizada: 'Aeronave atualizada com sucesso.',
		msgInserida: 'Inspeção adicionada com sucesso.',
		novaAeronave: 'Nova Aeronave',
		pousos: 'Pousos',
		prefixo: 'Prefixo',
		registro: 'Registro',
		serialNumber: 'Número de série',
		serialNumberMotor: 'Número de série do motor',
		tailNumber: 'Prefixo',
		tipo: 'Tipo',
	},
	calendario: {
		domingo: 'domingo',
		hoje: 'Hoje',
		quartaFeira: 'quarta-feira',
		quintaFeira: 'quinta-feira',
		segundaFeira: 'segunda-feira',
		sextaFeira: 'sexta-feira',
		sábado: ' sábado',
		terçaFeira: 'terça-feira',
	},
	componentNatureza: {
		cAddItem: 'Você só pode adicionar um item',
		cItem: 'Nenhum item adicionado ainda',
		cItemAdicionado: 'Item já adicionados',
		cItemJaAdicionado: 'Esse item já foi adicionado',
		cNatureza: 'Natureza da Ocorrência',
		cTipo: 'Tipo da Ocorrência',
	},
	componentRAisp: {
		aisp: 'Aisp',
		risp: 'Risp',
	},
	conversao: {
		ano: 'ano',
		anos: 'anos',
		ciclo: 'Ciclo',
		ciclos: 'Ciclos',
		dia: 'dia',
		dias: 'dias',
		hora: 'hora',
		horas: 'horas',
		mes: 'mês',
		meses: 'meses',
	},
	cores: {
		amarelo: 'Amarelo',
		azul: 'Azul',
		cinza: 'Cinza',
		preto: 'Preto',
		verde: 'Verde',
		vermelho: 'Vermelho',
	},
	diasDaSemana: {
		domingo: 'Dom',
		quarta: 'Qua',
		quinta: 'Qui',
		sabado: 'Sáb',
		segunda: 'Seg',
		sexta: 'Sex',
		terca: 'Ter',
	},
	diasSemana: {
		domingo: 'D',
		quarta: 'Q',
		quinta: 'Q',
		sabado: 'S',
		segunda: 'S',
		sexta: 'S',
		terca: 'T',
	},
	diasSemanaPos: {
		0: 'D',
		1: 'S',
		2: 'T',
		3: 'Q',
		4: 'Q',
		5: 'S',
		6: 'S',
	},
	gestao: {
		gestaoDe: 'Gestão',
	},
	global: {
		Altura: 'Altura',
		Desativando: 'Desativando',
		Dias: 'Dias',
		Em: 'Em',
		JornadaTrabalhoEFolgasProgramadas: 'Jornada Trabalho e Folgas Programadas',
		Justificativa: 'Justificativa',
		NenhumaNFSEncontrada: 'Nenhuma NFe Encontrada',
		PDFICPBrasil: 'PDF ICP Brasil',
		PermissoesAcessoLayers: 'Permissões de acesso ao layer',
		Por: 'Por',
		TipoDeEmbalagem: 'Tipo de embalagem',
		aListaAbaixo: 'A lista abaixo',
		aOS: 'A OS',
		aOrdemInciaEm: 'A ordem iniciará em',
		aPartirDe: 'A partir de',
		aQuantidadeFoiAlteradaComSucesso: 'A quantidade foi alterada com sucesso',
		aRecomendacaoFoiSalvaComSucesso: 'A recomendação foi salva com sucesso',
		aSolicitacaoEstaAprovada: 'A solicitação está <strong>APROVADA.</strong>',
		aSolicitacaoFoiDefinida: 'A solicitação foi definida para o operador',
		aSolicitacaoNaoAval: 'A solicitação <strong>NÃO TEM</strong> o parecer da operações.',
		aSolicitacaoNaoTemAprovacao: 'A solicitação <strong>NÃO TEM APROVAÇÃO</strong>.',
		aSolicitacaoNaoTemAvalManutencao: 'A solicitação <strong>NÃO TEM</strong> o parecer da manutenção.',
		aSolicitacaoTemAvalManutencao: 'A solicitação <strong>TEM</strong> o parecer da manutenção.',
		aSolicitaoTemOaval: 'A solicitação <strong>TEM</strong> o parecer da operações.',
		aTarefaFoiAdicionadaComSucesso: 'A tarefa foi adicionada com sucesso',
		aTarefaFoiSalvaComSucesso: 'A tarefa foi salva com sucesso',
		abaixoDe: 'Abaixo de',
		abaixoEstaoOsTrechosAgrupados: 'Abaixo estão os trechos agrupados.',
		abaixoMudancas: 'Abaixo como mudanças feitas nessa atualização',
		abastecedor: 'Abastecedor',
		abastecimento: 'Abastecimento',
		abastecimentoAeronave: 'Abastecimento de Aeronave',
		abastecimentoDeAeronaveFoiDeletadoComSucesso: 'Abastecimento de aeronave foi deletado com sucesso',
		abastecimentoDeAeronaveFoiSalvoComSucesso: 'Abastecimento de aeronave foi salvo com sucesso!',
		abastecimentoDeAeronaveViaApiContrato: 'Abastecimento de Aeronave via API/Contrato',
		abastecimentoDeAeronaveViaUnidadeDeArmazenamento: 'Abastecimento de Aeronave via Unidade de Armazenamento',
		abastecimentoOleo: 'Abastecimento óleo (L)',
		aberta: 'Aberta',
		aberto: 'Aberto',
		abertoPor: 'Aberto Por: ',
		abertura: 'Abertura',
		abrirChat: 'Abrir Chat',
		acao: 'Ação',
		acaoAdotada: 'Ação Adotada',
		acaoCorretiva: 'Ação Corretiva',
		acaoPreventiva: 'Ação Preventiva',
		acaoSalva: 'Ação Salva',
		acaoTomada: 'Ação Tomada',
		aceitavel: 'Aceitável',
		aceitavelbase: 'Aceitável com base na mitigação do risco. Pode requerer uma decisão da Direção',
		aceleracao: 'Aceleração',
		acessar: 'Acessar',
		acessarApp: 'Acessar App',
		acesso: 'Acesso',
		acessoExcluido: 'Acesso excluido com sucesso',
		acimaDe: 'Acima de',
		acimaDos: 'Acima dos',
		acionamento: 'Acionamento',
		acoes: 'Ações',
		acoesTomadas: 'Ações Tomadas',
		acumulado: 'Acumulado',
		acumuladoAno: 'Acumulado Ano',
		acumuladoMes: 'Acumulado Mês',
		acumuladoNoPeriodo: 'Acumulado no Período',
		adendo: 'Adendo',
		adicaoOleoLubrificante: 'Houve adição de óleo lubrificante?',
		adicionado: 'adicionado',
		adicionadoSucesso: 'Adicionado com sucesso',
		adicional: 'Adicional',
		adicionar: 'ADICIONAR',
		adicionarAcao: 'Adicionar Ação',
		adicionarAditivo: 'Adicionar aditivo',
		adicionarAeronave: 'Adicionar Aeronave',
		adicionarAplicabilidade: 'Adicionar APLICABILIDADE',
		adicionarBase: 'Adicionar Base',
		adicionarCarga: 'Adicionar Carga',
		adicionarCargaOpcao: 'Essa opção permite exibir um botão \'ADICIONAR CARGA\' em cada cartão de trabalho na manutenção.',
		adicionarConfiguracao: 'Adicionar Configurações',
		adicionarContato: 'Adicionar contato',
		adicionarDespacho: 'Adicionar Despacho',
		adicionarDias: 'Adicionar Dias',
		adicionarDiscrepancia: 'Adicionar Discrepância',
		adicionarDocumentacao: 'Adicionar Documentação',
		adicionarEmpenhos: 'Adicionar Empenhos',
		adicionarFrequencia: 'Adicionar frequência',
		adicionarFuncao: 'Adicionar Função',
		adicionarGrupo: 'Adicionar Grupo',
		adicionarInspecao: 'Adicionar Inspeção',
		adicionarInspecoes: 'Adicionar Inspeções',
		adicionarItem: 'Adicionar Item',
		adicionarLayer: 'Adicionar layer',
		adicionarMalhas: 'Adicionar Malhas',
		adicionarNovoParecer: 'Adicionar novo parecer',
		adicionarOcorrencia: 'Adicionar Ocorrência',
		adicionarOrgao: 'Adicionar Órgão',
		adicionarOrigem: 'Adicionar Origem',
		adicionarPagamento: 'ADICIONAR PAGAMENTO',
		adicionarParecer: 'Adicionar Parecer',
		adicionarPassageiro: 'Adicionar Passageiro',
		adicionarPeloMenosUmaInspecao: 'Você tem que adicionar pelo menos uma inspeção.',
		adicionarPeloMenosUmaPessoa: 'Você tem que adicionar pelo menos uma pessoa.',
		adicionarPeriodicidade: 'ADICIONAR PERIODICIDADE',
		adicionarPontos: 'Adicionar Pontos',
		adicionarRessalva: 'Adicionar Ressalva',
		adicionarSemana: 'Adicionar Semana',
		adicionarTarefa: 'Adicionar Tarefa',
		adicionarTarefas: 'Adicionar Tarefas',
		adicionarTipoDeSolicitacao: 'Adicionar tipo de solicitação',
		adicionarTrecho: 'Adicionar Trecho',
		adicionarTripulacao: 'Adicionar Tripulação',
		adicionarTripulante: 'Adicionar Tripulante',
		adicionarUnidade: 'Adicionar Unidade',
		adicionarUsuarios: 'Adicionar Usuários',
		adicionarValorAoContrato: 'Adicionar valor ao contrato',
		adicionarVoo: 'Adicionar Voo',
		adicionarVooEspecial: 'Adicionar Voo especial',
		adicionePeloMenosUmaTarefaParaCadaGrupoDeInspecoes: 'Adicione pelo menos uma tarefa para cada grupo de inspeções',
		adicioneUmRegistroDeLeitura: 'Adicione pelo menos um registro na tabela de leitura obrigatória',
		aditivo: 'Aditivo',
		aditivoSalvoEContratoAtualizadoComSucesso: 'Aditivo salvo e contrato atualizado com sucesso',
		aditivos: 'Aditivos',
		administracaoEscolar: 'Administração Escolar',
		administradorContrato: 'Fiscal / Administrador do Contrato',
		administradorSubstitutoDoContrato: 'Fiscal / Administrador Substituto do Contrato',
		administrativa: 'Administrativa',
		aeronauta: 'Aeronauta',
		aeronavaArmazenamento: 'Aeronave para armazenamento',
		aeronave: 'Aeronave',
		aeronaveAplicavel: 'Aeronave Aplicável',
		aeronaveDestino: 'Aeronave Destino',
		aeronaveDisponivel: 'Aeronave disponível',
		aeronaveDuplicada: 'Essa aeronave está duplicada',
		aeronaveIndisponivel: 'Aeronave indisponível',
		aeronaveNaoRetornouAoServico: 'A aeronave não retornou ao serviço pois existe(m) ordem(ns) em aberto',
		aeronaveNãoEncontrada: 'Aeronave não encontrada',
		aeronaveParada: 'Aeronave parada',
		aeronaveTurnoServico: 'Aeronave do turno de serviço',
		aeronavesAsasFixas: 'Aeronaves Asas Fixas',
		aeronavesAsasRotativas: 'Aeronaves Asas Rotativas',
		aeronavesEDisponibilidade: 'Aeronaves e Disponibilidade',
		aeronavesEmpregadas: 'Aeronaves Empregadas',
		aeronavesOperadasPelo: 'Aeronaves Operadas pelo',
		aeroporto: 'Aeroporto',
		afastamentoVor: 'Afastamento do VOR(NM)',
		agrupado: 'Agrupado',
		agruparTrecho: 'Agrupar Trecho',
		agruparTrechos: 'Agrupar Trechos',
		aguardandoLeitura: 'Aguardando leitura',
		aindaNaoAvaliado: 'Ainda não avaliado',
		aindaNaoLido: 'Ainda não lido',
		ajustes: 'AJUSTES',
		alergia: 'Alergia',
		alerta: 'Alerta',
		alertaCalculoAutomatico1: 'O cálculo automático de tempo de voo não está disponível, a',
		alertaCalculoAutomatico2: 'velocidade média, consumo e tanque não foram adicionados para essa aeronave.',
		alertas: 'Alertas',
		alinhaTabela: 'Alinhar Tabela',
		almoco: 'Almoço',
		alocacao: 'Alocação',
		alocacaoExcluidaComSucesso: 'Alocação excluída com sucesso',
		alocado: 'Alocado',
		alta: 'Alta',
		alteracao: 'Alteração',
		alteracoesEdicao: 'Alterações salvas e assinatura realizadas com sucesso!',
		alteradoPor: 'Alterado Por',
		alterados: 'Alterados',
		alterandoAQuantidade: 'Alterando a quantidade',
		alterandoSenha: 'Alterando sua senha',
		alterar: 'Alterar',
		alterarAQuantidade: 'Alterar a quantidade',
		alterarAssinatura: 'Alterar Assinatura',
		alterarAssinaturaNoProximoLogin: 'Alterar Assinatura no próximo login?',
		alterarDespacho: 'Alterar Despacho',
		alterarQuantidade: 'Quantidade Alterada',
		alterarSenha: 'Alterar a senha',
		alterarSenhaProximoLogin: 'Alterar a senha no próximo login?',
		alterarStatus: 'Alterar Status',
		alternativos: 'Alternativos',
		altitude: 'Altitude',
		altitudeRecuperadaAtraves: 'Altitude recuperada através do Google Maps',
		altitudeTerreno: 'Altitude do Terreno',
		altitudeVelocidade: 'Altitude e Velocidade',
		altura: 'Altura',
		alturaVoo: 'Altura do Voo',
		aluno: 'Aluno',
		alunos: 'Alunos',
		ambiente: 'Ambiente',
		anac: 'Anac',
		and: 'e',
		anexeUmaImagem: 'Anexe uma imagem',
		anexo: 'Anexo',
		anexoSolicitacao: 'Anexo da Solicitação',
		anexos: 'Anexos',
		ano: 'Ano',
		anoFabricacao: 'Ano de Fabricação',
		anoModelo: 'Ano do Modelo',
		anos: 'Anos',
		anual: 'Anual',
		apareceraDespachoAeronaves: 'Aparecerá no Despacho de Aeronaves até a opção \'Encerrar este despacho?\' ser marcada como SIM.',
		aplicabilidade: 'Aplicabilidade',
		aplicar: 'Aplicar',
		aplicativoTelaLogin: 'Aplicativo Tela de Login',
		aplicavel: 'Aplicável',
		apoiados: 'Apoiados',
		aposSelecionarInspecao: 'Após selecionar todas as inspeções que deseja, clique em \'Adicionar Inspeções\'.',
		apreciacao: 'Apreciação',
		apreciacaoAnalise: 'Analise do ESO',
		apreciacaoSalva: 'Apreciação salva com sucesso',
		apresentacao: 'Apresentação',
		aprovacao: 'Aprovação',
		aprovado: 'Aprovado',
		aprovados: 'Aprovados',
		aprovarEssaSolicitacao: 'Aprovar essa solicitação (Gerar Ordem de Missão)?',
		areaCriacao: 'Área de Criação',
		areaMapeamento: 'Área de Mapeamento',
		areaMonitoramento: 'Área de Monitoramento',
		armasApreendidas: 'Armas Apreendidas',
		armazenamento: 'Armazenamento',
		armazenamentoDisponivel: 'Armazenamento disponível',
		arquivo: 'Arquivo',
		arquivosAusentesCorrompidos: 'Arquivos Ausentes/Corrompidos',
		arrasteParaAumentarInferior: 'Arraste para aumentar de tamanho, no canto inferior direito da tela',
		arrasteParaMover: 'Arraste para mover os itens da tabela',
		as: 'às',
		asTarefasForamAdicionadasComSucesso: 'As tarefas foram adicionadas com sucesso',
		asTarefasForamSalvasComSucesso: 'As tarefas foram salvas com sucesso',
		asasFixas: 'Asas Fixas',
		asasRotativas: 'Asas Rotativas',
		aspectos: 'Aspectos Envolvidos',
		assinadoDigitalmentePor: 'Assinado digitalmente por',
		assinadoPor: 'Assinado por',
		assinadosPorMim: 'Assinados por mim',
		assinando: 'Assinando',
		assinar: 'Assinar',
		assinarEFinalizar: 'Assinar e Finalizar',
		assinarESalvarTrecho: 'Assinar e Salvar Trecho',
		assinarEletronicamente: 'Assinar eletronicamente',
		assinarInspetor: 'Assinar Inspetor',
		assinarManualmente: 'Assinar manualmente',
		assinarMecanico: 'Assinar Mecânico',
		assinarTodosOsTrechos: 'Assinar todos os trechos',
		assinarTrecho: 'Assinar Trecho',
		assinatura: 'ASSINATURA',
		assinaturaAvalicao: 'A assinatura deve ter 8 dígitos numéricos.',
		assinaturaDigialInspetor: 'Assinado digitalmente pelo inspetor',
		assinaturaDigital: 'Assinatura Digital',
		assinaturaDigitalMecanico: 'Assinado digitalmente pelo mecânico',
		assinaturaDigitalPilotoComando: 'Assinado digitalmente pelo piloto em comando',
		assinaturaEletronica: 'Assinatura Eletrônica',
		assinaturaInvalida: 'Assinatura inválida.',
		assinaturaMotivo: 'Motivo enviando com sucesso!',
		assinaturaOrdem: 'Assinatura da ordem de missão',
		assinaturaTemQueTer8: 'A Assinatura tem que ter 8 dígitos numéricos',
		ate: 'até',
		atencaoAdd: 'Atenção adicionada com sucesso!',
		atencaoEspecial: 'Atenção Especial',
		ativa: 'Ativa',
		ativaEDesativaPrivilegios: 'Aqui você ATIVA ou DESATIVA os privilégios que serão exibidos para o cliente.',
		ativar: 'Ativar',
		ativarInspecao: 'Ativar Inspeção',
		ativarInspecoes: 'Para ativar essa inspeção, é necessário uma justificativa',
		ativarTodas: 'Ativar todas',
		ativarTodasInspecoes: 'Para ativar todas as inspeções, é necessário uma justificativa',
		ativarUsuario: 'Ativar Usuário',
		atividade: 'Atividade',
		atividades: 'Atividades',
		atividadesAereas: 'Atividades Aereas',
		atividadesAereasGeral: 'Atividades Aéreas Geral',
		ativo: 'Ativo',
		atravesDaBusca: 'através da busca',
		atualizaDadosFdm: 'Atualiza dados do FDM',
		atualizacao: 'Atualização',
		atualizacaoTempoManual: 'Atualização de tempo manual',
		atualizacoes: 'Atualizações',
		atualizado: 'Atualizado',
		atualizando: 'Atualizando',
		atualizandoLista: 'Atualizando lista',
		atualizandoModelosAeronaves: 'Atualizando modelos das aeronaves',
		atualizandoTempo: 'Atualizando tempo',
		atualizar: 'Atualizar',
		atualizarCartao: 'Atualizar Cartão',
		atualizarCartoes: 'Atualizar cartões',
		atualizarGrupo: 'Atualizar Grupo',
		atualizarItem: 'Atualizar Item',
		atualizarMapa: 'Atualizar Mapa',
		atualizarOrdemDeMissao: 'Salvar o preenchimento da Ordem de Missão',
		atualizarOrdemServico: 'Atualizar ordem de serviço',
		atualizarRoteiro: 'Atualizar Roteiro',
		atualizarSolicitacao: 'Atualizar Solicitação',
		atualizarTrecho: 'Atualizar Trecho',
		auditoria: 'Auditoria',
		auditoriaDiarioDeBordo: 'Auditoria Diário de Bordo',
		aunqueNoFueCerrado: 'EMBORA NÃO ESTIVESSE FECHADO',
		ausentes: 'Ausentes',
		autoLocalizacao: 'Auto Localização',
		autonomia: 'Autonomia',
		autorizacao: 'Autorização',
		aval: 'Aval',
		avaliacao: 'Avaliação',
		avaliacaoGeral: 'AVALIAÇÂO GERAL',
		avaliacaoQualitativa: 'Avaliação qualitativa',
		avaliacaoQualitativaAposAAplicacao: 'Avaliação qualitativa após a aplicação das recomendações',
		avaliacaoQualitativaExecucao: 'Avaliação Qualitativa após a mitigação',
		avaliar: 'Avaliar',
		avaliarDiscrepancia: 'Avaliar Discrepancia',
		avancado: 'Avançado',
		avancar: 'Avançar',
		avioesEDisponibilidade: 'Aviões e Disponibilidade',
		avisoDeInicializacao: 'AVISO DE INICIALIZAÇÃO',
		baco: 'Baço',
		bagagemMao: 'Bagagem de Mão',
		bagagemPorao: 'Bagagem Porão',
		bairro: 'Bairro',
		baixa: 'Baixa',
		baixar: 'Baixar',
		bambiBucket: 'Bambi Bucket',
		bancoDeDados: 'Banco de Dados',
		base: 'Base',
		baseContratual: 'Base Contratual',
		baseContratualETransferencia: 'Bases contratuais e transferências',
		baseDeOrigem: 'Base de Origem',
		baseOperacional: 'Base Operacional',
		basico: 'Básico',
		bastaClicar: 'Basta clicar no mapa para adiconar um novo ponto de interesse, ou clicar em um no mapa para editá-lo',
		bateria: 'Bateria',
		bilhete: 'Bilhete',
		bilhetesDeEmbarque: 'Bilhetes de embarque',
		boletins: 'Boletins',
		botaoAlertaAeronave: 'Botão de alerta da aeronave',
		botoesEGatilhos: 'Botões e Gatilhos',
		brigadistas: 'Brigadistas',
		buscar: 'Digite para buscar na lista abaixo',
		buscarFatura: 'Buscar',
		cCarregar: 'CARREGAR',
		cadComissaria: 'Cadastro de Comissaria',
		cadTipoHabilitacao: 'Cadastro de tipo de habilitação',
		cadTripulacao: 'Cadastro Tripulação',
		cadastrar: 'Cadastrar',
		cadastrarImagens: 'Cadastrar Imagens',
		cadastrarNovoDespacho: 'Cadastrar novo despacho',
		cadastrarProcedimento: 'Cadastrar Procedimento',
		cadastro: 'Cadastro',
		cadastroAplicabilidade: 'CADASTRO DE APLICABILIDADE',
		cadastroAtividade: 'Cadastro de Atividade',
		cadastroCliente: 'Cadastro de cliente',
		cadastroCombustiveis: 'Cadastro Combustíveis',
		cadastroConfigAeronave: 'Cadastro Configurações da Aeronave',
		cadastroDeBase: 'Cadastro de Base',
		cadastroDeDepartamento: 'Cadastro de Departamento',
		cadastroDeDocumentacao: 'Cadastro de Documentação',
		cadastroDeFuncoes: 'Cadastro de Funções',
		cadastroDeOvn: 'Cadastro de OVN',
		cadastroDeSecao: 'Cadastro de Seção',
		cadastroDeSessao: 'Cadastro de Sessão',
		cadastroDeVeiculos: 'Cadastro de Veículos',
		cadastroFornecedor: 'Cadastro de Fornecedor',
		cadastroGrupoDePassageiros: 'Cadastro Grupo de Passageiros',
		cadastroLayer: 'Cadastro de Layers',
		cadastroLicenca: 'Cadastro de Licenças',
		cadastroMateriais: 'Cadastro de Materiais',
		cadastroMotor: 'Cadastro de Motor',
		cadastroPassageiros: 'Cadastro de Passageiros',
		cadastroPontosInteresse: 'Cadastro de Pontos de Interesse',
		cadastroRotaer: 'Cadastro de Rotaer',
		cadastroTipoArmazenamento: 'Cadastro Tipo Armazenamento',
		cadastroTipoCarga: 'Cadastro de Tipo de Carga',
		cadastroTipoEmbalagem: 'Cadastro de Tipo de Embalagem',
		cadastroTipoVeiculo: 'Cadastro de Tipo de Veículo',
		cadastroUnidadeArmazenamento: 'Cadastro de Unidade de Armazenamento',
		cadastroUnidadeConservacao: 'Cadastro de Unidade de Conservação',
		cadastroUnidadeOrcamentaria: 'Cadastro Unidade Orçamentária',
		cadastroUsuarioSimplificado: 'Cadastro de Usuário Simplificado',
		cafeManha: 'Café da manhã',
		calculoSistema: 'Cálculo no Sistema',
		calculosDoImpostos: 'Cálculo do Impostos',
		calendarica: 'Calendárica',
		calendaricas: 'Calendáricas',
		calendario: 'Calendário',
		calendarioAnual: 'Calendário Anual',
		calendarioDeManutencao: 'Calendário de Manutenção',
		calendarioEscala: 'Calendário Escala',
		calendarioManutencao: 'Calendário Manutenção',
		calendarioSemanal: 'Calendário Semanal',
		calor: 'Calor',
		caminhao: 'Caminhão',
		camp: 'Camp',
		campo1: 'Campo 1',
		campo2: 'Campo 2',
		campo3: 'Campo 3',
		campo4: 'Campo 4',
		campo5: 'Campo 5',
		campoObrigatorio: 'Esse campo é obrigatório.',
		camposObrigatorios: 'Você precisa inserir os campos obrigatórios.',
		camposOleoLubrificante: 'Campos de óleo lubrificante',
		camposWsdl: 'Campos WSDL',
		cancelaOrdemServico: 'Cancelar Ordem de Serviço',
		cancelada: 'Cancelada',
		canceladaComSucesso: 'Cancelada Com Sucesso!',
		cancelado: 'Cancelado',
		cancelados: 'Canceladas',
		cancelando: 'Cancelando',
		cancelar: 'Cancelar',
		cancelarDespacho: 'Cancelar Despacho',
		cancelarDiario: 'Cancelar Edição',
		cancelarOrdem: 'Cancelar Ordem',
		cancelarOrdemServico: 'Deseja CANCELAR essa Ordem de Serviço?',
		cancelarSelecao: 'Cancelar seleção',
		capacidade: 'Capacidade',
		capacidadeMaxima: 'Capacidade Máxima',
		capacidadeMaximaMovimentacaoCombustivel: 'Capacidade Máxima(l)',
		capacidadeOuPotenciaOuCilindrada: 'Capacidade / Potência / Cilindrada',
		capitulo: 'Capítulo',
		caracteresRestantes: 'caracteres restantes.',
		carga: 'Carga',
		cargaExcluidaComSucesso: 'Carga excluída com sucesso',
		cargaHoraria: 'Carga horária',
		cargaHorariaSemanal: 'Carga Horária Semanal',
		cargaInicial: 'Carga Inicial',
		cargaLiquida: 'Carga Líquida?',
		cargaPerigosa: 'Carga Perigosa',
		cargaSalvaComSucesso: 'Carga salva com sucesso',
		cargaTransportada: 'Carga Transportada',
		cargo: 'Cargo',
		carregaAutomaticoPerfilAoCriarUsuario: 'Carregar automaticamente esse perfil ao criar um novo usuário?',
		carregando: 'Carregando',
		carregandoComponentes: 'Carregando Componentes',
		carregandoDados: 'Carregando dados',
		carregandoDadosCAMP: 'Carregando dados de API do CAMP',
		carregandoDiario: 'Carregando diário de bordo',
		carregandoDiarios: 'Carregando diários',
		carregandoEntregas: 'Carregando entregas',
		carregandoHorimetro: 'Carregando horimetro',
		carregandoListas: 'Carregando Listas',
		carregandoMaisOpcoes: 'Carregando mais opcões',
		carregandoManutencoes: 'Carregando manutenções',
		carregandoModelo: 'Carregando modelo',
		carregandoMovimentacoes: 'Carregando movimentações',
		carregandoNFS: 'Carregando NFe',
		carregandoOrdemServico: 'Carregando Ordem de Serviço',
		carregandoPosicaoDoVoo: 'Carregando posição do voo',
		carregar: 'Carregar',
		carregarFoto: 'Carregar Foto',
		carregarModelo: 'Carregar Modelo',
		carregarNota: 'Carregar NFe',
		carregarPosicaoDoVoo: 'Carregar posição do voo',
		carregarVoos: 'Carregar Voos',
		carrgandoFoto: 'Carregando foto',
		cartaDeSituacao: 'Carta de Situação',
		cartaDeSituacaoCalendario: 'Carta de Situação',
		cartaDeSituacaoOperacoes: 'Carta de Situação Operações',
		cartoesParaAtualizar: 'CARTÕES PARA ATUALIZAÇÃO',
		casaDecimal: 'Necessita de casa decimal',
		casado: 'Casado(a)',
		caso: 'Caso',
		casoNaoUtilizeDiario: 'Caso não utilize o diário de bordo para atualizar os manuais, você pode habilitar essa opção, com isso será exibia uma aba \'ATUALIZAÇÕES \' na tela VISÃO GERAL, permitindo atualizar manualmente a manutenção.',
		casoNenhumaAeronave: 'Caso nenhuma aeronave seja selecionada',
		catastrofico: 'Catastrófico',
		categoria: 'Categoria',
		celula: 'Célula',
		centralizar: 'Centralizar',
		centroCusto: 'Centro de custo',
		centroCustoAtualizado: 'Centro de Custo Atualizado',
		centroDeCustos: 'Centros de Custo',
		cep: 'CEP',
		ceso: 'Gerenciamento de Risco',
		cfg: 'Configuração',
		chamada: 'Chamada',
		chamadaDeSuporte: 'Chamada de Suporte',
		chamadoConcluido: 'Chamado Concluido',
		chamadoSuporte: 'Chamados de Suporte',
		chassi: 'Chassi',
		chaveApi: 'Chave da Api',
		chaveDaNFE: 'Chave da NFe',
		chaveNFE: 'Chave da NFe',
		chaveServices: 'Chave no Services',
		checkIn: 'checkin',
		chegada: 'Chegada',
		cicloDeTorque: 'Ciclo de Torque',
		cicloTorque: 'Ciclo de Torque',
		cicloTotaisManutencao: 'Ciclos Totais Manutenção',
		ciclos: 'Ciclos',
		ciclosNF: 'Ciclos N2/NF/NTL',
		ciclosNG: 'Ciclos N1/NG',
		ciclosNP: 'Ciclos NP',
		ciclosTorque: 'Ciclos Toque',
		ciclosTotais: 'Ciclos Totais',
		ciclosTotaisMotor: 'Ciclos Totais Motor',
		cidade: 'Cidade',
		cidadeDeVerificacao: 'Cidade de Verificação',
		classificacao: 'Classificação',
		classificacaoAtualizada: 'Classificação atualizada',
		classificacaoDesativada: 'Classificação desativada',
		classificacaoESub: 'Classificação e Subclassificação',
		classificacaoExcluida: 'Classificação excluída',
		classificacaoSalva: 'Classificação Salva',
		clickAquiParaAnexar: 'Clique aqui para anexar',
		clickExibirApp: 'Clique aqui para acessar o followair do seu telefone.',
		clickParaVerOsTrechosAgrupados: 'Clique para ver os voos agrupados',
		clickParaVerOsTrechosPor: 'Clique para ver os voos agrupados por',
		clienteAtualizado: 'Cliente Atualizado',
		clienteSolicitante: 'Cliente Solicitante',
		clientesSolicitantes: 'Clientes Solicitantes',
		cliqueAqui: 'Clique Aqui',
		cliqueEmAlgumaImagem: 'Clique em alguma imagem',
		cliqueEmCarregar: 'Clique em carregar após digitar',
		cliqueEmNovoParaAdicionar: 'Clique em \'Novo\' para adicionar',
		cliqueNoHistoricoParaCarregar: 'Clique no histórico para carregá-lo.',
		cliqueParaAnexar: 'CLIQUE PARA ANEXAR',
		cliqueParaConcluir: 'Clique para concluir',
		cliqueParaRemover: 'Clique para remover',
		cliqueParaVerAAssinatura: 'Clique para ver a assinatura',
		cliqueTrechoCarregar: 'Clique no trecho para carregá-lo.',
		cnpj: 'CNPJ',
		codigo: 'Código',
		codigoClassificacao: 'Código Classificação',
		codigoDaSolicitacao: 'Código da solicitação',
		codigoDoProduto: 'Código do Produto',
		codigoGeradoAoSalvar: 'Código gerado ao salvar',
		codigoGerenciamentoDeRisco: 'Código gerenciamento de risco',
		codigoInterno: 'Código Interno',
		codigoOrdemDeServico: 'Código da Ordem de Serviço',
		codigoRenavan: 'Código Renavan',
		codigoSituacao: 'Código - Situação',
		codinome: 'Codinome',
		coluna: 'Coluna',
		com: 'Com',
		comUmLink: 'com um link para recuperar a sua senha!',
		comandante: 'Comandante',
		comandanteLocalMissao: 'Comandante da Missão no local',
		combustivel: 'Combustível',
		combustivelConsumido: 'Combustível Consumido',
		combustivelInicial: 'Combustível Inicial',
		combustivelTotal: 'Combustível Total',
		comissario: 'Comissário',
		comissarios: 'Comissário',
		comoDesejaFiltar: 'Escolha forma que gostaria de filtrar',
		complemento: 'Complemento',
		completo: 'Completo',
		componente: 'Componente',
		componenteCargaSolicitacao: 'Componente Carga Solicitação',
		componentePassageiroSolicitacao: 'Componente passageiro solicitação',
		componenteTrechoSolicitacao: 'Componente Trecho Solicitação',
		componentes: 'Componentes',
		comprimento: 'Comprimento',
		comprovanteAbastecimento: 'Comprovante Abastecimento',
		comprovanteMaterialRequisitado: 'Comprovante de Material Requisitado',
		computadorDeBordo: 'Computador de Bordo',
		comunicacaoESO: 'Gerenciamento de risco',
		comunicacoes: 'Comunicações',
		concluiEssaInspecao: 'Concluí essa Inspeção',
		concluida: 'Concluída',
		concluido: 'Concluído',
		concluidoNoTotalDe: 'Concluido no total de: ',
		concluidoPor: 'Concluido por',
		concluidos: 'Concluídos',
		concluir: 'Concluir',
		concluirDiscrepancia: 'Concluir Discrepância',
		concluirOrdemDeServico: 'CONCLUIR ORDEM DE SERVIÇO',
		conclusao: 'Conclusão',
		concordoComOsTermosDeUso: 'CONCORDO COM OS TERMOS DE USO',
		conferencia: 'CONFERÊNCIA',
		configBackend: 'Configuração Backend',
		configuracao: 'Configuração',
		configuracaoAeronave: 'Configuração Aeronave',
		configuracoes: 'Configurações',
		configuracoesEscala: 'Configurações Escala',
		configuracoesSalvas: 'Configurações Salvas',
		confirmaExclusaoLeitores: 'Esta ação irá excluir os leitores obrigatórios ja inseridos, deseja prosseguir?',
		confirmaLeitura: 'Confirma a leitura',
		confirmaLeituraDocumento: 'Você confirma a leitura desse documento?',
		confirmando: 'Confirmando',
		confirmar: 'Confirmar',
		confirmarAssinatura: 'Confirmar nova assinatura',
		confirmarDuplicar: 'Confirma que deseja duplicar',
		confirmarNewPassword: 'Confirmar nova senha',
		confirmeDadosAeronave: 'Confirme se os dados da aeronave e motor estão corretos',
		conjuge: 'Cônjuge',
		consultarNota: 'Consultar NFe',
		consumados: 'Consumados',
		consumidoOValorTotalDoContrato: 'Consumido o valor total do contrato',
		consumidoOValorTotalDoEmpenho: 'Consumido o valor total do empenho',
		consumivel: 'Consumível?',
		consumo: 'Consumo',
		consumoDeCiclos: 'CONSUMO DE CICLOS',
		consumoTotal: 'consumo Total',
		contador: 'Contador',
		contato: 'Contato',
		contatoDeEmergencia: 'Contato de Emergência',
		contatoEmCasoDeEmergencia: 'Contato em Caso de Emergência',
		contatosMissao: 'Contatos da Missão',
		contexto: 'Contexto',
		contextoAtualizado: 'Contexto operativo atualizado',
		contextoExcluido: 'Contexto Operativo excluído.',
		contextoOperativo: 'Contexto Operativo',
		contextoSalvo: 'Contexto Operativo salvo',
		continuar: 'Continuar',
		contrato: 'Contrato',
		contratoAtualizadoComSucesso: 'Contrato Atualizado com Sucesso!',
		contratoEmpenhoMovimentacao: 'Esse contrato já possui um empenho ou está relacionado a uma movimentação de combustível!',
		contratoExcluidoComSucesso: 'Contrato Excluído com Sucesso!',
		contratoSalvoComSucesso: 'Contrato salvo com sucesso',
		contratos: 'Contratos',
		contratosAbastecimento: 'Contratos Abastecimentos',
		contratosGenericos: 'Contratos Genéricos',
		contratosSBH: 'Contratos SBH',
		controlado: 'Controlado',
		controle: 'Controle',
		controleDeAbastecimento: 'Controle de Abastecimento',
		controleDeInpencoesEManuais: 'Controle de Inspeções e Manuais',
		controleDeInspecao: 'Controle de Inspeção',
		controleDePassageirosECargas: 'Controle de passageiros e cargas',
		controleHorasEMotor: 'CONTROLE DE HORAS E CICLOS DE MOTOR',
		controleHorasOvn: 'Controle de Horas do Óculos de Visão Noturna(OVN)',
		controleHorasVoadas: 'Controle de Voos',
		controleInpencoesComponentes: 'Controle de Inspeções e Componentes',
		copiandoDiario: 'Copiando diário de bordo',
		copiar: 'Copiar',
		copiarDespacho: 'Copiar último despacho',
		copiarOrdem: 'Copiar última ordem',
		copiarPessoas: 'Copiar Pessoas',
		copiarSolicitacao: 'Copiar última solicitação',
		copiloto: 'Copiloto',
		cor: 'Cor',
		corIdentificacao: 'Cor de identificação',
		corPolilyne: 'Cor Polilyne',
		corPredominante: 'Cor Predominante',
		coracao: 'Coração',
		cornea: 'Córnea',
		correcao: 'Correção',
		corrijaCamposVermelho: 'Corrija os campos em vermelho',
		corrijaOsCamposEmVermelho: 'Corrija os campos em vermelho',
		corrompidos: 'Corrompidos',
		corte: 'Corte',
		corteVoo: 'Corte',
		cotacao: 'Cotação',
		cpfInvalido: 'CPF inválido',
		cpfInvalidoOuJaCadastradoNoSistema: 'CPF inválido ou já cadastrado no sistema',
		cpfJaCadastrado: 'CPF já cadastrado.',
		cpfUsadoComoLoginEsenha: 'O Número do CPF será usado como LOGIN e SENHA, que deverá ser alterada no primeiro acesso.',
		crea: 'CREA',
		crianca: 'Criança (Entre 2 e 12 anos)',
		criar: 'Adicionar',
		criarModeloPadrao: 'Criar Modelo Padrão',
		critica: 'Crítica',
		cumpridoConformeDocumentacaoReferencia: 'Cumprido Conforme Documentação de Referência.',
		custo: 'Custo',
		custoDoCiclo: 'Custo do Ciclo',
		custoHora: 'Custo da Hora',
		daAeronave: 'da aeronave',
		daProgramacao: 'da programação',
		dac: 'DAC',
		dadosCadernetaIndividualVoos: 'Dados Caderneta Individual de Voo (CIV)',
		dadosDaMissao: 'Dados da Missão',
		dadosDaMissaoPreenchidos: 'Todos os dados da ordem de missão foram preenchidos, está aguardando entrar em execução.',
		dadosDaPrevencao: 'Dados da Prevenção',
		dadosDeDestino: 'Dados de Destino',
		dadosDeEmissao: 'Dados de Emissão',
		dadosDeEntrega: 'Dados de Entrega',
		dadosDeMonitoramento: 'Dados de Monitoramento do Motor e Abastecimento de Óleo',
		dadosDoCliente: 'Dados do Cliente',
		dadosDoContrato: 'Dados do Contrato',
		dadosDoDespacho: 'Dados do Despacho',
		dadosDoVoo: 'Dados do Voo',
		dadosFornecedor: 'Dados do Fornecedor',
		dadosFuncionais: 'Dados Funcionais',
		dadosGerais: 'Dados Gerais',
		dadosIniciais: 'Dados Iniciais',
		dadosKit: 'Dados do Kit',
		dadosMotor: 'Dados do Motor',
		dadosOleoEdicaoMecanico: 'As informações referentes ao óleo lubrificante foram editadas pelo mecânico',
		dadosdeEntregaDaNFe: 'Dados de Entrega da NFe',
		dashboardDadosSistema: 'Dashboard dos Dados do Sistema',
		data: 'Data',
		dataAbertura: 'Data de Abertura',
		dataAberturaCadastro: 'Data de Abertura',
		dataAcesso: 'Data de acesso',
		dataAtualMaiorUltimoTrecho: 'A data atual é maior que o último trecho da ordem de missão.',
		dataAtualizacao: 'Data Atualização',
		dataCE: 'Data do CE',
		dataCadastroOvn: 'Data quando o cadastro deste S/N foi feito no sistema',
		dataCompra: 'Data da compra',
		dataConclusao: 'Data Conclusão',
		dataCorrecao: 'Data Correção',
		dataCotacao: 'Data Cotação',
		dataCriacao: 'Data Criação',
		dataDaConclusao: 'Data da conclusão',
		dataDaNFE: 'Data da NFe',
		dataDaOcorrencia: 'Data da ocorrência',
		dataDaSolicitacao: 'Data da Solicitação',
		dataDeConclusao: 'Data de conclusão',
		dataDeInspecao: 'Data de Inspeção',
		dataDeVerificacao: 'Data de Verificação',
		dataDiario: 'Data Diário',
		dataDoDiarioDeBordo: 'Data do Diário de Bordo',
		dataDoMB1A2: 'Data do MB1A2',
		dataDoPagamento: 'Data do Pagamento',
		dataDoRecebimentoFisico: 'Data do Recebimento Físico',
		dataEmissao: 'Data de Emissão',
		dataEmissaoNotaFiscal: 'Data da Emissão da Nota Fiscal',
		dataEncerramento: 'Data Encerramento: ',
		dataEstimada: 'Data Estimada',
		dataExecucao: 'Data Execução',
		dataFabricacao: 'Data Fabricação',
		dataFim: 'Data Fim',
		dataFimIndisponibilidade: 'Data fim da indisponibilidade',
		dataFimValidade: 'Data de fim da validade',
		dataGarantia: 'Data da garantia',
		dataHoraCadastro: 'Data-Hora Cadastro',
		dataHorasVoadas: 'Data Horas Voadas',
		dataHorimetro: 'Data Horímetro',
		dataHorimetroAtual: 'Data Horímetro Atual',
		dataInicio: 'Data Início',
		dataInicioCarga: 'Data início da primeira carga',
		dataInicioIndisponibilidade: 'Data de início da indisponibilidade',
		dataInicioOvn: 'Data inicial do OVN',
		dataInicioValidade: 'Data de início da validade',
		dataInvalida: 'Data Inválida',
		dataLeitura: 'Data da leitura',
		dataLimite: 'Data Limite',
		dataManutencao: 'Data Manutenção',
		dataNascimento: 'Data de Nascimento',
		dataPrevisao: 'Data Previsão: ',
		dataProcessamento: 'Data Processamento',
		dataProximaInspecao: 'Data da próxima inspeção',
		dataReportada: 'Data Reportada',
		dataServico: 'Data do serviço',
		dataSolicitacao: 'Data Solicitação',
		dataTermino: 'Data Término',
		dataTolerancia: 'Data de tolerância',
		dataUltimaInspecao: 'Data da última Inspecao',
		dataUltimoVoo: 'Data do Último Voo',
		dc: 'dc',
		de: 'De',
		deTrabalho: 'de Trabalho',
		decimal: 'Decimal',
		decimo: 'Décimo',
		decolagem: 'Decolagem',
		decolagemPrevista: 'Decolagem prevista',
		decolagemPrevisto: 'Decolagem previsto',
		defasagemVorI: 'Defasagem VOR I',
		defasagemVorII: 'Defasagem VOR II',
		definirComoPlanoDeFundo: 'Definir Como Plano De Fundo',
		definirOperador: 'Definir Operador',
		definirPlanoDeFundo: 'Definir Plano de Fundo',
		delito: 'Delito',
		demandaReprimida: 'Demanda Reprimida',
		densidade: 'Densidade',
		departamento: 'Departamento',
		departamentoSolicitante: 'Departamento solicitante',
		desabilitado: 'desabilitado',
		desabilitar: 'Desabilitar',
		desabilitarInspecao: 'Desabilitar Inspeção',
		desagrupando: 'Desagrupando',
		desagruparTrechos: 'Desagrupar Trechos',
		desativadoComSucesso: 'Desativado com sucesso',
		desativar: 'Desativar',
		desativarInspecao: 'Desativar Inspeção',
		desativarInspecoes: 'Para desativar essa inspeção, é necessário uma justificativa',
		desativarTodas: 'Desativar todas',
		desativarTodasInspecoes: 'Para desativar todas as inspeções, é necessário uma justificativa',
		desativarUsuario: 'Desativar Usuário',
		desconto: 'Desconto',
		descricao: 'Descrição',
		descricaoAlijamentosCarga: 'Descrição dos alijamentos de carga',
		descricaoAnp: 'Descrição ANP',
		descricaoCapitulo: 'Descrição do capitulo',
		descricaoCompleta: 'Descrição completa',
		descricaoDaCarga: 'Descrição da Carga',
		descricaoDaMissao: 'Descrição da Missão',
		descricaoDaOrdem: 'Descrição da Ordem',
		descricaoDoExercicio: 'Descrição do Exercício',
		descricaoDoLocal: 'Descrição do Local',
		descricaoDoTema: 'Descrição do Tema',
		descricaoDosFatos: 'Descrição dos Fatos',
		descricaoLavagemCompressor: 'Descrição da lavagem do compressor',
		descricaoLayer: 'Descrição para o layer',
		descricaoOrdemDeMissao: 'Descrição da Ordem de Missão',
		descricaoOrdemMissaoExcluidoComSucesso: 'Descrição Ordem de Missão excluído corretamente.',
		descricaoOrdemMissaoSalvoComSucesso: 'Descrição Ordem de Missão salvo com sucesso.',
		descricaoProduto: 'Descrição do Produto',
		descricaoResumida: 'Descrição Resumida',
		descricaoServico: 'Descrição do Serviço',
		descricaoStatus: 'Status',
		descricaoTipoArmazenamento: 'Descrição Tipo Armazenamento',
		descricaoUnidadeCompra: 'Unidade de compra orçamentária',
		desdeOInicio: 'DESDE O INÍCIO DA OPERAÇÃO NO MÊS',
		desejaAdicionarAssinaturaPorLogin: 'Deseja adicionar assinatura por login',
		desejaAdicionarRecomendacao: 'Deseja adicionar alguma recomendação?',
		desejaAssinarEsseTrecho: 'Deseja Assinar esse trecho',
		desejaAtivarEsseUsuario: 'Deseja Ativar Esse Usuário?',
		desejaAtualizarTrecho: 'Deseja atualizar esse trecho?',
		desejaCancelarDiscrepancia: 'DESEJA CANCELAR ESSA DISCREPÂNCIA',
		desejaCancelarEssePedido: 'Deseja cancelar esse pedido',
		desejaCancelarPrevencao: 'Deseja CANCELAR essa prevenção?',
		desejaCancelarSolicitacao: 'Deseja cancelar essa solicitação?',
		desejaCancelarTicket: 'Deseja CANCELAR esse Ticket?',
		desejaConcluirDiscrepancia: 'DESEJA CONCLUIR ESSA DISCREPÂNCIA',
		desejaConcluirEssaDiscrepancia: ' Deseja concluir essa discrepância?',
		desejaConfirmarExclusaoNota: 'Deseja confirmar a exclusão dessa NFe',
		desejaConfirmarVerificacaoNota: 'Deseja confirmar a verificação dessa NFe',
		desejaContinuarAPrrencher: 'Você deseja continuar preenchendo este diário de bordo?',
		desejaDesativarEsseUsuario: 'Deseja Desativar Esse Usuário?',
		desejaEncerrarEssaOrdemDeMissao: 'Deseja encerrar essa ordem de missão?',
		desejaEncerrarEsseDespacho: 'Deseja encerrar esse despacho',
		desejaExcluir: 'Deseja excluir',
		desejaExcluirACarga: 'Deseja excluir a carga',
		desejaExcluirADocumentacao: 'Deseja excluir a documentação',
		desejaExcluirAcesso: 'Deseja excluir o acesso?',
		desejaExcluirCategoria: 'Deseja excluir categoria?',
		desejaExcluirClassificacao: 'Deseja Excluir essa Classificação?',
		desejaExcluirContexto: 'Deseja Excluir este Contexto Operativo?',
		desejaExcluirContrato: 'Deseja excluir este contrato?',
		desejaExcluirEmbalagem: 'Deseja excluir essa Embalagem?',
		desejaExcluirEmpenho: 'Deseja excluir esse empenho:',
		desejaExcluirEssaLeitura: 'Deseja excluir essa obrigatoriedade de leitura?',
		desejaExcluirEssaPermissao: 'Deseja mesmo excluir essa permissão ?',
		desejaExcluirEssaSolicitacao: 'Deseja excluir essa Solicitação?',
		desejaExcluirEsse: 'Deseja excluir esse',
		desejaExcluirEsseDespacho: 'Deseja Excluir esse Despacho?',
		desejaExcluirEsseDocumento: 'Deseja excluir esse documento?',
		desejaExcluirEsseEmpenho: 'Deseja excluir esse empenho',
		desejaExcluirEsseItem: 'Deseja excluir esse item',
		desejaExcluirEsseLayer: 'Deseja excluir esse layer ?',
		desejaExcluirEsseProcedimento: 'Deseja Excluir esse Procedimento?',
		desejaExcluirEsseProduto: 'Deseja excluir esse produto',
		desejaExcluirEsseProdutoServico: 'Deseja excluir esse produto/serviço',
		desejaExcluirEsseTipo: 'Deseja excluir esse Tipo?',
		desejaExcluirEsseTrecho: 'Deseja Excluir esse Trecho?',
		desejaExcluirFornecedor: 'Deseja excluir esse fornecedor?',
		desejaExcluirMalhaVoo: 'Deseja excluir essa Malha de Voo?',
		desejaExcluirOTipoDeSolicitacao: 'Deseja excluir o tipo de solicitação',
		desejaExcluirParametroLegais: 'Deseja Excluir esse Parâmetro Legal?',
		desejaExcluirPontoInteresse: 'Deseja excluir o ponto de interesse',
		desejaExcluirSubclassificacao: 'Deseja Excluir essa Subclassificação?',
		desejaExcluirUnidadeMedida: 'Deseja excluir essa Unidade de Medida ?',
		desejaFinalizarTrecho: 'Deseja finalizar esse trecho?',
		desejaGerarFatura: 'Deseja gerar uma fatura para essa fatura',
		desejaSelecionarvoo: 'Utilizar um modelo de voo da malha?',
		desejada: 'Desejada',
		desembarque: 'N° ATERRISSAGEM',
		desenvolvedorVejaOErroRetornadoPeloBackEnd: 'Desenvolvedor, veja o erro retornado pelo back-end',
		designativo: 'Designativo',
		desmarcarTodos: 'Desmarcar todos',
		desmarqueTrechosCarg: 'Desmarque os trechos que a carga não irá',
		desmarqueTrechosPass: 'Desmarque os trechos que o passageiro não irá',
		despacho: 'Despacho',
		despachoAeronaves: 'Despacho Aeronaves',
		despachoDeAeronaves: 'Despacho de Aeronaves',
		despachoEmergencial: 'Despacho Emergêncial',
		despachoExcluido: 'Despacho Excluído',
		despachoGerado: 'Programação gerada com sucesso',
		despachoReaberto: 'Despacho Reaberto.',
		despachoSalvo: 'Despacho Salvo',
		despachos: 'Despachos',
		despachosGerados: 'Despachos Gerado',
		destinatario: 'Destinatário',
		destinatarios: 'Destinatários',
		destino: 'Destino',
		destinoAproximado: 'Destino Aproximado',
		detalhar: 'Detalhar',
		detalhes: 'Detalhes',
		detalhesDaProgramacao: 'Detalhes da Programação',
		detalhesDoPagamento: 'DETALHE DO PAGAMENTO',
		detalhesDoProduto: 'Detalhes do Produto',
		determinacaoSessaoManutencao: 'Conforme determinação da seção de manutenção',
		deveConterMininoUm: 'Deve conter no mínimo 01',
		devolucaoPrevista: 'Devolução Prevista',
		devolvido: 'Devolvido',
		devolvidoEm: 'Devolvido em',
		diaAnterior: 'Dia Anterior',
		diagonal: 'Diagonal',
		diarias: 'Diárias',
		diario: 'Diário',
		diarioDeBordo: 'Diário de Bordo',
		diarioDeBordoMecanico: 'Diário de Bordo Mecânico',
		diarioDeBordoOperador: 'Diário de Bordo Operador',
		diariosDeBordoNaoAssinados: 'Diários de bordo não assinados',
		dias: 'dias',
		diasMaisComuns: 'Dia mais comum',
		diasRestantes: 'Dias Restantes',
		diferencaUTC: 'Diferença de UTC',
		digiteANovaAssinatura: 'Digite a nova assinatura no campo abaixo',
		digiteNovaSenhaAbaixo: 'Digite a nova senha no campo abaixo.',
		digiteOItemQueDesejaBuscar: 'Digite o item que deseja buscar',
		digiteParaBuscar: 'Digite para buscar',
		digiteParaRealizarUmaBuscaAvancada: 'Digite para realizar uma busca avançada',
		digiteSeuLogin: 'Digite o seu login.',
		digiteSuaAssinatura: 'Digite a sua assinatura',
		digiteSuaSenhaParaRenovala: 'Digite sua senha para renovar-la.',
		direcao: 'Direção',
		disciplina: 'Disciplina',
		disciplinaAtualizada: 'Disciplina atualizada',
		disciplinaInserida: 'Disciplina inserida',
		discrepancia: 'discrepância',
		discrepancia1: 'Discrepâncias',
		discrepanciaConcluida: 'Discrepância Concluída',
		discrepanciaSalva: 'Discrepância Salva',
		discrepancias: 'Discrepâncias',
		discrepanciasTecnicas: 'Discrepâncias Técnicas',
		discrepanciasVerificadas: 'Discrepâncias Verificadas',
		disponibilidade: 'Disponibilidade',
		disponibilizarAeronave: 'Disponibilizar Aeronave',
		disponivel: 'Disponível',
		disponivelNa: 'Disponível na',
		disponivelParaRetorno: 'Disponível para Retorno',
		distancia: 'Distância',
		distanciaCalculada: 'Distância Calculada',
		distanciaEmNM: 'Distância em NM',
		distanciaTotal: 'Distância Total',
		diurno: 'Diurno',
		divorciado: 'Divorciado(a)',
		doArtigo: 'DO ART. 4º DA RESOLUÇÃO 457',
		doContrato: 'do contrato',
		documentacao: 'Documentação',
		documentacaoExcluidaComSucesso: 'Documentação excluída com sucesso',
		documentacaoSalva: 'Documentação salva',
		documento: 'Documento',
		documentoExcluidoComSucesso: 'Documento excluido com sucesso.',
		documentoLeituraObrigatoria: 'Documentos de leitura obrigatória',
		documentoObrigatorioExiste: 'O documento obrigatório já existe no sistema',
		documentoS: 'Documentos',
		documentosArmazenados: 'Documentos Armazenados',
		documentoSalvoComSucesso: 'Documento salvo com sucesso.',
		documentos: 'Documento(s)',
		documentosSemDuplicidade: 'CPF e Passaporte são os únicos documentos que evitam cadastros duplicados',
		dois: 'Dois',
		dosUltimos: 'dos ultimos',
		asUltimas: 'as ultimas',
		download: 'Download',
		downloadAnexo: 'Download Anexo',
		dpoAlteraAtual: 'Altera Termo e DPO atual.',
		dpoAlterar: 'Altera DPO',
		dpoAssinarPolitica: 'Deseja solicitar que todos os usuários assinem obrigatoriamente a nova	política de privacidade, inclusive os usuários que já assinaram	anteriormente?',
		dpoCpf: 'CPF do DPO',
		dpoEmail: 'Email para contato com o DPO',
		dpoEndereco: 'Endereço para correspondência com DPO',
		dpoNome: 'Nome completo do DPO',
		dpoTelefone: ' Telefone de contato com o DPO',
		duplicar: 'Duplicar',
		duracao: 'Duração',
		duracaoPrevistaJornada: 'Duração prevista da jornada de trabalho',
		duracaoPrevistaVoo: 'Duração prevista do voo',
		e: 'e',
		eDestino: 'e Destino',
		eEstrangeiro: 'É estrangeiro',
		eImportanteFazerEsseProcedimento: 'É importante fazer esse procedimento antes que a aeronave comece a voar',
		eNecessario: 'É necessário gerar uma fatura',
		eOperador: 'é o operador',
		eUsuario: 'e Usuário',
		edicao: 'Edição',
		editadoMecanico: 'EDITADO MECÂNICO',
		editar: 'Editar',
		editarCapitulo: 'Editar Capítulo',
		editarCategoria: 'Editar Categoria',
		editarDiario: 'Editar Diario',
		editarHabilitacao: 'Editar habilitação',
		editarMalha: 'Editar malha',
		editarTrecho: 'Editar Trecho',
		editarUsuarioSimplificado: 'Editar Usuário Simplificado',
		editaveis: 'Editáveis',
		efetividade: 'Efetividade',
		em: 'Em',
		em2: 'em',
		emAberto: 'Em Aberto',
		emAnalise: 'Em análise',
		emAndamento: 'EM ANDAMENTO',
		emBrancoMantemAssinatura: 'Em branco mantém a mesma assinatura',
		emEstoque: 'Em estoque',
		emExecucao: 'Em execução',
		emExecucaoOuAberta: 'Em execução ou aberta',
		emExecucaoVencida: 'Em execução vencida',
		emHoras: 'em horas',
		emMeses: 'em Meses',
		emMesesDias: 'em Meses e Dias',
		emMonitoramento: 'Em monitoramento',
		emMovimento: 'Em movimento',
		emTolerancia: 'em tolerância',
		emUso: 'em uso',
		email: 'E-mail',
		emailAnac: 'E-mail ANAC',
		emailInvalido: 'E-mail inválido.',
		emailJaCadastrado: 'E-mail já cadastrado.',
		emailObrigatorio: 'E-mail obrigatório',
		embalagemExcluidaComSucesso: 'Embalagem excluída com sucesso.',
		embalagemJaCadastrada: 'Embalagem já cadastrada.',
		embarcou: 'Embarcou',
		embarque: 'Embarque',
		emergencia: 'Emergência',
		emergencial: 'Emergencial',
		emissao: 'Emissão',
		empenho: 'Empenho',
		empenhoExcluidoComSucesso: 'Empenho excluído com sucesso',
		empenhoSalvoComSucesso: 'Empenho salvo com sucesso',
		empenhos: 'Empenhos',
		empresa: 'Empresa',
		empresaEstrangeira: 'Empresa estrangeira',
		encaminharParaExecucao: 'Encaminhar a Ordem para execução',
		encerrada: 'Encerrada',
		encerramento: 'Encerramento',
		encerrar: 'Encerrar',
		encontrados: 'encontrados',
		end: 'Endereço',
		endereco: 'Endereço',
		enderecoFuncional: 'Endereço Funcional',
		enderecoResidencial: 'Endereço Residencial',
		enfermeiro: 'Enfermeiro',
		ensino: 'Ensino',
		ensinoInfantil: 'Educação infantil',
		ensinoSuperior: 'Ensino Superior (Graduação)',
		enterSalvaEscCancela: 'ENTER para salvar e ESC para cancelar',
		entrada: 'Entrada',
		entradaEfetuada: 'Entrada efetuada',
		entradaRegistrada: 'Entrada registrada',
		entreEmContatoConosco: 'Entre em contato conosco',
		entregar: 'Entregar',
		entregarSuprimentos: 'Entregar suprimentos',
		entregue: 'Entregue',
		enviaMensagem: 'Envia Mensagem',
		enviamosUmEmail: 'Enviamos email para você',
		enviando: 'Enviando',
		enviandoSuprimentos: 'Enviando suprimentos',
		enviar: 'Enviar',
		enviarArquivos: 'Enviar arquivos',
		enviarSolicitacao: 'Enviar Solicitação',
		envioNotificacoes: 'Envio de Notificações',
		envolvidos: 'Envolvidos',
		equipamento: 'Equipamento',
		equipamentoTrocado: 'Equipamento Trocado',
		equipamentos: 'Equipamentos',
		equipe: 'Equipe',
		equipeTitular: 'Equipe/Titular',
		erroAoNotificar: 'Erro ao notificar',
		erroConectarServidor: 'Erro ao conectar ao servidor.',
		erroDataOvn: 'Não é permitido relacionar este OVN à trecho anterior ao seu cadastro',
		erroHorimetro: 'Horímetro não preechido no cadastro de aeronave',
		erroVor: 'Erro(graus)',
		esclero: 'Esclero',
		escola: 'Escola',
		escolaDeVoo: 'Escola de Voo',
		escolaridade: 'Escolaridade',
		escolha: 'Escolha',
		escolhaAFuncaoTripulante: 'Escolha a função desse tripulante',
		escolhaAOrigem: 'Escolha a origem',
		escolhaData: 'Escolha uma data',
		escolhaOMotivoCancelamentoOrdem: 'Escolha o motivo para cancelar a solicitação',
		escolhaOpcao: 'Escolha uma Probabilidade e uma Severidade',
		escolhaOpcaoAbaixo: 'Escolha uma ação abaixo',
		escolhaPeloMenosUmTrecho: 'Escolha pelo menos um trecho por passageiro',
		escolhaPeloMenosUmTrechoCarga: 'Escolha pelo menos um trecho por carga',
		escolhaProbabilidade: 'Escolha uma Probilidade',
		escolhaSeveridade: 'Escolha uma Severidade',
		escolhaUmEmpenhoParaOCampoValorSerLiberado: 'Escolha um empenho para o campo valor ser liberado',
		escolhaUmTrechoParaCopiar: 'Escolha um trecho para você copiar.',
		escolhaUmaAcao: 'Escolha uma ação acima.',
		escolhaUmaClassificacaoPara: 'Escolha uma classificação<br>para exibir a lista.',
		escolhaUmaOpcao: 'Escolha uma opção',
		escolhaUmaOpcaoAbaixo: 'Escolha uma opção abaixo.',
		escolhaUmaOpcaoAoLado: 'Escolha uma opção no menu ao lado.',
		escolhaUmaTabelaDoBancoDeDadosNaLista: 'Escolha uma tabela do banco de dados na lista',
		escolhaaTurma: 'Escolha a turma',
		escolhaoAluno: 'Escolha o aluno',
		escolhaoTreinamento: 'Escolha o treinamento',
		escolherItemAcima: 'Você tem que escolher um ou mais itens acima.',
		esconderConcluidos: 'Esconder Concluídas',
		esconderDetalhes: 'Esconder detalhes',
		esconderItens: 'Esconder itens',
		escritorio: 'Escritório',
		esfera: 'Esfera',
		espacoEmDisco: 'Espaço em Disco',
		espacoEmDiscoUtilizado: 'Espaço em Disco Utilizado',
		especial: 'Especial',
		especieOuTipo: 'Espécie / Tipo',
		esqueceuSuaSenha: 'Esqueceu sua senha?',
		esqueciMinhaSenha: 'Esqueci minha senha',
		essaDocumentacaoTemValidade: 'Essa documentação tem validade',
		essaOrdem: 'Essa Ordem',
		essaOrdemNaoPossui: 'Essa ordem NÃO POSSUI assinatura',
		essaOrdemPossui: 'Essa ordem POSSUI assinatura',
		essaSolicitaoTemAvalManutencao: 'Essa solicitação tem o parecer da Manutenção?',
		essaSolicitaoTemOaval: 'Essa solicitação tem o parecer da Operação?',
		esseCampoObrigatorio: 'Esse campo é obrigatório',
		esseDiarioDeBordoNaoEstaIntegroEntreEmContatoComOSuporte: 'Esse diário de bordo não está íntegro, entre em contato com o suporte.',
		esseGrupoExige: 'Esse grupo exige a assinatura do inspetor',
		esseMes: 'Esse Mês',
		esseTrechoNaoPodeSerPreenchido: 'Esse trecho não pode ser preenchido agora',
		essesDados: 'Esses dados',
		estaExibindo: 'está exibindo',
		estaPreenchendoUmDiarioDeBordo: 'está preenchendo um diário para essa aeronave.',
		estado: 'Estado',
		estadoCivil: 'Estado Civíl',
		estadoDeVerificacao: 'Estado de Verificação',
		estadoDoItem: 'Estado do item',
		estagiario: 'Estagiário',
		estavaAtualizado: 'Estava atualizado',
		esteCampoEObrigatorio: 'Este campo é obrigatório',
		estePerfilEhTripulante: 'Este perfil é tripulante',
		estoque: 'Estoque',
		estoqueDisponivelSuprimentos: 'Disponíveis: NOVO, USADO, REPARADO E OVERHAUL',
		estoqueQuantidadeMinima: 'Quantidade mínima do produto no estoque.',
		estoqueTotalSuprimentos: 'Estoque total, incluindo DESCARTADO E DEFEITUOSO',
		estoqueUnidadeMedida: 'Estoque - Unidades de Medida',
		estouCiente: 'Estou ciente',
		estouCienteQuanto: 'ESTOU CIENTE QUANTO AS INFORMAÇÕES QUE TRATAM OS',
		etiqueta: 'Etiqueta',
		evento: 'Evento',
		excelParaCompra: 'Excel para compra',
		excelente: 'EXCELENTE',
		excluida: 'Excluída',
		excluidoComSucesso: 'Excluído com sucesso.',
		excluindo: 'Excluindo',
		excluir: 'Excluir',
		excluirAtualizacao: 'Excluir Atualização',
		excluirContrato: 'Excluir Contrato',
		excluirFatura: 'EXCLUIR FATURA',
		excluirFoto: 'Excluir Foto',
		excluirImagem: 'Excluir Imagem',
		excluirLicenca: 'Deseja excluir essa licença?',
		excluirPontoInteresse: 'Excluir ponto de interesse',
		excluirProcedimento: 'Excluir Procedimento',
		excluirUsuario: 'Excluindo usuário',
		exclusaoLeitores: 'Exclusao Leitores Obrigatórios',
		execucao: 'Execução',
		execucaoSalva: 'Execucao salva com sucesso',
		executado: 'Executado',
		exercicio: 'EXERCÍCIO',
		exercicios: 'Exercícios',
		exibeAnuncio: 'Exibe Anúncios',
		exibicao: 'Exibição',
		exibir: 'Exibir',
		exibirConcluidos: 'Exibir Concluídas',
		exibirDadosDiarioBordo: 'Os dados serão preenchidos apos o preenchimento do número de CE e aeronave de acordo com diaro de bordo',
		exibirDesativados: 'Exibir Desativados',
		exibirEncerradas: 'Exibir Encerradas',
		exibirLegendas: 'Exibir Legendas',
		exibirTodas: 'Exibir Todos',
		exigirPolitica: 'Exigir que todo usuário assine digitalmente a Política de Privacidade em seu primeiro acesso.',
		existemCampoDaAeroASerem: 'Existem campos a serem preenchidos na(s) aeronave(s) empregada(s).',
		experienciaRecente: 'Experiência Recente - Últimos 90 dias',
		experienciaTotal: 'Experiência Total',
		exportacaoDados: 'Exportação de Dados',
		exportar: 'Exportar',
		exportarJSON: 'Exportar JSON',
		extrato: 'Extrato',
		extratoDiarioDeBordo: 'Extrato Diário de Bordo',
		extremamenteImprovavel: 'Extremamente Improvável',
		fabricacao: 'Fabricação',
		fabricante: 'Fabricante',
		fabricanteAtualizado: 'Fabricante atualizado',
		fabricanteInserido: 'Fabricante salvo',
		faltaPagar: 'Falta pagar',
		farol: 'Farol',
		fatorContribuinte: 'Fator Contribuinte',
		fatura: 'FATURA',
		faturaEmAberto: 'FATURA EM ABERTO',
		faturaFechadaPor: 'FATURA FECHADA POR',
		faturaSBH: 'Fatura SBH',
		faturas: 'FATURAS',
		favorPreencherCamposEmVermelho: 'Favor preencher o(s) campo(s) em vermelho!',
		fechaExercicio: 'FECHAR EXERCÍCIO',
		fechado: 'Fechado',
		fechar: 'Fechar',
		fecharDadosDaAeronave: 'Fechar dados da aeronave',
		fecharOrdemDeMissao: 'Concluir a ordem de missão',
		fem: 'Feminino',
		fichaCadastralFuncional: 'Ficha Cadastral Funcional',
		figado: 'Fígado',
		filtrar: 'Filtrar',
		filtrarPorNome: 'Filtrar Posições',
		filtro: 'Filtros',
		filtroPor: 'Filtro por:',
		fim: 'Fim',
		final: 'Final',
		finalidade: 'Finalidade',
		finalizadoPor: 'Finalizado por:',
		finalizar: 'Finalizar',
		finalizarOrdemDeServico: 'Finalizar Ordem de Serviço',
		finalizarTracho: 'Finalizar Trecho',
		foiAtivado: 'Foi ativado',
		foiGeradoUmCodigo: 'Foi gerada uma ordem de missão com código',
		foiPressionado: 'Foi Pressionado',
		forcarAssinarTermo: 'Forçar assinar termo?',
		forma: 'Forma',
		formaDePagamento: 'Forma de Pagamento',
		formularioBloqueado: 'O formulário será bloqueado para edições',
		fornecedor: 'Fornecedor',
		fornecedorCombustivel: 'Fornecedor de Combustível',
		fornecedores: 'Fornecedores',
		foto: 'Foto',
		fragil: 'Fragil',
		frequencia: 'Frequência',
		frequente: 'Frequente',
		funcao: 'Função',
		funcaoABordo: 'Função A Bordo',
		funcaoComoTripulante: 'Função como Tripulante',
		funcaoNaEmpresa: 'Função na Empresa',
		funcoes: 'Funções',
		fuso: 'Fuso',
		fusoHorario: 'Fuso Horário',
		galao: 'Galão',
		gancho: 'Gancho',
		ganchos: 'Ganchos',
		gerais: 'Gerais',
		geral: 'Geral',
		gerando: 'Gerando',
		gerandoDespacho: 'Gerando despacho da semana',
		gerandoRelatorio: 'Gerando Relatório',
		gerandoRelatorioDemorar: 'Gerando Relatório (isso pode demorar um pouco)',
		gerar: 'Gerar',
		gerarDespacho: 'Gerar despacho',
		gerarDespachoAvulso: 'Gerar despacho avulso',
		gerarDespachoSemana: 'Gerar despacho da semana',
		gerarDiarioBordo: 'Gerar diário de bordo',
		gerarExcel: 'Gerar Excel',
		gerarFatura: 'Gerar Fatura',
		gerarMapa: 'Gerar Mapa',
		gerarNotas: 'Gerar Notas',
		gerarOrdem: 'Gerar Ordem',
		gerarOrdemDeServico: 'Gerar Ordem de Serviço?',
		gerarOrdemMissao: 'Gerar Ordem Missão',
		gerarOrdemServico: 'Gerar Ordem de Serviço',
		gerarPrevencao: 'Gerar Prevenção',
		gerarProgramacaoDeVoo: 'Gerar programação de voo',
		gerarProgramacaoVoo: 'Gerar programação',
		gerarRelatorio: 'Gerar relatório',
		gerenciamentoDeRisco: 'Gerenciamento de risco',
		gerenciamentoDeRiscoRecomendacao: 'Gerenciamento de Risco Recomendação',
		gerenciamentoTrecho: 'Gerenciamento de Trecho',
		gerenciamentoVoo: 'Gerenciamento de Voo',
		gestao: 'Gestão',
		gestaoAbastecimento: 'Gestão Abastecimento',
		gestaoAeronave: 'Gestão de Aeronave',
		gestaoDe: 'Gestão de',
		gestaoDeContratos: 'Gestão de Contratos',
		gestaoDeMalha: 'Gestão de Malhas',
		gestaoInterna: 'Gestão Interna',
		gestaoLayer: 'Gestão de Layers',
		graficos: 'Gráficos',
		grau: 'Grau',
		grauDeRelacionamento: 'Grau de Relacionamento',
		graus: 'Graus',
		grupo: 'Grupo',
		grupoDePassageiro: 'Grupo de Passageiros',
		grupoDePassageiroSalvoComSucesso: 'Grupo de Passageiros salvo com sucesso.',
		grupoDePassageiros: 'Grupo de Passageiros',
		grupoDePassageirosAtualizadoComSucesso: 'Grupo de Passageiros atualizado com sucesso.',
		grupoDePassageirosExcluidoComSucesso: 'Grupo de Passageiros excluído com sucesso',
		grupoDePassageirosSalvoComSucesso: 'Grupo de Passageiros salvo com sucesso.',
		grupoOrgaos: 'Grupo de Orgãos',
		grupos: 'Grupos',
		guarnicao: 'Guarnição',
		guincho: 'Guincho',
		hAssinatura: 'Assinatura',
		hNotificacao: 'Notificações',
		haCargaASerTransportada: 'Há carga a ser transportada?',
		haContextoOperativo: 'Há contexto operativo?',
		haNecessidadeDeAbastecimento: 'Há necessidade de reabastecimento?',
		haNecessidadeDeAlmoco: 'Almoço',
		haNecessidadeDeCafeManha: 'Café da Manhã',
		haNecessidadeDeDiarias: 'Há necessidade de empenho de diárias?',
		haNecessidadeDeJantar: 'Jantar',
		haPassageiros: 'Há Passageiros?',
		haResalvasNaSituacao: 'Há resalvas na situação?',
		habilitaCamp: 'Quando você habilita a manutenção no CAMP, é necessário dar a primeira carga nas inspeções e tarefas já feitas, feito isso, é necessário colocar a data início dessa carga, a partir desse dia, se tiver diários de bordo preenchido e/ou cargas de atualização, o sistema vai atualizar os tempos da aeronave e dos componentes que estão ligado a ela',
		habilitacao: 'Habilitação',
		habilitacaoExcluido: 'Habilitação removida com sucesso',
		habilitado: 'habilitado',
		habilitar: 'Habilitar',
		habilitarCargasEmTempos: 'Habilitar carga de tempos',
		habilitarContrato: 'Habilitar Contrato',
		habilitarContratoConfirmacao: 'Deseja realmente habilitar este contrato?',
		habilitarInspecao: 'Habilitar Inspeção',
		haviamCargasPerigosas: 'Haviam cargas perigosas?',
		helicopteros: 'Helicópteros',
		historico: 'Histórico',
		historicoAcesso: 'Histórico Acesso',
		historicoAtualizacoesDocumento: 'Histórico Atualizações do Documento',
		historicoDoEmpenho: 'Histórico do Empenho',
		historicoSistema: 'Histórico do Sistema',
		historicoVoo: 'Histórico de',
		homeHora: 'Homem/Hora',
		hora: 'Hora',
		horaFinal: 'Hor. Final',
		horaInicial: 'Hor. Inicial',
		horario: 'Horário',
		horarioApresentacaoTripulacao: 'Horário de Apresentação da Tripulação',
		horarioMaisComum: 'Horário mais comum',
		horarioPrevisto: 'Horário previsto',
		horariosMaisComuns: 'Horários mais comuns',
		horas: 'Horas',
		horasAcionamentoCorte: 'Horas de Acionamento ao Corte',
		horasCelulaProximaInspecao: 'Horas Célula Próx. Inspeção',
		horasDeCelulaParaAProxima: 'Horas de célula previstas para a próxima intervenção',
		horasDeUtilizacao: 'Horas de Utilização',
		horasDeVooApoio: 'Horas de Voo em Apoio',
		horasDecolagemPouso: 'Horas de Decolagem ao Pouso',
		horasDisponiveis: 'Horas Disponíveis',
		horasDisponivel: 'Tempo Disponível',
		horasECiclosDoMes: 'Horas e ciclos do mês',
		horasOvnAntesDb: 'Horas do OVN antes do preenchimento do primeiro Diário de Bordo',
		horasPilotoComandoInstrucao: 'As horas de Piloto em Comando contemplam também as horas como Piloto em Instrução.',
		horasTotais: 'Horas Totais',
		horasUsoDecimal: 'Horas de Uso (Decimal)',
		horasVoadas: 'Horas Voadas',
		horasVoadasAbreviacao: 'HV',
		horasVoadasSemanal: 'Horas Voadas semanal',
		horasVoo: 'Horas de Voo',
		horasVooPrimeiroPilotoComando: 'Horas de Voo Primeiro Piloto Comando',
		horasVooSegundoPilotoComando: 'Horas de Voo Segundo Piloto Comando',
		horasVooTripulacao: 'Horas de Voo Tripulação',
		horasVooUsuarioOvn: 'Horas de Voo com OVN',
		horimetro: 'Horímetro',
		horimetroCelula: 'Horímetro Célula',
		horimetroFinal: 'Hor. Final',
		horimetroFinalCelula: 'Hor. Final Célula',
		horimetroFinalManutencao: 'Hm. Manutenção Final',
		horimetroFinalMotor: 'Horimetro Final Motor',
		horimetroInicial: 'Hor. Inicial',
		horimetroInicialCelula: 'Hor. Ínicial Célula',
		horimetroInicialManutencao: 'Hm. Manutenção Inicial',
		horimetroInicialMotor: 'Horimetro Inicial Motor',
		horimetroInicialOvn: 'Horas inicial do OVN',
		horimetroManutencao: 'Horímetro Manutenção',
		horimetroMotor: 'Horímetro Motor',
		horimetroProximaInspecao: 'Horimetro próxima inspeção',
		horimetroUltimaInspecao: 'Horimetro última inspeção',
		houveAcionamentoDosOrgaos: 'Houve acionamento dos orgãos externos componentes do ',
		houveAlijamento: 'Houve alijamento de emergência ou inadvertido de artigos perigosos?',
		houveCargaTransportada: 'Houve carga transportada?',
		houveUmErroAoTentarAcessarOSeguinteEnderecoURL: 'Houve um erro ao tentar acessar o seguinte endereço URL',
		houveUmErroAoTentarSalvar: 'Houve um erro ao tentar salvar',
		icone: 'Ícone',
		id: 'Id',
		idade: 'Idade',
		idadeAparente: 'Idade Aparente',
		identificacaoVoo: 'Identificação do Voo',
		imagem: 'Imagem',
		imagensCadastradas: 'Imagens Cadastradas',
		importar: 'Importar',
		importarLayer: 'Importar Layer',
		imprimir: 'Imprimir',
		imprimirEtiqueta: 'Imprimir Etiqueta',
		imprimirPDF: 'Imprimir PDF',
		imprimirRequisicao: 'Imprimir requisição',
		improvavel: 'Improvável',
		inaceitavel: 'Inaceitável sob as circustâncias existentes',
		inativo: 'Inativo',
		incidenciaFatores: 'Incidência de fatores contribuintes',
		incisoss: 'INCISOS XIII A XVII',
		incluir: 'Incluir',
		incluirLer: 'Incluir + Ler',
		inclusao: 'Inclusão',
		inclusaoAnalise: 'Analise inicial do evento',
		inclusaoAnexar: 'Anexar arquivos',
		inclusaoApreciacaoDevem: 'Inclusão e apreciação devem estar concluídas',
		inclusaoDescricao: 'Descrição do evento de segurança operacional',
		inclusaoDeve: 'Inclusão deve estar concluída',
		inclusaoInformacao: 'Informações adicionais',
		inclusaoRecomendacoes: 'Parecer e recomendações',
		inclusaoSalva: 'Inclusão salva com sucesso',
		indeterminada: 'Indeterminada',
		indicador: 'Indicador',
		indicadorAno: 'Indicador Ano',
		indicadorMes: 'Indicador Mês',
		indiceDocumento: 'Índice por Tipo Documento',
		indiceNomeDocumento: 'Índice de Documentos',
		indicePorDocumento: 'Índice por nome',
		indisponibilidadeAeronave: 'Indisponibilidade de aeronave',
		indisponibilidadeEfetivo: 'Indisponibilidade de efetivo',
		indisponibilizarAeronave: 'Indisponibilizar Aeronave',
		indisponivel: 'Indisponível',
		info: 'Informação',
		infoHorasOvn: 'Preencha este campo com as horas totais de voo que já realizou utilizando OVN. Após esse preenchimento, o sistema automaticamente somará este valor inicial com as horas de voo do diário de bordo',
		infoOrdemDeMissao: 'Informações da Ordem de Missão',
		informacaoDoPonto: 'Informações do Ponto',
		informacaovoo: 'Informações do Voo',
		informacoesAdicionais: 'Informações Adicionais',
		informacoesAdicionaisProduto: 'Informações Adicionais do Produto',
		informacoesIniciais: 'Informações Iniciais',
		inicial: 'Inicial',
		inicio: 'Início',
		inicioCargaOpcao: 'Quando você habilita a manutenção no followair, é necessário dar a primeira carga nas inspeções e tarefas já feitas, feito isso, é necessário colocar a data início dessa carga, a partir desse dia, se tiver diários de bordo preenchido e/ou cargas de atualização, o sistema vai atualizar os tempos da aeronave e dos componentes que estão ligado a ela.',
		inicioDaOrdem: 'Início da Ordem',
		inicioDoMesReferencia: 'início do mês de referência',
		inicioOrdem: 'Início da Ordem',
		inicioSBH: 'Início SBH',
		inicioValidade: 'Início de validade da política',
		inpecoesAssinadas: 'Inspeção(ões) Assinada(s).',
		inscricao: 'Inscrição',
		inseridoManualmentePor: 'Inserido manualmente por',
		inseridoPor: 'Inserido por:',
		insignificante: 'Insignificante',
		insiraCaso: 'ou insira uma caso não tenha',
		inspecao: 'Inspeção',
		inspecaoAdicionadaComSucesso: 'Inspeção adicionado com sucesso',
		inspecaoAtiva: 'Inspeção Ativa',
		inspecaoDesativada: 'Inspeção Desativada',
		inspecaoEmMeses: 'Próxima inspeção em meses',
		inspecaoExcluidaComSucesso: 'Inspeção excluída com sucesso',
		inspecaoListadas: 'As inspeções listadas não contem componentes atrelados a mesma',
		inspecaoVinculada: 'Inspeção Vinculada',
		inspecoes: 'Inspeções',
		inspecoesMandatorias: 'Inspeções Mandatórias',
		inspecoesNaoMandatorias: 'Inspeções Não Mandatórias',
		inspetor: 'Inspetor',
		inspetorResponsavel: 'Inspetor Responsável',
		instalacao: 'Instalação',
		instalar: 'Instalar',
		instrucao: 'Instrução',
		instrumentos: 'Instrumentos',
		instrutor: 'Instrutor',
		instrutorVoo: 'Instrutor de Voo',
		instruçãoDemissao: 'INSTRUÇÃO DE MISSÃO',
		interacaoSalva: 'Interação salva',
		intercambialidade: 'Intercambialidade',
		intercambiaveisAdicionadas: 'Intercambiáveis adicionadas',
		intervalo: 'Intervalo',
		intervaloServico: 'Intervalo de Serviço',
		inverter: 'Inverter',
		irParaA: 'Ir para a',
		irParaO: 'IR PARA O',
		irParaOrdemDeMissao: 'Ir para a ordem de missão',
		irParaOrdemServico: 'Ir para a ordem de serviço',
		item: 'item',
		itemAtualizado: 'Item atualizado',
		itemJaAdicionado: 'Item já adicionado',
		itens: 'Itens',
		itensComOEstadoDefeituosoOuDescarteNaoEstaoDisponiveisParaEntrega: 'Itens com o estado DEFEITUOSO ou DESCARTE não estão disponíveis para entrega',
		itensIntercambiaveis: 'Itens intercambiáveis',
		itensParaAeronave: 'Itens para aeronave',
		jaExiste: 'Já existe.',
		jantar: 'Jantar',
		jivochat: 'Jivochat',
		jornadaDeTrabalho: 'Jornada de Trabalho',
		jornadaMensal: 'Jornada Mensal',
		jornadaSemanal: 'Jornada Semanais',
		jornadaTrabalho: 'Jornada Trabalho',
		jornadaTrabalhoCumprida: 'Jornada Trabalho Cumprida',
		juntadoTrechos: 'Juntando trechos',
		justificativa: 'Justificativa',
		justificativaInspecao: 'essa inspeção é necessário uma justificativa',
		kitComissaria: 'Kit de Comissaria',
		kmAtual: 'Km Atual',
		kmVoado: 'Km Voado',
		labelQuantidadeCaracteres: 'Quantidade da caracteres restantes',
		largura: 'Largura',
		lat: 'lat',
		latInicio: 'Lat Inicio',
		latitude: 'Latitude',
		latitudeFinal: 'Latitude Final',
		latitudeInicial: 'Latitude Inicial',
		lavagemCompressor: 'Lavagem de Compressor',
		layer: 'Layer',
		layerAtualizadoSucesso: 'Layer Atualizado com sucesso!',
		layerCadastradoSucesso: 'Layer Cadastrado com sucesso!',
		layerExcluidoSucesso: 'Layer Excluido com sucesso!',
		legislacao: 'Legislação',
		lei: 'Lei',
		leiAeronauta: 'Lei Aeronauta',
		leiaAOrdem: 'Leia sua ordem e no final clique em "ATUALIZAR ORDEM".',
		leiaQRCode: 'Leia o QR Code através do Followair em seu telefone.',
		leiaSuaSolicitacao: 'Leia sua solicitação e no final clique em "ENVIAR SOLICITAÇÃO".',
		leitores: 'Leitores',
		leituraConfirmada: 'Leitura Confirmada',
		leituraExcluida: 'Leitura Obrigatória excluída.',
		leituraObrigatoria: 'Leitura Obrigatória',
		leituraObrigatoriaUsuario: 'Leitura obrigatória para o usuário atual',
		ler: 'Ler',
		letra: 'Letra',
		lgpd: 'LGPD e Política de Privacidade',
		lgpdPoliticaPrivacidade: 'Política de Privacidade e LGPD',
		lgpdTermo: 'A contratante deverá conforme rege a LGPF, nomear um Encarregado de Proteção de Dados Pessoais (Data Protection Officer - DPO) e divulgar publicamente sua identidade e informações de contato, de maneira clara e objetiva. Essa pessoa será o canal de comunicação entra o contorlador, os titulares de dados e a Autoridade Nacional de Proteção de Dados (ANPD), e será responsável por receber e responder as requisições e reclamações dos titulares dos dados pessoais tratados pela empresa. Estas informações deverão ser adicionadas abaixo.',
		liberadoParaConhecimentoGeral: 'Liberado para conhecimento Geral',
		libras: 'Libras',
		licenca: 'Licença',
		licencaExcluida: 'Licença excluida',
		licencasHabilitacoesRegistros: 'Licenças, Habilitações e Registros',
		lido: 'Lido',
		lidoPor: 'Lido por',
		limite: 'Limite',
		limiteReferencia: 'Limite Referência',
		limitesContratuais: 'Limites Contratuais',
		limpaTudas: 'Limpar Todas',
		limpar: 'Limpar',
		limparFiltro: 'Limpar Filtro',
		linhaContrato: 'Linha Contrato',
		linhaDoContrato: 'Linha do Contrato',
		linkAPP: 'Link App',
		linkBD: ' Link Banco de Dados',
		linkTrello: 'Link para o Trello',
		linkWS: 'Link WS',
		links: 'Links',
		liquida: 'Líquida',
		lista: 'lista',
		listaContratosNaoOcultos: 'Essa lista se refere aos contratos não ocultos',
		listaContratosOcultos: 'Essa lista se refere aos contratos ocultos',
		listaDePerfis: 'Lista de Perfis',
		listaNFS: 'Lista NFe',
		listarNovosUsuarios: 'Listar Novos Usuários',
		litros: 'Litros',
		lng: 'lng',
		local: 'Local',
		localDeNascimento: 'Local de Nascimento',
		localisacaoPorao: 'Localização porão',
		localizacao: 'Localização',
		logAcessos: 'Log de Acessos',
		logProcessamento: 'Log de Processamento',
		login: 'Login',
		loginAs: 'Login às',
		loginComoLogin: 'O LOGIN cadastrado será usado como SENHA, que deverá ser alterada no primeiro acesso ao sistema.',
		loginsHoje: 'Logins realizados hoje',
		logitudeFinal: 'Longitude Final',
		logitudeInicial: 'Longitude Inicial',
		logo: 'Logo do cliente',
		logradouro: 'Logradouro',
		longInicio: 'Long Inicio',
		longitude: 'Longitude',
		lotacao: 'Lotação',
		lote: 'Lote',
		maintenanceStatus: 'Mapa',
		maior: 'Maior',
		maiorValor: 'Maior que o valor.',
		maisDeumDespacho: 'Encontramos mais de um despacho para essa aeronave, selecione qual despacho esse voo se refere.',
		maisDeumItem: 'mais de um item',
		maisDias: 'mais dias',
		maisInformacoes: 'Mais Informações',
		malha: 'Malha',
		malhaAnual: 'Malha anual',
		malhaSemanal: 'Malha semanal',
		malhaVoo: 'Malha Voo',
		malhas: 'Malhas',
		manuais: 'Manuais',
		manual: 'Manual',
		manualOnline: 'Manual Online',
		manutencao: 'Manutenção',
		manutencaoAeronave: 'Manutenção Aeronave',
		manutencaoAtrasada: 'Manutenção Atrasada',
		manutencaoCamp: 'Manutenção CAMP',
		manutencaoCiencia: 'Modal de manutenção em Ciências',
		manutencaoDeuParecer: 'Tem o parecer da manutenção',
		manutencaoNaoDeuParecer: 'A manutenção não deu parecer',
		manutencoes: 'Manutenções',
		mapa: 'Mapa',
		marcaDagua: 'Marca d\'água',
		marcaOuModelo: 'Marca / Modelo',
		marcadores: 'Marcadores',
		marcarTodos: 'Marcar todos',
		margem: 'margem',
		margemTelaLogin: 'Margem da tela de Login em pixels',
		marqueOsTrechosQueACargaIra: 'Marque os trechos que o passageiro ira',
		marqueOsTrechosQueOPassageiroIra: 'Marque os trechos que o passageiro irá:',
		masc: 'Masculino',
		materiaEncerrada: 'Matéria fechada por',
		materias: 'Materias',
		matricula: 'Matrícula',
		matriculado: 'Matriculado',
		maximo: 'Máximo',
		mecanico: 'Mecânico',
		mecanicoResponsavel: 'Mecânico Responsável',
		mecanicos: 'Mecânico',
		media: 'Media',
		mediaCiclos: 'Média Ciclos',
		mediaHorasDiario: 'Média de horas voadas diária',
		mediaHorasMes: 'Média de horas voadas mensal',
		mediaManual: 'Média Manual',
		medicao: 'Medição',
		medico: 'Médico',
		menor: 'Menor',
		mensagem: 'Mensagem',
		mes: 'Mês',
		mesAtual: 'Mês Atual',
		meses: 'Meses',
		mesesDias: 'Meses e Dias',
		mesmoDbMovimentacoes: 'Foram encontrados estes diário de bordo abaixo para este número de CE e esta aeronave. Selecione o diário de bordo referente a está movimentação',
		mesmoMovimentacoesDb: 'Foram encontrados movimentações de combustível abaixo para este número de CE e esta aeronave. Selecione a movimentação de combustível referente a este diário de bordo',
		messagemInputError: 'Valor inválido!',
		meta: 'Meta',
		metaAno: 'Meta Ano',
		metaHoras: 'Meta Horas',
		metaIndicadores: 'Meta e Indicadores',
		metaMes: 'Meta Mês',
		metricas: 'Métricas',
		milhas: 'Milhas',
		milhasNauticas: 'Milhas Náuticas',
		minutos: 'Minutos',
		missao: 'Missão',
		missaoESigilosa: 'Missão é sigilosa ?',
		missaoSigilosa: 'Missão sigilosa',
		modalErroElementoJaInserido: 'Elemento já inserido na tabela.',
		modelo: 'Modelo',
		modeloAtualizado: 'Modelo atualizado',
		modeloDoMapa: 'Modelo do Mapa',
		modeloInserido: 'Modelo salvo',
		modelos: 'Modelos',
		modelosAtualizados: 'Modelos atualizados',
		modulo: 'Escolha o módulo que você deseja acessar',
		moduloManutencao: 'Módulo de Manutenção',
		modulos: 'Modulos',
		moeda: 'Moeda',
		monitora: 'Monitora',
		monitorada: 'Monitorada',
		monitoramento: 'Monitoramento',
		monitoramento1: 'Carta de Situação',
		mostrarDetalhes: 'Mostrar detalhes',
		mostrarItens: 'Mostrar itens',
		motivacao: 'Motivação',
		motivo: 'Motivo',
		motivoApareceraDiario: 'Esse motivo aparecerá na assinatura desse diário de bordo',
		motivoDaEdicao: 'Motivo da edição',
		motivoNaoEmbarcou: 'Motivo por não embarcar',
		motivoNaoEmbarque: 'Cadastro Motivos Não Embarque',
		motivoReassinatura: 'MOTIVO DA REASSINATURA',
		motor: 'Motor',
		motorAdicionado: 'Motor Adicionado',
		motorAtualizado: 'Motor Atualizado',
		motorEHorario: 'Motor e Horário',
		motores: 'Motores',
		movimentacao: 'Movimentação',
		movimentacaoCombustivel: 'Movimentação de Combustível',
		movimentacaoCombustivelAbaixo: 'a movimentação de combustivel abaixo',
		movimentacaoCombustivelEntreUnidades: 'Movimentação Combustivel entre Unidades',
		movimentacaoCombustivelEntreUnidadesSucesso: 'Movimentação Combustivel entre Unidades Salvo com Sucesso',
		movimentacaoDeCombustivelExcluidaComSucesso: 'Movimentação de combustível excluída com sucesso',
		msgPagamentoMaiorPagamento: 'Você está adicionando um valor maior que a compra.',
		mudancaFuncao: 'Mudança de Função',
		mudarMoeda: 'Moeda',
		multicamadasMapa: 'Multicamadas sobre mapa',
		municipio: 'Município',
		nOrdem: 'Nº da Ordem',
		nSolicitacao: 'Nº da Solicitação',
		nacionalidade: 'Nacionalidade',
		nao: 'Não',
		naoAprovado: 'Não aprovado',
		naoAssinados: 'Não Assinado',
		naoCalculado: 'Não Calculado',
		naoControlado: 'Não Controlado',
		naoDefinido: 'Não definido',
		naoDocumento: 'Não há anexo de documento disponível.',
		naoEPossivelColocarUmValorQueEstaAbaixoDoTotalDeProdutosServicos: 'Não é possível colocar um valor que está abaixo do total de produtos/serviços',
		naoEPossivelEscolherUmaQuantidadeMaiorQueADisponivelNoEstoque: 'Não é possível escolher uma quantidade maior que a disponível no estoque',
		naoEPossivelRemoverUmEmpenhoQueHaProdutosServicosVinculados: 'Não é possível remover um empenho que há produtos/serviços vinculados',
		naoEncontramosSuaAero: 'Não encontramos essa aeronave dentro da ordem de missão, caso queria importar os dados da aeronave(s) da ordem de missão, basta clicar no modelo abaixo.',
		naoExecutado: 'Não executado',
		naoExisteDespachoAvulso: 'Não foi encontrado nenhum programação de voo avulso',
		naoExisteFatoresContribuintesParaOObjetoEscolhido: 'Não existe fatores contribuintes para o objeto escolhido',
		naoExisteNenhumParecerParaEsteRelatorio: 'Não existe nenhum parecer para este relatório',
		naoFoiPossivelAlterarSenha: 'Não foi possível alterar a senha.',
		naoFoiPossivelAssinar: 'Não foi possível assinar',
		naoFoiPossivelAssinarOS: 'Não foi possível assinar Ordem de Serviço',
		naoFoiPossivelCadastrarUsuario: 'Não foi possível cadastrar Usuario',
		naoFoiPossivelCancelar: 'Não foi possível cancelar',
		naoFoiPossivelEncontrarDados: 'Não foi encontrado nenhum dado através deste login.',
		naoFoiPossivelEnviarSuprimentos: 'Não foi possivel enviar suprimentos',
		naoFoiPossivelExcluir: 'Não foi possível excluir',
		naoFoiPossivelGerarRelatorio: 'Não foi possível gerar Relatório',
		naoHaAeronaves: 'Não há aeronaves',
		naoHaCarga: 'Não há carga',
		naoHaDiariosDeBordo: 'Não existem Diários de Bordo abertos, Diários de Bordo não assinados',
		naoHaDiscrepancia: 'Não há discrepâncias',
		naoHaEmpregoAeronave: 'Não há emprego de aeronave',
		naoHaNenhumVoo: 'NÃO HÁ NENHUM VÔO ESPECIAL CADASTRADO',
		naoHaNenhumaTarefaCadastrada: 'Não há nenhuma tarefa cadastrada',
		naoHaRoteiro: 'Não Há Roteiro',
		naoInformado: 'Não Informado',
		naoLido: 'Não lido',
		naoNecessarioImprimirRelprev: 'Não é necessário imprimir o RELPREV',
		naoPossivelExcluirUnidadeMedidaSuprimentosLigados: 'Não é possível excluir uma unidade de medida com suprimentos ligados a ela',
		naoPossui: 'NÃO POSSUI',
		naoPossuiEntregas: 'Não possui entregas',
		naoSaiaDessaTela: 'Não saia dessa tela, isso interromperá o processo.',
		naoSatisfeito: 'NÃO SATISFEITO',
		naoSelecionouData: 'Você não selecionou uma data.',
		naoTemManutencao: 'Não Possui manutenção',
		naoTemParecerManutencao: 'Não tem o parecer da manutenção',
		naoTemParecerOperacoes: 'Não tem o parecer da operações',
		naoTenhoUmAerodromoDefinido: 'Não tenho um aeródromo definido.',
		nascer: 'Nascer',
		naturalidade: 'Naturalidade',
		natureza: 'Natureza',
		naturezaDoVoo: 'Natureza do Voo',
		naturezas: 'Naturezas',
		navegacao: 'Navegação',
		necessarioAdicionarPeloMenosUmItemAoPN: 'Necessário adicionar pelo menos um item ao PN',
		necessarioPeloMenosUmaInspecao: 'Necessário pelo menos uma inspeção para atualizar',
		negada: 'Negada',
		negar: 'Negar',
		negativo: 'Negativo',
		nenhum: 'Nenhum',
		nenhumAlertaEncontrado: 'NENHUM ALERTA ENCONTRADO',
		nenhumArquivo: 'Nenhum Arquivo Anexado',
		nenhumArquivoAnexado: 'Nenhum Arquivo anexado',
		nenhumDadoEncontrado: 'Nenhum dado encontrado para essa data.',
		nenhumDespacho: 'Não encontramos nenhum despacho para essa aeronave, selecione um na lista ou insira um despacho.',
		nenhumDespachoParaEssesDias: 'Nenhum Despacho para esses dias',
		nenhumDiarioDeBordoEncontrado: 'NENHUM DIÁRIO DE BORDO ENCONTRADO NESSE PERIODO',
		nenhumDiarioDisponivelParaAssinatura: 'Nenhum diário de bordo disponível para assinatura.',
		nenhumHistoricoEncontrado: 'Nenhum histórico encontrado.',
		nenhumItemEncontrado: 'Nenhum Item Encontrado',
		nenhumMotorAcionado: 'Nenhum motor acionado',
		nenhumParametroLegalCadastrado: 'Nenhum Parâmetro Legal Cadastrado',
		nenhumProdutoFoiAdicionado: 'Nenhum produto foi adicionado',
		nenhumRegistroEncontrado: 'Nenhum Registro encontrado',
		nenhumResultadoFoiEncontrado: 'Nenhum resultado foi encontrado',
		nenhumTrecho: 'NÃO HÁ NENHUM TRECHO',
		nenhumTrechoAdicionado: 'Nenhum Trecho Adicionado',
		nenhumValorRegistrado: 'Nenhum valor registrado',
		nenhumVooEncontrado: 'Nenhum voo foi encontrado.',
		nenhumaAcao: 'Nenhuma ação',
		nenhumaAcaoFoiTomadaDiscrepancia: 'Nenhuma ação foi tomada para essa discrepância.',
		nenhumaAeronaveAdicionada: 'Nenhuma Aeronave Adicionada',
		nenhumaAlteracao: 'Nenhuma alteração feita no diário será salva, para isso você tem que clicar em editar diário',
		nenhumaConversaEncontrada: 'Nenhuma conversa encontrada.',
		nenhumaDiscrepanciaAberta: 'Nenhuma discrepância aberta.',
		nenhumaDiscrepanciaEncontrada: 'Nenhuma discrepância encontrada',
		nenhumaDisponibilidadeEncontrada: 'Nenhuma disponibilidade encontrada.',
		nenhumaDocumentacaoAdicionada: 'Nenhuma Documentação Adicionada',
		nenhumaEscalaEncontrada: 'Nenhuma escala encontrada',
		nenhumaImagemCadastrada: 'Nenhuma Imagem Cadastrada',
		nenhumaInformacaoEncontrada: 'Nenhuma Informação Encontrada',
		nenhumaInspecaoEncontrada: 'Nenhuma Inspeção foi Encontrada',
		nenhumaMalha: 'NÃO HÁ NENHUMA MALHA CADASTRADA',
		nenhumaNotificacao: 'Você não tem nenhuma notificação',
		nenhumaNotificacaoEncontrada: 'Nenhuma notificação encontrada',
		nenhumaObservacao: 'Nenhuma observação adicionada',
		nenhumaOrdemFoiEncontrada: 'Nenhuma solicitação foi encontrada.',
		nenhumaOrdemParaEssesDias: 'Nenhuma Ordem para esses dias',
		nenhumaPosicaoEncontrada: 'Nenhuma posição encontrada',
		nenhumaRessalvaAdicionada: 'Nenhuma Ressalva Adicionada',
		nenhumaSolicitacaoParaEssesDias: 'Nenhuma Solicitação para esses dias',
		nenhumaTripulacaoAdicionada: 'Nenhuma tripulação adicionada',
		nice: 'BOM',
		nivel: 'Nível',
		nivelDeAprendizagem: 'Nível de Aprendizagem',
		noLlenado: 'NÃO PREENCHIDO',
		noMes: 'no Mês',
		nome: 'Nome',
		nomeAdicionado: 'Nome Adicionado',
		nomeAlternativo: 'Nome Alternativo',
		nomeCompleto: 'Nome Completo',
		nomeContato: 'Nome do Contato',
		nomeDaCategoria: 'Nome da categoria',
		nomeDaUnidade: 'Nome da Unidade',
		nomeDoVoo: 'Nome Do Voo',
		nomeDocumentoJaExistente: 'Este nome de documento já existe',
		nomeESobrenomealuno: 'NOME E SOBRENOME',
		nomeESobrenomeinstrutor: 'NOME E SOBRENOME DO INSTRUTOR',
		nomeModelo: 'Nome do Modelo',
		nomePasta: ' Nome da pasta',
		nomePrincipal: 'Nome Principal',
		nomeTipoDocumentoJaExistente: 'Este nome de tipo de documento já existe',
		nomeTratamento: 'Nome de tratamento',
		nomeclaturaComumMercosul: 'Nomeclatura Comum do Mercosul',
		nomeclaturaOleoLubrificante: 'Informe as nomeclaturas que serão exibidas nos Diários de Bordo, caso haja controle de óleo lubrificante',
		normas: 'Normas',
		nos: 'nós',
		nota: 'nota',
		notaCadastradaSistema: 'Nota Cadastrada no Sistema',
		notaFiscal: 'Nota Fiscal',
		notasAtualizacao: 'Notas de Atualização',
		notasDaVersao: 'Notas da Versão',
		notificaTripulacao: 'Notificar a tripulação ',
		notificacao: 'NOTIFICAÇÕES',
		notificacaoAtualizada: 'Notificação atualizada',
		notificacaoEncontrada: 'notificação(es) encontradas',
		notificacoesEnviadas: 'Notificações Enviadas',
		notificadoComSucesso: 'Notificado com sucesso',
		notificar: 'Notificar',
		noturno: 'Noturno',
		nova: 'Nova',
		novaAcao: 'Nova Ação',
		novaAssinatura: 'Nova Assinatura',
		novaCategoria: 'Nova Categoria',
		novaComunicacao: 'Nova Comunicação',
		novaDisciplina: 'Nova Disciplina',
		novaDiscrepancia: 'Nova Discrepância',
		novaDocumentacao: 'Nova Documentação',
		novaHabilitacao: 'Nova habilitação',
		novaInteracao: 'Nova Interação ',
		novaMalha: 'Nova malha',
		novaNota: 'Nova NFe',
		novaObservacao: 'Nova Observação',
		novaPrestacao: 'NOVA PRESTAÇÃO DE SERVIÇO',
		novaSenha: 'Nova Senha',
		novo: 'NOVO',
		novoAcionamento: 'Novo Acionamento',
		novoCapitulo: 'Novo Capítulo',
		novoContato: 'Novo Contato',
		novoDespacho: 'Novo Despacho',
		novoFornecedor: 'Novo Fornecedor',
		novoKit: 'Novo Kit',
		novoLayer: 'Novo Layer',
		novoMotor: 'Novo Motor',
		novoParametro: 'Novo Parâmetro',
		novoPonto: 'Novo Ponto',
		novoProcedimento: 'Novo Procedimento',
		novoRelatorio: 'Novo Relatório',
		novoSimplificado: 'Novo Simplificado',
		novoTicket: 'Novo Ticket',
		novoTrecho: 'Novo Trecho',
		novoUsuario: 'Novo Usuário',
		numAtividade: 'Nº Atividade',
		numChamada: 'Nº Chamada',
		numMotores: 'Número de Motores',
		numReds: 'Nº REDS',
		numSiape: 'Nº SIAPE',
		numberMotor: 'Nº Série Motor',
		numero: 'Número',
		numeroCarne: 'Número do Carnê',
		numeroCe: 'Número CE',
		numeroCodigo: 'Número do Código',
		numeroDB: 'Número DB',
		numeroDaCE: 'Número do CE',
		numeroDaFatura: 'Número da Fatura',
		numeroDaNota: 'Número da NFe',
		numeroDaOrdem: 'Número da Ordem',
		numeroDaProgramacao: 'N° da programação',
		numeroDeCE: 'Número de CE',
		numeroDeVoo: 'Número do Voo',
		numeroDiario: 'Número Diário',
		numeroDoCe: 'Número do CE',
		numeroDoContrato: 'Número do Contrato',
		numeroDoDespacho: 'Nº do Despacho',
		numeroDoDiarioDeBordo: 'Número do Diário de Bordo',
		numeroDoEmpenho: 'Número do empenho',
		numeroDoPedido: 'Número do Pedido',
		numeroIdentificacaoEmpregado: 'CNPJ',
		numeroLei: 'Número Lei',
		numeroLicenca: 'Número de Licença',
		numeroOrdemServico: 'Número Ordem Serviço',
		numeroPatrimonio: 'Número Patrimônio',
		numeroPeca: 'Número da Peça',
		numeroPrevencao: 'Número da Prevenção',
		numeroSolicitacao: 'Número da Solicitação',
		numeroTarefa: 'Número Tarefa',
		numeroTicket: 'Número do ticket: ',
		numeroVoo: 'Número do voo',
		oCampoDePassaporteEObrigatorioParaUmEstrangeiro: 'O campo de passaporte é obrigatório para um estrangeiro',
		oEventoFoiAtualizadoComSucesso: 'O evento foi atualizado com sucesso',
		oEventoFoiCadastradoComSucesso: 'O evento foi cadastrado com sucesso',
		oHorimetroDeveSerMenorQueOAtual: 'O horímetro deve ser menor que o atual',
		oKitDeveConterUmItem: 'O kit deve conter no mínimo 01 item',
		oQueEstaAcontecendo: 'O que está acontecendo? ',
		oRelatorioFoiAtualizadoComSucesso: 'O relatório foi atualizado com sucesso',
		oRelatorioFoiSalvoComSucesso: 'O relatório foi salvo com sucesso',
		oResultadoPodeDemorarUmPouco: 'o resultado pode demorar um pouco.',
		oTipoDeSolicitacaoFoiAtualizadoComSucesso: 'O tipo de solicitação foi atualizado com sucesso',
		oTipoDeSolicitacaoFoiExcluidoComSucesso: 'O tipo de solicitação foi excluído com sucesso',
		oTipoDeSolicitacaoFoiSalvoComSucesso: 'O tipo de solicitação foi salvo com sucesso',
		oTrechoEstaAberto: 'O trecho de <strong>{{INICIO}}</strong>, está em aberto e precisa ser preenchido.',
		oTrechodeInicioTexto: 'O trecho de inicio <strong>{{TRECHO}}</strong>, do dia <strong>{{INICIO}}</strong>, está em aberto e precisa ser preenchido.',
		oUsuarioPodeAlterarSuasConfigs: 'O usuário pode editar suas configurações?',
		objetivosAlcancados: 'Objetivos Alcançados',
		objetivosMissaoAlcancados: 'Os objetivos da missão foram alcançados?',
		objeto: 'Objeto',
		obrig: 'Obrigatório',
		obrigInstrutorVoo: 'Obrigatório para o instrutor de voo',
		obrigPilotoComando: 'Obrigatório para o Piloto em Comando',
		obrigacao: 'Obrigatório',
		obrigatorio: 'Campos marcados com * são obrigatórios',
		obs: 'Observação',
		observacao: 'Observação',
		observacoes: 'Observações',
		observacoesImportante: 'Observações importantes',
		ocasional: 'Ocasional',
		ocorrencias: 'Ocorrências',
		ocorreuErroTenteNovamente: 'Ocorreu um erro, tente novamente',
		ocultar: 'Ocultar',
		ocultarContrato: 'Ocultar Contrato',
		ocultarContratoConfirmacao: 'Deseja realmente ocultar esse contrato?',
		ocultarContratoNaoVigente: 'Oculte os contratos não vigentes',
		oficina: 'Oficina',
		oficio: 'Ofício',
		okParaUso: 'Ok para o uso?',
		ola: 'Olá',
		oleoLubrificante: 'Óleo Lubrificante',
		ondeNoEstoque: 'Onde no Estoque',
		opcoes: 'Opções',
		operacao: 'Operação',
		operacional: 'Operacional',
		operacoes: 'Operações',
		operacoesDeuParecer: 'Tem o parecer da operações',
		operacoesNaoDeuParecer: 'A operações não deu o parecer',
		operador: 'Operador',
		operadorAerotatico: 'Operador Aerotático',
		operadorIndefinido: 'O operador não foi definido',
		ordemCancelada: 'Ordem Cancelada',
		ordemDeMissao: 'Ordem de Missão',
		ordemDeMissaoSalva: 'Ordem de Missão Salva',
		ordemDeServico: 'Ordem de Serviço',
		ordemDeServicoConcluida: 'Ordem de Serviço Concluída',
		ordemDeServicoSalvaComSucesso: 'Ordem de Serviço Salva com Sucesso',
		ordemEncerrada: 'Ordem encerrada',
		ordemMissao: 'Ordem de Missão',
		ordemMissaoEncerrada: 'Ordem de Missão Encerrada.',
		ordemMissaoPrevencaoQualificada: 'Ordem de Missão de Prevenção Qualificada',
		ordemServico: 'Ordem de Serviço',
		ordemServicoCancelada: 'Ordem de serviço cancelada',
		ordemServicoManutencao: 'Ordem de Serviço de Manutenção',
		ordensDeMissao: 'Ordens de Missão',
		ordensGeradas: 'Ordens geradas',
		organizacao: ' Organização',
		orgao: 'Órgão',
		orgaoApioadoSalvo: 'Órgão apoiado salvo',
		orgaoApoiado: 'Órgão Apoiado',
		orgaoApoiadoAtualizado: 'Órgão apoiado atualizado',
		orgaoApoiadoAtualizadoComSucesso: 'Orgão Apoiado atualizado com sucesso.',
		orgaoApoiadoUnidades: 'Orgão Apoiado - Unidades',
		orgaoOperador: 'Órgão Operador',
		orgaoProprietario: 'Órgão Proprietário',
		orgaoSolicitante: 'Orgão Solicitante',
		orgaoUtilizam: 'Orgãos que utilizam a aeronave',
		orgaos: 'Órgãos',
		orgaosApoiados: 'Órgãos Apoiados',
		orgaosApoiadosDesativados: 'Orgão apoiado desativado',
		origem: 'Origem',
		origemDoVoo: 'Origem do voo',
		origemSistema: 'Documento origem sistema',
		osArquivosNãoPodemSerMaiorQue: 'O(s) arquivo(s) não pode(m) ser maior que',
		osDeSaida: 'OS de Destino',
		osTrechosPrecisamSerSeqquencial: 'Os trechos selecionados precisam ser sequenciais.',
		ou: 'Ou',
		outras: 'Outras',
		outrasClassificacao: 'outras',
		outro: 'Outro',
		outros: 'Outros',
		pacote: 'Pacote',
		padrao: 'Padrão',
		padraoProcedimento: 'Operacional Padrão',
		pagamento: 'PAGAMENTO',
		pagamentoDetalhes: 'Pagamento',
		pagamentoFeitoSucesso: 'Pagamento adicionado com sucesso',
		pagamentoNaoEfetuado: 'Nenhum Pagamento Efetuado',
		pago: 'Pago',
		pais: 'País',
		pancreas: 'Pâncreas',
		para: 'para',
		paraAddObrigatorio: 'Para \'novo\' este campo é obrigatório.',
		paraAdicionarEmpenhos: 'Para adicionar Empenhos',
		paraAdicionarTarefasVocePrecisaTerPeloMenosUmaInspecao: 'Para adicionar tarefas você precisa ter pelo menos uma inspeção',
		paraRemoverEsteGrupoVocePrecisaRemoverTodasTarefasLigadaAEle: 'Para remover este grupo você precisa remover todas tarefas ligada a ele',
		paraTodosOsArquivos: 'para todos os arquivos',
		parametro: 'Parâmetro',
		parametrosAeronave: 'Parâmetros da Aeronave',
		parametrosLegais: 'Parâmetros Legais',
		parametrosMidia: 'Parametros e médias',
		parcela: 'Parcela',
		parcelas: 'parcelas',
		parciais: 'Parciais',
		parcial: 'Parcial',
		parcialmentePago: 'Parcialmente Pago',
		parecer: 'Parecer',
		parecerAdicionadoComSucesso: 'Parecer adicionado com sucesso',
		parecerFinal: 'Parecer Final',
		parecerRecomendacoes: 'Parecer e recomendações apresentadas na inclusão',
		pareceres: 'Pareceres',
		partida: 'Partida',
		partidas: 'Partidas',
		passageiro: 'Passageiro',
		passageiroAtualizadoComSucesso: 'Passageiro atualizado com sucesso',
		passageiroExcluidoComSucesso: 'Passageiro excluído com sucesso',
		passageiroSalvoComSucesso: 'Passageiro salvo com sucesso',
		passageiros: 'Passageiros',
		passageirosDaAeronave: 'Passageiros da Aeronave',
		passaporte: 'Passaporte',
		passouTolerancia: 'Passou da tolerância',
		patrimonial: 'Patrimonial',
		patrimonio: 'Patrimônio',
		pedidoCanceladoComSucesso: 'Pedido cancelado com sucesso',
		pedirPecas: 'Pedir Peças',
		peloMenosUmContato: 'É necessário adicionar pelo menos um contato',
		peloMenosUmTelefone: 'É necessário adicionar pelo menos um número de telefone',
		peloUsuario: 'pelo usuário',
		pendentePagamento: 'Pendente Pagamento',
		percentualRestante: 'Percentual restante',
		percursoASerEfetuado: 'Percurso a ser efetuado',
		perfil: 'Perfil',
		perfilDoUsuario: 'Perfil do Usuário',
		perfilTipo: 'Tipo Perfil',
		perfilTripulacao: 'Perfil Tripulação',
		perfis: 'Perfis',
		perguntasERespostas: 'Perguntas e Respostas',
		perigosa: 'Perigosa',
		perigoso: 'Perigoso',
		periodicidade: 'Periodicidade',
		periodo: 'Período',
		periodoDeTesteAcabou: 'Periodo de teste acabou',
		permissaoExcluida: 'Permissão excluida',
		permissaoNegada: 'Permissão negada',
		permiteAlterarOContrato: 'Permite alterar o contrato',
		permiteMovimentarOContrato: 'Permite movimentar o contrato',
		pernoite: 'Pernoite',
		peso: 'Peso',
		pesoAprox: 'Peso Aproximado(Kg)',
		pesoMedio: 'Peso Médio (Kg)',
		pesoPassageiro: 'Peso Passageiro',
		pesoReal: 'Peso Real (kg)',
		pesoTotal: 'Peso total bagagem',
		pesquisar: 'Pesquisar',
		pesquisarPor: 'Pesquisar Por',
		pessoalEnvolvido: 'Pessoal envolvido',
		pessoasDetidas: 'Pessoas Detidas',
		pessoasSalvas: 'Pessoas Salvas',
		piloto: 'Piloto',
		pilotoComandante: 'PILOTO COMANDANTE',
		pilotoComando: 'Piloto em Comando',
		pilotoECopiloto: 'Piloto e Copiloto',
		pilotoEmComando: 'Piloto em comando',
		pilotoEmInstrucao: 'Piloto em Instrução',
		pilotoInstrucao: 'Piloto em Instrução',
		pilotoResponsavel: 'Piloto Responsável',
		pilotos: 'Piloto',
		placa: 'Placa',
		planejada: 'Planejada',
		plano: 'Plano',
		planoDeFundo: 'Plano de Fundo Tela Inicial',
		planoDeFundoAtual: 'Plano de Fundo Atual',
		planoDeRegistro: 'AVIÃO',
		planoPlem: 'Plano de emergência aeroportuário(PLEM)',
		planoPre: 'Plano de resposta emergencial da empresa(PRE)',
		planta: 'Planta',
		pn: 'PN',
		podeSerAlocado: 'Pode Ser Alocado',
		ponto: 'Ponto',
		pontos: 'pontos',
		pontosInteresse: 'Pontos de Interesse',
		pontualOuCondicao: 'Pontual ou na Condição',
		por: 'Por',
		por1: 'Por',
		porArtigo: 'Por',
		porHoraVoada: 'Por Hora Voada',
		porQuestoesAlterarSenha: 'por questões de segurança é necessário que você altere sua senha.',
		porQuestoesDeSeguranca: 'por questões de segurança é necessário que você altere sua Assinatura Digital',
		porcentagem: 'Porcentagem',
		porcentagemConsumidaDoContrato: 'Porcentagem consumida do contrato',
		porcentagemConsumidaDoEmpenho: 'Porcentagem consumida do empenho',
		portePassageiro: 'Porte do Passageiro',
		posGraduacao: 'Pós-Graduação',
		posicao: 'Posição',
		posicaoVoo: 'Posições de Voo',
		posicoes: 'Posições',
		positivo: 'Positivo',
		possui: 'POSSUI',
		pouso: 'Pouso',
		pousoPrevisto: 'Pouso Previsto',
		pousos: 'Pousos',
		pratica: 'PRÁTICA',
		prazo: 'Prazo',
		prazoParaExecucao: 'Prazo para execução',
		preRequistos: 'Pré-requisitos',
		precoMedio: 'Preço Médio',
		predefinicoes: 'Predefinições',
		preechaTodasAsInformacoesNecessarias: 'Preencha todas as informações necessárias',
		preenchaOsDadosDoResponsavelPeloVoo: 'Preencha os dados do responsável pelo vôo',
		preenchaOsDadosDoSolicitante: 'Preencha os dados da autoridade solicitante.',
		preenchaPeloMenosUmCampo: 'Preencha pelo menos um campo',
		preencher: 'Preencher',
		preenchimentoConcluido: 'Preenchimento concluído',
		preenchimentoMotorHorario: 'O preenchimento dos 4 campos de Motor e Horário deverá ser realizado em horário local.',
		preenchimentoPeriodo: 'Fique atento ao preenchimento dos campos Diurno, Noturno, IFR e VFR.',
		prefiroNaoDeclarar: 'Prefiro não declarar',
		prefixoAeronave: 'Prefixo Aeronave',
		prefixoOuIdentificacao: 'Prefixo / Identificação',
		prefixoOuIdentificacaoDoVeiculo: 'Prefixo / Identificação do Veículo',
		pressioneCtrl: 'Pressione CRTL',
		prevencao: 'Prevenção',
		prevencaoDespacho: 'Prevenção',
		prevencaoQualificada: 'Prevenção Qualificada',
		prevencaoSalva: 'Prevenção Salva',
		preventiva: 'Preventiva',
		previewOrdemMissao: 'Preview de ordem de missão',
		previsao: 'Previsão',
		previsaoDeData: 'Previsão de Data',
		previsaoDisponibilidadeDbEletronico: 'Previsão de Disponibilidade de DB Eletrônico',
		primeiroPilotoComando: '1º Piloto em Comando',
		prioridade: 'Prioridade',
		privilegio: 'Privilégio',
		privilegiosParaVer: 'privilégios para ver',
		proa: 'Proa',
		probabilidade: 'Probabilidade de volta a ocorrer',
		procedimento: 'Procedimento',
		procedimentoOperacionalPadrao: 'Procedimento Operacional Padrão',
		processaVoos: 'Processa Voos',
		processandoManutencao: 'Processando Manutenção (isso pode demorar um pouco)',
		processandoManutencaoVisao: 'Processando Manutenção',
		processarAuditoria: 'Processar Auditoria',
		processo: 'Processo',
		processoEmAndamento: 'Processo em andamento de uma ordem de missão ou despacho.',
		produto: 'Produto',
		produtoExcluidoComSucesso: 'Produto excluído com sucesso',
		produtoSalvoComSucesso: 'Produto salvo com sucesso',
		produtoServico: 'Produto/Serviço',
		produtoServicoExcluidoComSucesso: 'Produto/Serviço excluído com sucesso',
		produtoServicoSalvoComSucesso: 'Produto/Serviço foi salvo com sucesso',
		produtos: 'Produtos',
		produtosServicos: 'Produtos/Serviços',
		produtosServicosVinculados: 'Produtos/Serviços vinculados',
		programacao: 'Programação',
		programacaoDeVoo: 'de Voo',
		programacaoVoo: 'Programação de Voo',
		provedorSMS: 'Provedor SMS',
		proximaData: 'Próxima Data',
		proximaHora: 'Próxima Hor.',
		proximaInspecao: 'Próxima intervenção',
		proximaInspecaoCamp: 'Próxima Inspeção',
		proximo: 'Próximo',
		qtdDias: 'Qtd. Dias',
		qtdPago: 'Qtd. Pago',
		qtdSolicitado: 'Qtd. Solicitado',
		qtdeASerEntregue: 'Qtde. a ser Entregue',
		qtdeEmEstoque: 'Qtde. em Estoque',
		qtdeEntregue: 'Qtde. Entregue',
		qtdeRecebida: 'Qtde. Recebida',
		qtdeSolicitado: 'Qtde. Solicitado',
		quadrantes: 'Quadrantes',
		qualAeronaveVaiSerUtilizada: 'Qual aeronave vai ser utilizada?',
		qualDirigenteDesseOrgao: 'Quem é o dirigente deste Órgão?',
		qualOMotivo: 'Qual o motivo?',
		qualificacaoCivil: 'Qualificação Civil',
		qualificada: 'Qualificada',
		qualquerAeronave: 'Qualquer aeronave',
		quandoBotaoAlerta: 'Quando o botão de alerta (VERMELHO) é cancelado.',
		quandoPesquisarPorLongosPeriodos: 'Ao pesquisar por periodos longos',
		quantas: 'Quantas?',
		quantidade: 'Quantidade',
		quantidadeAtual: 'Quantidade Atual',
		quantidadeDeAeronavePorColuna: 'Quantidade de aeronave por coluna',
		quantidadeDeItens: 'Quantidade de Itens',
		quantidadeDeLitros: 'Quantidade de Litros',
		quantidadeDeveSerMaiorQueZero: 'Quantidade deve ser maior que 0',
		quantidadeDeveraSerMaiorQueZero: 'Quantidade deverá ser maior que 0',
		quantidadeDisponivel: 'Quantidade disponível',
		quantidadeEstimadaPassageiros: 'Quantidade Estimada',
		quantidadeHorasAcionamentoAoCorte: 'Quantidade Horas (Acionamento ao Corte)',
		quantidadeHorasDecolagemAoPouso: 'Quantidade horas (Decolagem ao Pouso)',
		quantidadeMinima: 'Quantidade Mínima',
		quantidadeMissao: 'Quantidade Missão',
		quantidadeTransferir: 'Quantidade a transferir',
		quantidadeTransferirMovimentacaoCombustivel: 'Quantidade a transferir (l)',
		quantitativo: 'Quantitativo',
		quantos: 'Quantos Confirmados?',
		quantosItens: 'Quantos Itens?',
		quatro: 'Quatro',
		quemEOOperador: 'Quem é o operador desta solicitação?',
		quilometros: 'Quilômetros',
		radial: 'Radial(°)',
		radio: 'Rádio',
		rastreado: 'Rastreado',
		rastreadoresAtivos: 'Rastreados Ativos',
		rastreamento: 'Rastreamento',
		razaoLatitude: 'Razão Latitude',
		razaoLongitude: 'Razão Longitude',
		razaoSocial: 'Razão Social',
		rbacTolerancia: 'É permitida a operação normal relativa a uma habilitação vencida há menos de 30 (trinta) dias. É vedada a operação normal relativa a uma habilitação vencida há mais de 30 (trinta) dias, em qualquer situação.',
		reabastecimento: 'Reabastecimento',
		reabertura: 'Reabertura',
		reabrindo: 'Reabrindo',
		reabrir: 'Reabrir',
		reabrirDespacho: 'Deseja Reabrir esse Despacho?',
		reabrirOrdem: 'Reabrir Ordem',
		realprevTelaLogin: 'Realprev Tela de Login',
		reativadoComSucesso: 'Reativado com sucesso',
		reativar: 'Reativar',
		receber: 'Receber',
		receberSuprimentos: 'Receber suprimentos',
		recebido: 'Recebido',
		recebidoPor: 'Recebido por',
		recomendacao: 'Recomendação',
		recomendacoes: 'Recomendações',
		recusados: 'Recusados',
		refOrigem: 'Ref Origem',
		refereSeAoInicio: 'refere-se ao inicio',
		referenciaManual: 'Referencia Manual',
		referencias: 'Referências',
		regNo: 'RegNo',
		registro: 'Registro',
		registroAbastecimento: 'Registro de Abastecimento',
		registroHFDM: 'FDM',
		registroNome: 'INSCRIÇÃO - NOME',
		registrosDaTripulação: 'Registros da Tripulação',
		registrosPrincipaisTabelas: 'Registros nas Principais Tabelas',
		regua: 'Régua',
		reguaDigital: 'Régua Digital',
		regulamento: 'Regulamento',
		regulamentoAtualizado: 'Regulamento atualizado',
		regulamentoExcluido: 'Regulamento removido com sucesso',
		regulamentoSalvo: 'Regulamento salvo',
		regular: 'REGULAR',
		relPrev: 'RelPrev',
		relacao: 'Relação',
		relator: 'Relator',
		relatorio: 'Relatório',
		relatorioAbastecimento: 'Relatório Abastecimento',
		relatorioAbastecimentoAnual: 'Relatório Abastecimento Anual',
		relatorioAeronave: 'Relatório Aeronave',
		relatorioAlocacao: 'Relatório Alocação',
		relatorioAviacaoCivil: 'Relatório aviação civil',
		relatorioCIV: 'Relatório CIV',
		relatorioCentroCusto: 'Relatório Centro de Custos',
		relatorioDiarios: 'Relatório Diário',
		relatorioEquipamentoOvn: 'Relatório Ovn Serial Number',
		relatorioHorasDeVoo: 'Relatório de Horas de Voo',
		relatorioHorasVoadas: 'Relatório de Horas Voadas',
		relatorioIndicadorEfetividade: 'Relatório de Indicador de Efetividade',
		relatorioMetaHorasVoadas: 'Relatório Meta Horas Voadas',
		relatorioMovimentacaoCombustivel: 'Relatório de movimentação de combustível',
		relatorioOVN: 'Relatório OVN',
		relatorioPerfil: 'Relatório de Perfil',
		relatorioPerfilUsuario: 'Relatório Perfil e Usuário',
		relatorioPrecoMedio: 'Relatório Preço Médio',
		relatorioPrestacaoDeContas: 'Relatório Prestação de Contas TDCO',
		relatorioPrevencao: 'Relatório de Prevenção',
		relatorioProdutividade: 'Relatório Produtividade',
		relatorioSinteticoDeProdutividade: 'Relatório Sintético de Produtividade',
		relevancia: 'Relevância',
		remota: 'Remota',
		removeTrechoVoltaHorimetro: 'Remove o trecho e volta o horímetro',
		remover: 'Remover',
		removerAeronave: 'Remover Aeronave',
		removidoSucesso: 'Removido com sucesso',
		renovacao: 'Renovação',
		requisicao: 'Requisição',
		requisitos: 'Requisitos',
		reservado: 'Reservado',
		responsavel: 'Responsável',
		responsavelCarga: 'Responsavel pela Carga',
		responsavelExecucao: 'Responsável pela execução',
		responsavelOS: 'Responsável pela ordem de serviço',
		responsavelPelaAprovacao: 'Responsável pela aprovação para retorno ao serviço',
		responsavelPelaCriacaoDaOrdem: 'Responsável pela Ordem de Missão',
		responsavelPelaExecucao: 'Responsável pela execução',
		responsavelPeloRetorno: 'Responsável pelo Retorno',
		responsavelPeloVoo: 'Responsável pelo Vôo',
		responsavelTecnico: 'Responsável Técnico',
		ressalvas: 'Ressalvas',
		resultados: 'Resultados',
		resultadosObtidos: 'Resultados Obtidos',
		resumoDaOrdemDeMissao: 'Resumo da Ordem De Missão',
		resumoDaSolicitacao: 'Resumo da Solicitação',
		retirada: 'Retirada',
		retiradoEm: 'Retirado em',
		retrair: 'Retrair',
		revalidacao: 'Revalidação',
		revisao: 'Revisão',
		revisaoData: 'Data da Revisão',
		revisar: 'Revisar',
		rim: 'Rim',
		rire: 'RIRE',
		roteiro: 'Roteiro',
		rua: 'Rua',
		ruaSemNome: 'Rua sem nome',
		saida: 'Saída',
		sair: 'Sair',
		sairTelaCheia: 'Sair Tela Cheia',
		saldo: 'Saldo',
		salvando: 'Salvando',
		salvandoGerandoRastreamento: 'Salvando e gerando rastreamento',
		salvandoSolicitacaoAvulsa: 'Salvando solicitação avulsa',
		salvar: 'Salvar',
		salvarAlteracoes: 'Salvar alterações',
		salvarE: 'Salvar e',
		salvarImagem: 'Salvar Imagem',
		salvarNovoPadrao: 'Salvar novo padrão',
		salvarOrdemMissao: 'Salve a ordem de serviço, ou volte em Due List ou Manuais e insira as inspeçoes faltantes',
		salvarPagamento: 'SALVAR',
		salvarProcessar: 'SALVAR E PROCESSAR',
		salvarTermo: 'Salvar Termo',
		salvarTrechos: 'Salvar Trechos',
		salvo: 'Salvo',
		salvoComSucesso: 'Salvo com sucesso ',
		satelite: 'Satélite',
		saudeESanitarias: 'de saúde e sanitárias',
		se: 'Se',
		seOErroPersistirPorFavorEntreEmContatoConosco: 'Se o erro persistir, por favor entre em contato conosco',
		secao: 'Seção',
		secaoAtualizada: 'Seção atualizada',
		secaoExpirada: 'Seção expirada',
		segundoComando: 'Segundo em Comando',
		segundoPilotoComando: '2º Piloto em Comando',
		segurancaPublica: 'de segurança pública',
		segurancaRelativa: 'de segurança relativa a atos de interferência ilícita contra a aviação civil',
		seguro: 'Seguro',
		sejaBemVindo: 'Seja bem-vindo ao',
		selecionadoOrgaos: 'Orgãos Selecionados',
		selecionarAeronave: 'Selecionar Aeronave',
		selecionarDespacho: 'Selecionar Despacho',
		selecionarItens: 'Selecionar itens',
		selecionarMalha: 'Selecionar malha',
		selecionarOpcaoAcima: 'Você tem que selecionar uma opção acima.',
		selecionarSemana: 'Selecionar Semana',
		selecionarUmDespacho: 'Selecione um Despacho',
		selecionarUmDiario: 'Selecione o diário de bordo abaixo.',
		selecione: 'Selecione',
		selecioneAPrevencaoQualificadaAbaixo: 'Selecione a prevenção qualificada abaixo',
		selecioneAbaixoALista: 'SELECIONE NA LISTA ABAIXO O EMPENHO QUE DESEJA ADICIONAR A ESSA FATURA',
		selecioneAeronave: 'Selecione uma Aeronave',
		selecioneAoMenosUmAcesso: 'Selecione pelo menos um acesso ao tipo de documento.',
		selecioneAoMenosUmLeitor: 'Selecione pelo menos um leitor ao documento',
		selecioneAsCargasTransportadas: 'Selecione as cargas transportadas',
		selecioneInspecaoAbaixo: 'Selecione uma inspeção abaixo',
		selecioneOAcesso: 'Selecione o acesso',
		selecioneOTipo: 'Selecione o tipo',
		selecioneOUsuario: 'Selecione o usuário',
		selecioneOrdemMissaoAbaixo: 'Selecione a ordem a missão abaixo.',
		selecioneOrdemMissaoPrevencaoAbaixo: 'Selecione a ordem de missão de prevenção qualificada abaixo.',
		selecioneOrdemMissaoPrevencaoQualificada: 'Selecione uma ordem de missão de prevenção qualificada',
		selecioneOrgaos: 'Selecione os Orgãos',
		selecioneOsPassageirosTrecho: 'Selecione os passageiros que voaram esse trecho',
		selecioneOsTrechosAgrupados: 'Selecione os trechos a serem agrupados abaixo.',
		selecioneParaExibir: ' Selecione um item para abrir as configurações.',
		selecioneParaExportar: 'Selecione o formato para exportação de dados',
		selecionePrioridade: 'Selecione uma prioridade',
		selecioneSeDesejaNotificar: 'Selecione se deseja notificar',
		selecioneUmContrato: 'Selecione um contrato',
		selecioneUmContratoAtivo: 'Selecione um contrato ativo',
		selecioneUmContratoOculto: 'Selecione um contrato oculto',
		selecioneUmContratoOcultoParaHabilitar: 'Selecione um contrato oculto para habilitar',
		selecioneUmEmpenho: 'Selecione um empenho',
		selecioneUmManual: 'Selecione um manual',
		selecioneUmMotor: 'Selecione Um Motor',
		selecioneUmaAero: 'Selecione uma aeronave para começar.',
		selecioneUmaAeronave: 'Selecione uma aeronave',
		selecioneUmaCor: 'Selecione uma Cor',
		selecioneUmaFatura: 'Selecione uma Fatura',
		selecioneUmaFuncao: 'Selecione uma Função',
		selecioneUmaMoeda: 'Selecione uma moeda',
		selecioneUmaOrdemDeMissao: 'Selecione uma Ordem de Missão',
		selecioneUmaPrevencaoQualificada: 'Selecione uma prevenção qualificada',
		sem: 'Sem',
		semDataInstalacao: 'PNs com data 00/00/0000 ainda não foram instalados',
		semMaisAlertas: 'SEM MAIS ALERTAS',
		semMaisConversa: 'sem mais conversa.',
		semPassageiros: 'Sem Passageiros confirmados',
		semSolicitacao: 'Sem solicitação',
		semTermoAbertura: 'Sem termo de abertura',
		semValor: 'Sem valor',
		semVitimas: 'Sem Vítimas',
		semana: 'Semana',
		semanas: 'Semanas',
		senha: 'Senha',
		senhaInvalida: 'Senha inválida.',
		senhaSpider: 'Senha Spider',
		senhaUtilizadaAoLogar: 'Senha utilizada para efetuar o login no sistema',
		senhasNaoCoincidem: 'As senhas digitadas não coincidem',
		separado: 'Separado(a)',
		seraExibidoTodas: 'será exibida todas as aeronaves no monitoramento por quadrante',
		seraExibidoTodasElas: 'será exibido as inspeções de todas aeronaves',
		seraNecessarioAssinarAlgumaInspecaoParaConfirmarNovasAlteracoesNosDadosDessaOrdemDeServico: 'Será necessário assinar alguma inspeção para confirmar novas alterações nos dados dessa ordem de serviço',
		seraNecessarioAssinatura: 'Será necessária uma nova assinatura do piloto',
		servicesWS: ' Services WS',
		servico: 'Serviço',
		servicos: 'Serviços',
		servicosAExecutar: 'Serviços á executar',
		servicosExecutados: 'Serviços executados',
		sessao: 'Sessão',
		sessaoAtualizada: 'Sessão atualizada',
		sessaoExpirada: 'Sessão expirada',
		setor: 'Setor',
		setorDestino: 'Setor destino',
		setorOuOrgaoExterno: 'Setor/Órgão Externo',
		setores: 'Setores responsáveis pela eliminação do perigo',
		severidade: 'Da Severidade',
		sexo: 'Sexo',
		sgpe: 'Nr do Arquivo SGP-e da pasta digital individual.',
		sigla: 'Sigla',
		sim: 'Sim',
		simples: 'Simples',
		simulador: 'SIMULADOR',
		sistema: 'Sistema',
		sistemaIntegado: 'Sistema Integrado',
		sistemaIntegrado: 'Sistema Integrado',
		sistemasDoCliente: 'Sistemas do cliente',
		situacao: 'Situação',
		situacaoDoPagamento: 'Situação do Pagamento',
		situacaoTripulacao: 'Situação Tripulação',
		sn: 'SN',
		snCelula: 'Célula SN',
		snDeEntrada: 'SN de Entrada',
		snDeSaida: 'SN de Saída',
		snOvn: 'Serial Number do OVN',
		soRecomendacoes: 'Só Recomendações',
		sobre: 'Sobre',
		socorridos: 'Socorridos',
		solicitaNumeroVoo: 'Solicita número do voo',
		solicitaUsoAeronave: 'Solicitação de uso de aeronave',
		solicitacao: 'Solicitação',
		solicitacaoCancelada: 'Solicitação cancelada.',
		solicitacaoCriadaDeUmaOrdemDeServico: 'Solicitação criada de uma ordem de serviço',
		solicitacaoInserida: 'Solicitação inserida no sistema.',
		solicitacaoSalva: 'Solicitação Salva',
		solicitacaoSalvaComSucesso: 'Solicitação Salva com Sucesso',
		solicitacoes: 'Solicitações',
		solicitacoesDeEdicao: 'Solicitações de Edição',
		solicitacoesEdicao: 'Solicitações de edição',
		solicitacoesFeitaPorVoce: 'Solicitações Feita por Você',
		solicitacoesItens: 'Solicitações de Itens',
		solicitacoesItensAvulsas: 'Solicitações de Itens Avulsos',
		solicitacoesParaVoce: 'Solicitações Para Você',
		solicitado: 'Solicitado',
		solicitadoEm: 'Solicitado em',
		solicitante: 'Solicitante',
		solicitanteCancelou: 'Solicitante cancelou',
		solicitanteDaMissao: 'Solicitante da Missão',
		solicitanteSelecionado: 'Esse usuário sera salvo apenas como solicitante em perfis do sistema.',
		solicitar: 'Solicitar',
		solicitarItemAvulso: 'Solicitar item avulso',
		solicitarItens: 'Solicitar Itens',
		solicitarOS: 'Você tem que salvar a OS para pedir suprimentos.',
		solicitarSuprimento: 'Solicitar Suprimento',
		solo: 'Solo',
		solteiro: 'Solteiro(a)',
		somaDiurnoNoturno: 'A soma dos campos "Diurno" e "Noturno" deve ser igual ao "Tempo de Voo do Piloto"',
		somaIfrVfr: 'A soma dos campos "VFR" e "IFR" deve ser igual ao "Tempo de Voo do Piloto"',
		souPiloto: 'Sou Piloto',
		status: 'Status',
		statusContrato: 'Status do Contrato',
		statusDaExecucao: 'Status da execução',
		statusDaRecomendacao: 'Status da recomendação',
		statusExcluidoComSucesso: 'Status excluído com sucesso!',
		statusFoiSalvoComSucesso: 'Status foi salvo com sucesso!',
		statusLeitura: 'Status Leitura',
		statusLicencas: 'Dias restantes para o vencimento.',
		suaSecaoExpirou: 'sua seção expirou.',
		suaSessaoExpirou: 'sua sessão expirou.',
		subEclassificacao: 'Subclassificação e Classificação',
		subcategoria: 'Subcategoria',
		subclassificacao: 'Subclassificação',
		subclassificacaoAtualizada: 'Subclassificação atualizada',
		subclassificacaoDesativada: 'Subclassifcacao desativada',
		subclassificacaoExcluida: 'Subclassificação excluída',
		subclassificacaoInstrucao: 'Subclassificação de Instrução?',
		subclassificacaoSalva: 'Subclassificação Salva',
		subtitulo: 'Subtitulo',
		suporte: 'Suporte',
		suprimento: 'Suprimento',
		suprimentoAeronauticos: 'Suprimentos Aeronáuticos',
		suprimentos: 'Suprimentos',
		tabela: 'Tabela',
		tamanho: 'Tamanho',
		tamanhoTelaLogin: ' Largura da tela de Login em pixels',
		tanque: 'Tanque',
		tarefaAdicionada: 'Tarefa Adicionada',
		tarefaCadastrada: 'Tarefa Cadastrada',
		tarefaRemovidaComSucesso: 'Tarefa removida com sucesso',
		tarefas: 'Tarefas',
		tas: 'Tas',
		telaCheia: 'Tela Cheia',
		telefone: 'Telefone',
		telefoneCelular: 'Telefone Celular',
		telefoneDeEmergencia: 'Telefone de Emergência',
		telefoneResidencial: 'Telefone Residencial',
		temUmTermino: 'Tem um término',
		template: 'Template',
		tempo: 'Tempo',
		tempoBusca: 'Tempo Busca',
		tempoDePreenchimento: 'Tempo de Preenchimento',
		tempoDeVoo: 'Tempo de Voo',
		tempoEstimado: 'Tempo Estimado',
		tempoEstimadoViaAr: 'ETA via AR',
		tempoIndisponibilidade: 'Tempo de indisponibilidade',
		tempoNotificao: 'Tempo de Notificações',
		tempoRestante: 'Tempo Restante',
		tempoSessao: 'Tempo de Sessão',
		tempoSobrevoo: 'Tempo de Sobrevoo',
		tempoTotal: 'Tempo Total',
		tempoTotalPiloto: 'Tempo Total do Piloto:',
		tempoUso: 'Tempo de utilização',
		tempoVooMuitoGrande: 'Tempo de Voo muito grande',
		tentativas: 'Tentativas',
		teorico: 'TEÓRICO',
		termino: 'Término',
		terminoOrdem: 'Término da Ordem',
		termoAbertura: 'Termo Abertura',
		termoAtualizado: 'Termo Atualizado',
		termoDeUso: 'Termo de Uso',
		termoDescentralizacaoCredito: 'Termo de Descentralizacao de Crédito',
		termosDeUso: 'Termos de uso',
		texto: 'Texto',
		textoDiaDiscrepancia: 'tem um maior número de casos ocorrendo',
		textoDigiteSeuLogin: 'Digite seu login que vamos achar a melhor forma definir uma nova senha.',
		textoHorarioDiscrepancia: 'em um horário próximo às',
		textoLogin: 'Texto na tela de Login',
		textoModificarSenha: 'Para modificar sua senha atual, digite a nova senha no campo abaixo.',
		textoNotificacao: 'Texto da Notificação',
		textoSenhaAlteradaSucesso: 'Sua senha foi alterada com sucesso!',
		ticket: 'Ticket',
		ticketCancelado: 'Ticket Cancelado',
		timeline: 'TIMELINE',
		tipo: 'Tipo',
		tipoAcionamento: 'Tipo de Acionamento',
		tipoAeronave: 'Tipo de Aeronave',
		tipoAplicacao: 'Tipo Aplicação',
		tipoArmazenamentoExcluido: 'Tipo Armazenamento Excluído com Sucesso',
		tipoCarga: 'Tipo de Carga',
		tipoCiclo: 'Tipo de Ciclo',
		tipoCombustivel: 'Tipo de Combustível',
		tipoContrato: 'Tipo de Contrato',
		tipoContratoExcluidoComSucesso: 'Tipo de contrato excluído com sucesso!',
		tipoContratoFoiSalvoComSucesso: 'Tipo de contrato foi salvo com sucesso!',
		tipoControle: 'Tipo do controle',
		tipoDeAmazenamentoSalvoComSucesso: 'Tipo De Armazenamento Salvo com Sucesso!',
		tipoDeArmazenamento: 'Tipo de Armazenamento',
		tipoDeCarga: 'Tipo de carga',
		tipoDeEntrada: 'Tipo de Entrada',
		tipoDeLicenca: 'Tipo de Licença',
		tipoDePagamento: 'Tipo de pagamento',
		tipoDePlano: 'Tipo de plano',
		tipoDeSolicitacao: 'Tipo de solicitação',
		tipoDeUsuario: 'Tipo do Usuário',
		tipoDeVoo: 'Tipo do Voo',
		tipoDespacho: 'Tipo de Despacho',
		tipoDoEvento: 'Tipo do evento',
		tipoDoProduto: 'Tipo do Produto',
		tipoDocumento: 'Tipo Documento',
		tipoDocumentoExcluidoComSucesso: 'Tipo documento excluido com sucesso',
		tipoDocumentoSalvoComSucesso: 'Tipo documento salvo com sucesso',
		tipoEmbalagem: 'Tipo de Embalagem',
		tipoEmbalagemCadastro: 'Tipo de embalagem cadatrado com sucesso',
		tipoEntrada: 'Tipo Entrada',
		tipoMapa: 'Tipo Mapa',
		tipoMissao: 'Tipo de Missão',
		tipoMovimentacao: 'Tipo Movimentação',
		tipoOrdemDeMissao: 'Tipo Ordem de Missão',
		tipoOrdemMissaoExcluidoComSucesso: 'Tipo Ordem de Missão excluído corretamente',
		tipoOrdemMissaoSalvoComSucesso: 'Tipo Ordem de Missão salvo com sucesso.',
		tipoProximaIntervencao: 'Tipo da próxima intervenção',
		tipoTarefa: 'Tipo da Tarefa',
		tipoUltimaIntervencao: 'Tipo da última intervenção',
		tipoUnidadeArmazenamento: 'Tipo Unidade Armazenamento',
		tipos: 'Tipos',
		tiposDeSolicitacao: 'Tipos de solicitação',
		titulo: 'Para gerar o relatório, preencha os campos abaixo.',
		tituloPrimario: 'Título',
		tituloTarefa: 'Título Tarefa',
		tituloTicket: 'Titulo ',
		tituloTicketForm: 'Titulo: ',
		todas: 'Todas',
		todasAlteracoesSalvas: 'Todas alterações serão salvas',
		todasAsFuncoes: 'Todas as Funções',
		todasDiscrepanciasConcluidas: 'Todas as discrepâncias concluídas.',
		todasInspecoes: 'Todas Inspeções',
		todasInspecoesAssinadaPeloInspetor: 'Todas inspeções assinadas pelo inspetor.',
		todasInspecoesAssinadaPeloMecanico: 'Todas inspeções assinadas pelo mecânico.',
		todasInspecoesDesabilitadas: 'Todas Inspeções Desabilitadas',
		todasNaturezas: 'Todas as naturezas',
		todasNturezas: 'Todas Naturezas',
		todasSeraoExibidas: ' todas serão exibidas',
		todos: 'Todos',
		todosGrupos: 'Todos os grupos',
		todosModelos: 'Todos os Modelos',
		todosOsContratos: 'todos os contratos',
		todosOsDiariosForamAssinados: 'Ok! Todos os Diários de Bordo dessa aeronave foram assinados.',
		todosOsTipos: 'Todos os Tipos',
		todosOsTrechos: 'Todos os trechos',
		todosOsVoos: 'Todos os Voos',
		todosProcessosOrdemMissaoOuDespachoConcluidos: 'Todos os processos da ordem de missão ou despacho foram concluídos.',
		tolerabilidade: 'Tolerabilidade',
		tolerancia: 'Tolerância',
		toleranciaDisponivel: 'Tolerância Disponível',
		tooltipDescricaoFatos: 'Descrição dos fatos, necessariamente informando o que e como se deu a ocorrência. Alguns exemplos de ocorrência são falecimento de um passageiro em voo, mulher em trabalho de parto, transmissão de algum vírus, etc.',
		tooltipLocalOcorrencia: 'Local da ocorrência, necessariamente, pelo indicativo de localidade ou coordenada geográfica se em solo e, obrigatoriamente por coordenada geográfica se em voo.',
		tooltipQualificacaoCivil: 'Melhor qualificação civil possível das pessoas envolvidas (nome completo, documento de identificação utilizado para embarque; nacionalidade e data de nascimento, entre outros).',
		tooltipReabrirDespacho: 'Reabrir Despacho',
		tornarRecomendacaoDeConhecimentoPublico: 'Tornar recomendação de conhecimento publico',
		totais: 'Totais',
		total: 'Total',
		totalCapacidadeMaxima: 'Capacidade máxima total',
		totalCiclosAviao: 'Total de Ciclos',
		totalCiclosVoados: 'Total de Ciclos Voados',
		totalDeCiclosNF: 'Total de Ciclos N2/NF/NTL',
		totalDeCiclosNG: 'Total de Ciclos N1/NG',
		totalDeCiclosNP: 'Total de Ciclos NP',
		totalDeGancho: 'Total de Gancho',
		totalDeGuincho: 'Total de Guincho',
		totalDeOcorrencias: 'Total de ocorrências',
		totalDePartidas: 'Total de Partidas',
		totalDePousos: 'Total de Pousos',
		totalDia: 'Total no dia',
		totalDoTreinamento: 'Total do treinamento',
		totalHoras: 'Total de Horas',
		totalHorasPiloto: 'Total de Horas (Piloto)',
		totalHorasUtilizacao: 'Total de Horas de Utilização',
		totalHorasVoadas: 'Total de Horas Voadas',
		totalNaoRastreado: 'Total não rastreado',
		totalPago: 'Total Pago',
		totalRastreado: 'Total rastreado',
		totalidade: 'Em sua totalidade',
		totalTempoVoo: 'Tempo Total de Voo',
		totalvolume: 'Volume Total',
		trabalho: 'Trabalho',
		transferencia: 'Transferência',
		transferenciaBase: 'Transferência de Base',
		transicao: 'Transição',
		trecho: 'Trecho',
		trechoAdicionado: 'Trecho adicionado.',
		trechoAgrupadoPor: 'Trecho agrupado por',
		trechoAposData: 'Trechos só poderão ter data de acionamento posterior a data de corte do último trecho',
		trechoAssinado: 'Trecho assinado',
		trechoDesagrupado: 'Trecho desagrupado.',
		trechoExcluido: 'Trecho excluído.',
		trechoJuntado: 'Trecho agrupado.',
		trechoSeraSalvo: 'O número do trecho será criado após o salvamento da Solicitação de Apoio Aéreo.',
		trechosAgrupados: 'Trechos Agrupados',
		trechosQueOPassEstara: 'Trechos que o passageiro estará',
		treinamento: 'Treinamento',
		trelloFollowair: 'Trello Followair',
		tres: 'Três',
		trigrama: 'Trigrama',
		tripulacao: 'Tripulação',
		tripulacaoZero: 'Você tem que adicionar uma tripulação',
		trocaEquipamentoAeronave: 'Troca equipamentos das aeronaves',
		trocaSucesso: 'Adicionado com sucesso',
		trocar: 'Trocar',
		trocarVoo: 'Trocar Voo',
		tudoCerto: 'Tudo certo, o solicitante já pode receber o(s) item(ns)!',
		txtNovoTipoHabilitacao: 'Clique em "Nova habilitação"',
		ubidadeDeOrgaoApoiadoSalvoComSucesso: 'Unidade de orgão apoiado salvo com sucesso',
		ultima: 'Última',
		ultimaAtualizacaoDaManutencao: 'Ultima Atualização da Manutenção',
		ultimaData: 'Última data',
		ultimaInspecao: 'Última intervenção',
		ultimaManutencaoRealizada: 'Última manutenção Realizada',
		ultimo: 'Último',
		ultimoReport: 'Ultimo Report',
		ultimos30Dias: 'Últimos 30 dias',
		ultimos60Dias: 'Últimos 60 dias',
		ultimos90Dias: 'Últimos 90 dias',
		ultimoServico: 'Último Serviço',
		ultimoVoo: 'Último Voo',
		um: 'Um',
		umCampoObrigatorio: 'Preencha ao menos um telefone',
		umDessesCampoEObrigatorio: 'Um desses campos é obrigatório.',
		unidade: 'Unidade',
		unidadeArmazenamento: 'Unidade de Armazenamento',
		unidadeArmazenamentoSalvaComSucesso: 'Unidade de Armazenamento salva com sucesso',
		unidadeCompra: 'Unidade de compra',
		unidadeContabil: 'Unidade Contábil',
		unidadeDeArmazenamentoDeDestino: 'Unidade de Armazenamento de Destino',
		unidadeDeArmazenamentoDeOrigem: 'Unidade de Armazenamento de Origem',
		unidadeDeConservacao: 'Unidade de Conservação',
		unidadeDeMedida: 'Unidade de medida',
		unidadeDestino: 'Unidade de Destino',
		unidadeDoOrgao: 'Unidade do Órgão',
		unidadeDoOrgaoApoiadoExcluidoComSucesso: 'Unidade do órgão apoiado excluído com sucesso',
		unidadeMedida: 'Unidade Medida',
		unidadeOrcamentaria: 'Unidade Orçamentária',
		unidadeOrcamentariaExcluida: 'Unidade orçamentária excluida',
		unidadeOrcamentariaSalvaComSucesso: 'Unidade Orçamentária salva com sucesso',
		unidadeOrgaoApoiado: 'Unidade de Órgão Apoiado',
		unidadeOrigem: 'Unidade de Origem',
		unidades: 'Unidades',
		upload: 'upload',
		url: 'URL',
		usaCAMP: 'Utiliza Manutenção CAMP ou Followair',
		userSpider: 'User Spider',
		usoDe: 'Uso de',
		usoDeAereonave: 'Uso de Aeronave',
		usoDeFlir: 'Uso de FLIR',
		usoDeOvn: 'Uso de OVN',
		usuario: 'Usuário',
		usuarioDesativado: 'Usuário Desativado',
		usuarioLicenca: 'Usuário Licença',
		usuarioNaoTenha: 'o usuário não tenha',
		usuarioQuePodeVer: 'Usuario que pode ver esse contrato',
		usuarioSemLicenca: 'Usuário não possui nenhuma licença',
		usuarios: 'Usuários',
		usuariosAtivos: 'Usuários Ativos',
		usuariosAtivosInativos: 'Usuários Ativos / Inativos',
		usuariosDesativados: 'Usuários Desativados',
		usuariosSimultaneos: 'Usuários Simultâneos',
		utcDate: 'Data UTC',
		utilizaManutencao: 'Utiliza Manutenção',
		utilizaSigiloOM: 'Utiliza Sigilo em Ordem de Missão',
		utilizaTrigrama: 'Utiliza Trigrama',
		utilizada: 'Utilizada',
		validade: 'Validade',
		validadeEmMeses: 'Validade em Meses',
		validando: 'Validando',
		validandoIntegridadeDoDiarioDeBordo: 'Validando integridade do diário de bordo',
		validandoSenha: 'Validando senha',
		validandoTrecho: 'Validando Trecho',
		validarDados: 'VALIDAR DADOS DA AERONAVE E MOTOR',
		validos: 'Válidos',
		valor: 'Valor',
		valorDaHora: 'Valor da Hora',
		valorDoCiclo: 'Valor do Ciclo',
		valorDoContrato: 'Valor do contrato',
		valorDoLitro: 'Valor do Litro',
		valorDoPagamento: 'Valor pagamento',
		valorEmpenhado: 'Valor Empenhado',
		valorFrete: 'Valor Frete',
		valorHoraTreinamentoPrático: 'Valor Hora Treinamento Prático',
		valorMaiorQueTempoPiloto: 'Valor maior que o tempo do piloto',
		valorNFS: 'Valor NFe',
		valorNaoPermitidoPorUltrapassarOValorContratado: 'Valor não permitido por ultrapassar o valor contratado',
		valorNaoPermitidoPorUltrapassarOValorEmpenhado: 'Valor não permitido por ultrapassar o valor empenhado',
		valorNumericoInvalido: 'Valor numérico inválido.',
		valorProduto: 'Valor do Produto',
		valorProdutoServico: 'Valor do Produto/Serviço',
		valorReal: 'Valor Real',
		valorRecuperado: 'Valor Recuperado',
		valorReferenteAData: 'Valor referente a data da inspeção',
		valorReportado: 'Valor Reportado',
		valorTempoVoo: 'Valor do tempo de voo',
		valorTotal: 'Valor Total',
		valorTotalAbastecido: 'Valor Total Abastecido',
		valorTotalEmProdutosServicos: 'Valor total em produtos/serviços',
		valorTotalProduto: 'Valor Total do Produto',
		valorTreinamentoTeorico: 'Valor Treinamento Teórico',
		valorTributos: 'Valor Tributos',
		valorUnitario: 'Valor Unitário',
		valorUnitarioTributos: 'Valor Unitário com Tributos',
		valordaMatricula: 'Valor da Matrícula',
		valoresAtivos: 'Valores ativos',
		valoresDoContrato: 'Valores do Contrato',
		valoresPorOrgao: 'VALORES POR ORGÃO',
		varIndMeta: 'var % ind/meta',
		variacoes: 'Variações',
		vcTemQueDigitarSenha: 'Você tem que digitar sua senha.',
		veiculo: 'Veículo',
		veiculoExcluidoComSucesso: 'Veiculo excluído com sucesso',
		velocidade: 'Velocidade',
		velocidadeAtual: 'Velocidade Atual',
		velocidadeMedia: 'Velocidade Média',
		vencido: 'Vencido',
		vencimento: 'vencimento',
		vencimentos: 'Vencimentos',
		ver: 'Ver',
		verAcionamentoECorte: 'Ver acionamento e corte',
		verDecolagemEPouso: 'Ver decolagem e pouso',
		verEstoque: 'Ver estoque',
		verTodos: 'Ver todos',
		verificaBloqueioDiscrepancia: 'Verifica Bloqueio de Discrepância',
		verificacao: 'VERIFIQUE A FORMA DE EXECUÇÃO DA OPERAÇÃO NO LUGAR CORRESPONDENTE',
		verificacaoDoVor: 'Verificação do VOR',
		verificacaoSePodeExcluir: 'Verificando se pode excluir',
		verificados: 'Verificados',
		verificando: 'Verificando',
		verificandoSePodePreencher: 'Verificando se pode preencher',
		verificar: 'Verificar',
		verificarDisponibilidade: 'Verificar Disponibilidade',
		versao: 'Versão',
		versaoApi: ' Versão da Api',
		versaoArquivo: 'Versão do Arquivo',
		vidaUtil: 'Vida útil',
		visaoGeral: 'Visão Geral',
		visualizacoes: 'Visualizações',
		visualizar: 'Visualizar',
		visualizarMalha: 'Visualizar Malha',
		visualizarNFS: 'Visualizar NFe',
		visualizarOrdemServico: 'Visualizar Ordem de Serviço',
		visualizarRelatorio: 'Visualizar Relatório',
		vitima: 'Vítima',
		vitimas: 'Vítimas',
		viuvo: 'Viúvo(a)',
		voadas: 'Voadas',
		voando: 'Voando',
		voce: 'Você',
		voceAlterandoAeronave: 'Você está alterando o modelo de aeronave',
		voceAlterandoModelos: 'Você está alterando todos os modelos',
		voceAlterandoSerial: 'Você está alterando o modelo de serial number',
		voceEAAutoridadeSolicitante: 'Você é a autoridade solicitante?',
		voceJaAddEsseFator: 'Você já adicionou este fator',
		voceJaAddEssePerfil: 'Você já adicionou este perfil',
		voceJaAddEsseSetor: 'Você já adicionou este setor',
		voceJaAddItem: 'Você já adicionou este item.',
		voceJaCadastrouItem: 'Você já cadastrou esse item.',
		voceNaoPodeAgrupar: 'Você não pode desagrupar esses trechos, eles já foram preenchido.',
		voceNaoPodeExcluirEditando: 'Você não pode excluir, alguém está preenchendo o diário.',
		voceNovaSenha: 'Você tem que digitar a nova senha.',
		vocePodeAtualizar: 'Você já pode atualizar o diário de bordo',
		voceResponsavelPeloVoo: 'Você é o responsável pelo vôo?',
		voceTem: 'Você tem',
		voceTemAddUmPerfil: 'Você tem que adicionar pelo menos um perfil.',
		voceTemQueEscolherUnidade: 'Você tem que adicionar pelo menos uma unidade.',
		voceTemQueEsperarPois: 'Você tem que aguardar, pois',
		voltar: 'Voltar',
		voltarMapa: 'Voltar para o mapa',
		volume: 'Volume',
		volumeAbastecido: 'Volume Abastecido',
		volumeAbastecidoUnidadeArmazenamento: 'Volume Abastecido (l)',
		volumeAtual: 'Volume atual',
		volumeAtualMovimentacaoCombustivel: 'Volume atual(l)',
		volumeEmLitros: 'Volume em Litros',
		volumeFinal: 'Volume Final',
		volumeFinalMovimentacaoCombustivel: 'Volume final (l)',
		volumeMovimentacaoCombustivel: 'Volume(l)',
		volumeReal: 'Volume Real',
		volumeTotalAbastecido: 'Volume Total Abastecido',
		voo: 'Voo',
		vooAdicionadoSucesso: 'Voo adicionado com sucesso',
		vooAssinadoPeloMecanico: 'Voo assinado pelo Mecânico',
		vooAssinadoPeloOperador: 'Voo assinado pelo Operador',
		vooAssinadoPeloPiloto: 'Voo assinado pelo Piloto',
		vooAssinadoPor: 'Voo assinado por',
		vooDecimoCelula: 'Voo Décimo Célula',
		vooDecimoMotor: 'Voo Décimo Motor',
		vooDeveConterPiloto: 'Voo de instrução deve conter um "Piloto em comando"',
		vooEspecial: 'Vôo Especial',
		vooFinal: 'Hor. Final',
		vooInicial: 'Hor. Inicial',
		vooLegado: 'Voo Legado',
		vooNaoPreenchido: 'Voo não preenchido',
		vooPreenchidoPor: 'Voo preenchido por',
		vooReferenteAData: 'Voo referente a data',
		vooRegular: 'Voo Regular',
		vooSalvo: 'Voo salvo com sucesso',
		voos: 'Voos',
		voosEspeciais: 'VÔOS ESPECIAIS',
		wsdlCampFeed: 'WSDL Feed',
		wsdlCampGeneral: 'WSDL Geral',
		wsdlCampStatus: 'WSDL Status',
		wsdlCampoWorkOrder: 'WSDL Ordem de trabalho',
		zonaQuenteCriminalidade: 'Zona Quente de Criminalidade',
		zoomAeronave: 'Zoom Aeronave',
		zoomMobile: 'Zoom (Mobile)',
		zoomPrincipal: 'Zoom Principal',
		zoomRastreamento: 'Zoom Rastreamento',
		zqc: 'ZQC',
	},
	login: {
		digiteLogin: 'Digite seu login',
		digiteSenha: 'Digite sua senha',
		digiteSenhaAtual: 'Digite sua senha atual',
		entrando: 'Entrando',
		entrar: 'Entrar',
		textoErro: 'Usuário ou senha inválidos',
	},
	menu: {
		administracao: 'Administração geral',
		comercial: 'Comercial',
		despachoComercial: 'Despacho Comercial',
		gestaoMalhaComercial: 'Gestão de Malha Comercial',
		menuAdministracao: 'Administração',
		menuAdministracaoEnsino: 'Administração do Ensino',
		menuCertificados: 'Certificados',
		menuExecucaoEnsinoTreinamento: 'Execução de Ensino/Treinamentos',
		menuGeral: 'Geral',
		menuGerenciais: 'Gerenciais',
		menuManutencao: 'Manutenção',
		menuManutencaoAeronave: 'Aeronave',
		menuMissao: 'Missão',
		menuMonitoraAeronaves: 'Aeronaves',
		menuOrdem: 'Ordem',
		menuProjeto: 'Projetos',
		menuRastreador: 'Rastreador',
		menuRastreamento: 'Rastreamento',
		menuRelatorios: 'Relatórios',
		menuTrello: 'Trello',
		menuTrocarEquipamento: 'Trocar Equipamento',
		sairSistema: 'Deseja sair do sistema?',
		segurancaOperacional: 'Segurança operacional',
		segurancaOperacionalOperacional: 'Operacional',
		segurancaOperacionalSeguranca: 'Segurança',
	},
	menuAGCadAula: {
		aberta: 'Aberta',
		adicionarAula: 'Adicionar Aula',
		aula: 'Aula',
		aulaAtualizada: 'Aula atualizada com sucesso',
		aulaCancelada: 'Aula cancelada com sucesso',
		aulaEncerrada: 'Aula encerrada',
		aulaInserida: 'Aula inserida com sucesso',
		aulaReaberta: 'Aula reaberta com sucesso',
		aulas: 'Aulas',
		aulasEFrequencias: 'Aulas e Frequências',
		cancelada: 'Cancelada',
		duracaoNaoPodeMaiorQue: 'Duração não pode ser maior que',
		encerrada: 'Encerrada',
		frequencias: 'Frequências',
		msgAjudaAula: 'Clique nos cards da tabela para editar ou fazer o lançamento de frequências.',
		presente: 'Presente',
	},
	menuAGCadTurma: {
		abertaParaInscricao: 'Aberta para inscrição',
		emAndamento: 'Em andamento',
		excluirTurma: 'Você quer deletar está Turma?',
		finalizada: 'Finalizada',
		novaTurma: 'Nova Turma',
		turmaAtualizada: 'Turma atualizada',
		turmaInserida: 'Turma adicionada',
		turmaRemovida: 'Turma removida com sucesso',
		turmaTitulo: 'Turma',
	},
	menuAGcadAluno: {
		acidente: 'Em caso de acidente avisar a',
		alergico: 'É alérgico a algum(ns) tipo(s) de medicamento(s)? Descrevê-lo(s)',
		contato1: 'Telefone Principal',
		contato2: 'Celular',
		contato3: 'Contato 3',
		dadosPessoais: 'Dados Pessoais',
		doSecao: 'Seção',
		doc1: 'Documento 1',
		doc2: 'Documento 2',
		doc3: 'Documento 3',
		docCategoria: 'Categoria',
		docCertidaoDeReservista: 'Certificado de Reservista',
		docCic: 'CIC',
		docDataExpedicao: 'Data de Emissão',
		docIdentidade: 'Identidade',
		docOrgaoExpeditor: 'Órgão Expedidor',
		docTituloEleitor: 'Título de Eleitor',
		docZona: 'Zona',
		documentacao: 'Documentação',
		doutorado: 'Doutorado',
		empresa: 'Empresa',
		ensinoFundamental: 'Ensino Fundamental',
		ensinoMedio: 'Ensino Médio',
		entende: 'Entende',
		escolhaNivelInstrucao: 'Escolha o seu nível de instrução',
		escreve: 'Escreve',
		eulieaceitootermo: 'Eu li e concordo com os termos acima.',
		fala: 'Fala',
		fatorRH: 'Fator RH',
		filiacao: 'Filiação',
		grauParentesco: 'Grau de Parentesco',
		habIFRaviaoP: 'Habilitação IFR Avião - Prático',
		habIFRaviaoT: 'Habilitação IFR Avião - Teórico',
		habIFRhelicopteroP: 'Habilitação IFR Helicóptero - Prático',
		habIFRhelicopteroT: 'Habilitação IFR Helicóptero - Teórico',
		habilitacao: 'Para Portadores de Habilitação',
		idioma: 'Idioma',
		idiomasEstrangeiros: 'Idiomas Estrangeiros',
		infoAdicionais: 'Informações Adicionais',
		inscricaoSalva: 'Inscrição salva com sucesso!',
		le: 'Lê',
		menuAGalunoAdm: 'Administração',
		menuAGalunoCargo: 'Cargo',
		menuAGalunoDoc: 'Documento',
		menuAGalunoEscolar: 'Escolar',
		menuAGalunoFicha: 'Ficha de Inscrição',
		menuAGalunoInsc: 'Inscrição',
		menuAGalunoInscs: 'Inscrições',
		menuAGalunoNovaInsc: 'Nova Inscrição',
		menuAGalunoSexo: 'Sexo',
		mestrado: 'Mestrado',
		nivelInstrucao: 'Nível de Instrução',
		nomeEmpresa: 'Nome da Empresa',
		nomeMae: 'Nome da Mãe',
		nomePai: 'Nome do Pai',
		numeroInscricao: 'Número da Inscrição',
		outrasInfo: 'Outras Informações',
		paraPortadoresDeLicenca: 'Para Portadores de Licença',
		pilotoCPaviao: 'Piloto Comercial de Avião - Prático',
		pilotoCPhelicoptero: 'Piloto Comercial de Helicóptero - Prático',
		pilotoCTaviao: 'Piloto Comercial de Avião - Teórico',
		pilotoCThelicoptero: 'Piloto Comercial de Helicóptero - Teórico',
		pilotoPPaviao: 'Piloto Privado de Avião - Prático',
		pilotoPPhelicoptero: 'Piloto Privado de Helicóptero - Prático',
		pilotoPTaviao: 'Piloto Privado de Avião - Teórico',
		pilotoPThelicoptero: 'Piloto Privado de Helicóptero - Teórico',
		requisitosParaOtreinamento: 'Requisitos para esse treinamento.',
		sebrac: 'SEBRAC',
		simuladorVoo: 'Simulador de voo',
		superiorCompleto: 'Superior',
		tipoSanguineo: 'Tipo Sanguíneo',
		treinamento: 'Treinamento',
		voltarParaLista: 'Voltar para a lista',
	},
	menuAGcadMatricula: {
		addMatricula: 'Matrícula adicionada',
		attMatricula: 'Matrícula atualizada',
		cadHabilitacao: 'Habilitação',
		cadMatriculaTitulo: 'Matrícula',
		cadNomeAluno: 'Nome Aluno',
		cadNovaMatricula: 'Nova Matrícula',
		cadNumero: 'Número',
		cadTreinamento: 'Treinamento',
		fechaMatricula: 'Matrícula encerrada',
	},
	menuAGcadPagamento: {
		addPagamento: 'Pagamento adicionado',
		attPagamento: 'Pagamento atualizado',
		cadNovoPagamento: 'Novo Pagamento',
		cadPagamentoTitulo: 'Pagamento',
		cadValor: 'Valor',
		codigoPagamento: 'Código',
		fechaPagamento: 'Pagamento finalizado',
		nomeAluno: 'Nome - Aluno',
		treinamentoHab: 'Treinamento',
	},
	menuAGcadTreinamento: {
		cadEditarTreinamento: 'Editar Treinamento',
		cadNomeTreinamento: 'Nome do Treinamento',
		cadNovoTreinamento: 'Novo Treinamento',
		cadTreinamentoAtualizado: 'Treinamento Atualizado',
		cadTreinamentoCargaHoraria: 'Carga Horária',
		cadTreinamentoCliente: 'Clique em \'Novo\'',
		cadTreinamentoDisciplina: 'Disciplinas',
		cadTreinamentoNovaDisciplina: 'Adicionar Nova Disciplina',
		cadTreinamentoPratico: 'Prático',
		cadTreinamentoSecretaria: 'Escola de voo',
		cadTreinamentoSucesso: 'Treinamento Adicionado',
		cadTreinamentoTeorico: 'Teórico',
		cadTreinamentoTitulo: 'Treinamento',
		cadTreinamentoValorTeorico: 'valor teorico',
		cadTreinamentomenuMtexto2: 'Clique no ícone',
		cadTreinamentomenuMtexto3: 'na lista ao lado.',
		cadValorTreinamento: 'Valor do Treinamento',
		disciplinaAvaliativa: 'Esta Disciplina é avaliativa?',
		frequenciaParaAprov: 'Frequência para aprovação',
		notaMinimalParaAprov: 'Nota mínima para aprovação',
	},
	menuAGinspecao: {
		menuAGaAeronave: 'de Aeronaves',
		menuAGatualizado: 'Inspeção atualizada com sucesso.',
		menuAGcCiclo: 'Ciclo',
		menuAGdadosInspecao: 'Dados da Inspeção',
		menuAGdescInspecao: 'Descrição da inspeção',
		menuAGeditarInspecao: 'Editar Inspeção',
		menuAGgInspecao: 'Grupo Inspeção',
		menuAGhHomem: 'Hora/Homem',
		menuAGiAnos: 'Anos',
		menuAGiDescricao: 'Descrição',
		menuAGiDias: 'Dias',
		menuAGiHoras: 'Horas',
		menuAGiInspecao: 'Inspeção',
		menuAGiMeses: 'Meses',
		menuAGinserido: 'Inspeção adicionada com sucesso.',
		menuAGmInspecao: 'Modelo',
		menuAGmodelAeronave: 'Modelo',
		menuAGnInspecao: 'Natureza',
		menuAGnovaInspecao: 'Nova Inspeção',
		menuAGnumPeca: 'Número Peça',
		menuAGnumSerie: 'Número Série',
		menuAGtInspecao: 'Tipo',
		menuAGtextoI1: 'Clique em \'Nova Inspeção\'',
		menuAGtextoI2: 'Clique no ícone',
		menuAGtextoI3: ' na lista ao lado.',
		menuAGvidaUtil: 'Vida Útil da Inspeção',
	},
	menuAGnovaEscala: {
		menuAGbusca: 'busca',
		menuAGcarregar: 'Carregar',
		menuAGtipoEscala: 'Tipo',
	},
	menuAGnovoCargo: {
		menuAGaddCargo: 'Cargo inserido',
		menuAGattCargo: 'Cargo atualizado',
		menuAGcadCargo: 'Novo Cargo',
		menuAGcadCargo2: 'Registro de cargo',
		menuAGdescCargo: 'Descrição',
		menuAGdescCargo2: 'Descrição do cargo',
		menuAGeditCargo: 'Editar Cargo',
		menuAGtexto1: 'Clique em \'Novo\'',
		menuAGtexto2: 'Clique no ícone',
		menuAGtexto3: ' na lista ao lado.',
	},
	menuAGnovoGrupo: {
		cadGrupoTitulo: 'Grupo de Inspeção',
		menuAGaddGrupo: 'Grupo inserido',
		menuAGattGrupo: 'Grupo atualizado',
		menuAGcadGrupo: 'Grupo de Inspeção',
		menuAGdescGrupo: 'Descrição',
		menuAGdescGrupo2: 'Descrição do grupo',
		menuAGeditGrupo: 'Editar Grupo',
		menuAGtextoG1: 'Clique em \'Novo\'',
		menuAGtextoG2: 'Clique no ícone',
		menuAGtextoG3: ' na lista ao lado.',
		naturezaManutencao: 'Natureza De Manutenção',
	},
	menuAGnovoOrgao: {
		cadOrgaoTitulo: 'Cadastro de Órgão',
		menuAGaddOrgao: 'Órgão inserido',
		menuAGattOrgao: 'Órgão atualizado',
		menuAGcadOrgao: 'Novo Órgão',
		menuAGdescOrgao: 'Descrição',
		menuAGdescOrgao2: 'Descrição do órgão',
		menuAGeditOrgao: 'Editar Órgão',
		menuAGtextoG1: 'Clique em \'Novo\'',
		menuAGtextoG2: 'Clique no ícone',
		menuAGtextoG3: ' na lista ao lado.',
	},
	menuAGnovoPosto: {
		menuAGaddPosto: 'Posto inserido',
		menuAGattPosto: 'Posto atualizado',
		menuAGcadPosto: 'Novo Posto',
		menuAGdescPosto: 'Descrição do posto',
		menuAGeditPosto: 'Editar Posto',
		menuAGtexto1: 'Clique em \'Novo\'',
		menuAGtexto2: 'Clique no ícone',
		menuAGtexto3: ' na lista ao lado.',
	},
	menuAGnovoUsuario: {
		menuAGacesso: 'Acesso ao sistema',
		menuAGanac: 'Código ANAC',
		menuAGbairro: 'Bairro',
		menuAGbase: 'Base',
		menuAGbranco: 'Em branco, mantém a mesma senha.',
		menuAGcadUser: 'Novo Usuário',
		menuAGcadastroUsuario: 'Cadastro de usuários',
		menuAGcargo: 'Cargo',
		menuAGcargo2: 'Cargo',
		menuAGcel1: 'Celular 1',
		menuAGcel2: 'Celular 2',
		menuAGcelular: 'Celular',
		menuAGcep: 'CEP',
		menuAGcidade: 'Cidade',
		menuAGcomplemento: 'Complemento',
		menuAGcpf: 'CPF',
		menuAGdadosCadastrais: 'Dados Cadastrais',
		menuAGdepto: 'Departamento',
		menuAGdesejaExcluir: 'Deseja EXCLUIR esse usuário?',
		menuAGeditarUsuario: 'Editar usuário',
		menuAGemail: 'E-mail',
		menuAGestado: 'Estado',
		menuAGexcluir: 'Excluir usuário',
		menuAGguarnicao: 'Faz parte da guarnição?',
		menuAGguarnicao2: 'Guarnição',
		menuAGid: 'Identidade',
		menuAGlogin: 'Login',
		menuAGlogradouro: 'Logradouro',
		menuAGmarcarTodos: 'Marcar Todos',
		menuAGmatricula: 'Matrícula',
		menuAGnao: 'Não',
		menuAGnome: 'Nome',
		menuAGnomeGuerra: 'Nome de Guerra',
		menuAGnum: 'Número',
		menuAGnumOrdem: 'Número de Ordem',
		menuAGorgao: 'Órgão',
		menuAGposto: 'Posto/Graduação',
		menuAGprivilegio: 'Privilégios do sistema',
		menuAGremover: 'Remover todos os privilégios',
		menuAGsenha: 'Senha',
		menuAGsim: 'Sim',
		menuAGsistema: 'Possui acesso ao sistema?',
		menuAGtel1: 'Telefone 1',
		menuAGtel2: 'Telefone 2',
		menuAGtipo: 'Tipo',
		menuAGtipoCertificado: 'Tipo Certificado',
		menuAGusuarioAdicionado: 'Usuário adicionado com sucesso.',
		menuAGusuarioAtualizado: 'Usuário atualizado com sucesso.',
		menuAGusuarioExcluido: 'Usuário excluído cmenuAGinspecaoom sucesso.',
		menuAGvalidadeCertificado: 'Validade Certificado',
		msgPrivilegio: 'Deseja Adicionar mais privilégios?',
		pClasse: '1ª Classe',
		sClasse: '2ª Classe',
		tClasse: '3ª Classe',
	},
	menuAGpermutas: {
		menuAGaeronave: 'Aeronave envolvida',
		menuAGchefiaEspecial: 'Chefia Especial da Área de Segurança Pública - CAESP',
		menuAGcidade: 'Cidade',
		menuAGconclusao: 'Conclusão',
		menuAGdata: 'Data',
		menuAGemail: 'E-mail',
		menuAGenvolvidos: 'Envolvidos',
		menuAGestado: 'Estado',
		menuAGfim: 'Fim',
		menuAGinicio: 'Início',
		menuAGlocal: 'Local',
		menuAGnome: 'Nome',
		menuAGparecer: 'Parecer',
		menuAGresposta: 'Resposta',
		menuAGresposta2: 'Resposta',
		menuAGsalvo: 'Salvo com sucesso!',
		menuAGsecretariaAlagoas: 'Secretaria de Estado de Segurança Pública do Alagoas',
		menuAGsituacao: 'Situação',
		menuAGsolicitado: 'Solicitado',
		menuAGtel: 'Telefone',
		menuAGtipo: 'Tipo',
		menuAGtipo2: 'Tipo',
	},
	menuAGplanoManutencao: {
		boletins: 'Boletins',
		comprimentoDeBoletins: 'CUMPRIMENTO DE BOLETINS DE AERONAVEGABILIDADE',
		comprimentodeBoletinsServico: 'CUMPRIMENTO DE BOLETINS DE SERVIÇOS',
		controleDeComponentesCeula: 'CONTROLE DE COMPONENTES',
		controleDeComponentesMotor: 'CONTROLE DE COMPONENTES',
		inspecoesAcessoriosMotor: 'INSPEÇÕES PROGRAMADAS DE ACESSÓRIOS',
		inspecoesProgramadas: 'INSPEÇÕES PROGRAMADAS',
		inspecoesProgramadasEquipamento: 'INSPEÇÕES PROGRAMADAS DE EQUIPAMENTOS',
		inspecoesProgramadasMotor: 'INSPEÇÕES PROGRAMADAS',
		inspecoesRegulamentares: 'INSPEÇÕES REGULAMENTARES',
		manuAGNenhumaEncontrada: 'Nenhuma inspeção encontrada.',
		menuAGInspecaoAtualizada: 'Inspeções atualizadas.',
		menuAGaddInspecao: 'Adicionar Inspeção ao Plano',
		menuAGaddTodas: 'Adicionar Todas',
		menuAGcelula: 'Célula',
		menuAGdetalhes: 'Detalhes',
		menuAGinspDetalhe: 'Detalhes da Inspeção',
		menuAGinspecao: 'Inspeção',
		menuAGinspecoes: 'Inspeções',
		menuAGmodelo: 'Modelo',
		menuAGmotor: 'Motor',
		menuAGpeca: 'Peça',
		menuAGperiodicidade: 'Periodicidade',
		menuAGplano: 'Plano de Manutenção',
		menuAGremoveTodas: 'Remover Todas',
		menuAGserie: 'Série',
		revalidacoes: 'REVALIDAÇÕES E CERTIFICAÇÕES',
	},
	menuAGprevencao: {
		menuAGNovaPrevencao: 'Nova Prevenção',
		menuAGaeronave: 'Aeronave',
		menuAGaeronave2: 'Aeronave',
		menuAGcidade: 'Cidade',
		menuAGcidade2: 'Cidade',
		menuAGconcluir: 'Concluir prevenção',
		menuAGconclusao: 'Descrição da conclusão',
		menuAGdataOcorrencia: 'Data da Ocorrência',
		menuAGdescricao: 'Descrição',
		menuAGemail: 'E-mail',
		menuAGenvolvidos: 'Pessoal Envolvido',
		menuAGlocal: 'Local da Ocorrência',
		menuAGpPrevencao: 'Prevenção',
		menuAGprevencaoConcluida: 'Prevenção concluída.',
		menuAGrelato: 'Relato de Prevenção',
		menuAGrelatoOcorrencia: ' O relato da ocorrência aqui apresentado tem como única finalidade o incentivo à segurança operacional, portanto, o seu uso destina-se exclusivamente, à prevenção de acidentes. NÃO HÁ NECESSIDADE DE SER ASSINADO OU IDENTIFICADO',
		menuAGrelator: 'Relator',
		menuAGrelatorio: 'Relatório de Prevenção',
		menuAGrelatorioAdicionado: 'Relatório adicionado com sucesso.',
	},
	menuAGstatus: {
		cadStatusTitulo: 'Cadastro de Status',
		menuAGaddStatus: 'Status adicionado',
		menuAGattStatus: 'Status atualizado',
		menuAGcadStatus: 'Novo Status',
		menuAGcadStatus2: 'Novo status',
		menuAGdescStatus: 'Descrição',
		menuAGdescStatus2: 'Descrição do status',
		menuAGeditStatus: 'Editar status',
		menuAGtexto1: 'Clique em \'Novo\'',
		menuAGtexto2: 'Clique no ícone',
		menuAGtexto3: ' na lista ao lado.',
		obrigaStatus: 'Exigir que insira uma observação ao selecionar esse status?',
	},
	menuAGtipoAfastamento: {
		cadAfastamentoTitulo: 'Cadastro de Afastamento',
		menuAGaddAfastamento: 'Afastamento inserido',
		menuAGattAfastamento: 'Afastamento atualizado',
		menuAGcadAfastamento: 'Novo Afastamento',
		menuAGdescAfastamento: 'Descrição',
		menuAGdescAfastamento2: 'Descrição do afastamento',
		menuAGeditAfastamento: 'Editar Afastamento',
		menuAGtextoG1: 'Clique em \'Novo\'',
		menuAGtextoG2: 'Clique no ícone',
		menuAGtextoG3: ' na lista ao lado.',
	},
	menuAGtipoGuarnicao: {
		cadGuarnicaoTitulo: 'Cadastro de Guarnição',
		menuAGaddGuarnicao: 'Guanição adicionada',
		menuAGattGuarnicao: 'Guarnição atualizada',
		menuAGcadGuarnicao: 'Nova Guarnição',
		menuAGdescGuarnicao: 'Descrição',
		menuAGdescGuarnicao2: 'Descricão da guarnição',
		menuAGeditGuarnicao: 'Editar Guarnição',
		menuAGgOrdem: 'Ordem',
		menuAGgSigla: 'Sigla',
		menuAGtexto1: 'Clique em \'Nova\'',
		menuAGtexto2: 'Clique no ícone',
		menuAGtexto3: ' na lista ao lado.',
	},
	menuAGtipoMissao: {
		cadMissaoTitulo: 'Cadastro de Tipo de Missão',
		menuAGaddMissao: 'Missão inserida',
		menuAGattMissao: 'Missão atualizada',
		menuAGcadMissao: 'Nova Missão',
		menuAGdescMissao: 'Descrição',
		menuAGdescMissao2: 'Descrição da missão',
		menuAGeditMissao: 'Editar Missão',
		menuAGtexto1: 'Clique em \'Nova\'',
		menuAGtexto2: 'Clique no ícone',
		menuAGtexto3: ' na lista ao lado.',
	},
	menuAGtipoNatureza: {
		cadNaturezaTitulo: 'Cadastro de Natureza do Voo',
		menuAGaddNatureza: 'Natureza adicionada',
		menuAGattNatureza: 'Natureza atualizada',
		menuAGcadNatureza: 'Nova Natureza',
		menuAGdescNatureza: 'Descrição',
		menuAGdescNatureza2: 'Descricão da natureza',
		menuAGeditNatureza: 'Editar Natureza',
		menuAGnSigla: 'Sigla',
		menuAGtexto1: 'Clique em \'Nova\'',
		menuAGtexto2: 'Clique no ícone',
		menuAGtexto3: ' na lista ao lado.',
	},
	menuAGtipoOcorrencia: {
		cadOcorrenciaTitulo: 'Cadastro de Ocorrência',
		menuAGaddOcorrencia: 'Ocorrência inserida',
		menuAGattOcorrencia: 'Ocorrência atualizada',
		menuAGcadOcorrencia: 'Nova Ocorrência',
		menuAGdescOcorrencia: 'Descrição',
		menuAGdescOcorrencia2: 'Descrição da ocorrência',
		menuAGeditOcorrencia: 'Editar Ocorrência',
		menuAGtexto1: 'Clique em \'Nova\'',
		menuAGtexto2: 'Clique no ícone',
		menuAGtexto3: ' na lista ao lado.',
	},
	menuAGtipoPrioridade: {
		cadPrioridadeTitulo: 'Cadastro de Prioridade',
		menuAGaddPrioridade: 'Prioridade inserida',
		menuAGattPrioridade: 'Prioridade atualizada',
		menuAGcadPrioridade: 'Nova Prioridade',
		menuAGdescPrioridade: 'Descrição',
		menuAGdescPrioridade2: 'Descrição da prioridade',
		menuAGeditPrioridade: 'Editar Prioridade',
		menuAGtexto1: 'Clique em \'Nova\'',
		menuAGtexto2: 'Clique no ícone',
		menuAGtexto3: ' na lista ao lado.',
	},
	menuAdicionarPerfil: {
		paraAdicionar: 'Para adicionar um perfil',
		selecionePerfil: 'selecione o perfil e clique em ADD',
	},
	menuAfastamento: {
		menuAadicionado: 'Pedido adicionado com sucesso.',
		menuAaprovar: 'Aprovar',
		menuAatualizado: 'Pedido atualizado com sucesso.',
		menuAreprovar: 'Reprovar',
		tipo: 'Tipo',
	},
	menuArapiraca: {
		menuAescala: 'Carregando escala arapiraca',
		menuAnpg: 'Nome - Post/Grad',
		menuAsalvo: 'Salvo',
	},
	menuCadCiv: {
		CivAtualizado: 'CIV atualizada',
		CivRemovida: 'CIV removida com sucesso',
		CivSucesso: 'CIV adicionada',
		cadCiv: 'Cadastro de CIV',
		pilotoParticipante: 'Piloto Participante',
	},
	menuCadHabilitacao: {
		EditarHabi: 'Editar Habilitação',
		HabiAtualizado: 'Habilitação Atualizada',
		HabiCliente: 'Clique em \'Nova\'',
		HabiDescricao: 'Descrição',
		HabiSecretaria: 'Escola de voo',
		HabiSucesso: 'Habilitação Adicionada',
		HabiTexto1: 'Clique no ícone',
		HabiTexto2: 'na lista ao lado.',
		HabiTitulo: 'Habilitação',
		NovoHabi: 'Nova Habilitação',
	},
	menuCadPacote: {
		EditarPacote: 'Editar Investimento',
		NovoPacote: 'Novo Investimento',
		PacoteAtualizado: 'Investimento Atualizado',
		PacoteCliente: 'clique em \'Novo\'',
		PacoteDescricao: 'Descrição',
		PacoteNumeroHoras: 'Carga Horária',
		PacotePratico: 'Prático',
		PacoteSecretaria: 'Escola de voo',
		PacoteSucesso: 'Investimento Adicionado',
		PacoteTeorico: 'Teórico',
		PacoteTexto1: 'Clique no ícone',
		PacoteTexto2: 'na lista ao lado.',
		PacoteTitulo: 'Investimento',
		ValorPacote: 'Valor do Investimento',
	},
	menuConfiguracao: {
		emailAssunto: 'Assunto do e-mail',
		emailTexto: 'Texto do e-mail',
		pessoasNotificadas: 'Pessoas Notificadas',
		sms: 'Texto do SMS',
	},
	menuDiscrepancia: {
		discrepanciaCancelada: 'Discrepância Cancelada',
	},
	menuEdicaoDiario: {
		horimetroFinal: 'Horimetro Final Manutenção',
		horimetroInicial: 'Horimetro Inicial Manutenção',
		nenhumEmpenhoAdicionado: 'Nenhum Empenho Adicionado',
		nenhumMotorAdicionado: 'Nenhum motor adicionado',
		tempoDeVoo: 'Tempo De Voo',
	},
	menuErro: {
		menuEtitulo: 'Ops!',
		menuEtitulo2: 'Oh-ou!',
		menuTextoErro: 'Aconteceu alguma coisa errada ao tentar fazer essa ação.',
		menuTextoErro2: 'Algo me diz que você não pode efazer isso.',
	},
	menuEscala: {
		copilotos: 'Copilotos',
		menuCarregaEscala: 'Carregando escala',
		menuElegenda: 'Legenda',
		menuElegenda1: 'Legenda',
		menuEnovaLegenda: 'Nova Legenda',
		menuEtotalDia: 'Total de serviços por dia',
		menuEvermelho: 'Corrija os campos em vermelho.',
		menuRemover: 'Remover',
		menuSalvaEscala: 'Salvo',
		pilotoEcopiloto: 'Piloto e Copiloto',
		pilotos: 'Pilotos',
		radioOperador: 'Rádio Operador',
		secaoManutencao: 'Seção de Manutenção',
		sessaoManutencao: 'Seção de Manutenção',
		tripulanteArapiraca: 'Tripulante Arapiraca',
		tripulanteMaceio: 'Tripulante Maceió',
		tripulanteOperacional: 'Tripulante Operacional',
	},
	menuMaceio: {
		menuMmaceio: 'Carregando escala Maceió',
		menuMnpg: 'Nome - Post/Grad',
		menuMsalvo: 'Salvo',
		menuMtripulante: 'Tripulante já adicionado.',
	},
	menuMalha: {
		editarSemana: 'Editar semana',
		gestaoMalha: 'Gestão Malha',
		novaSemana: 'Nova Semana',
	},
	menuManutencao: {
		menuMapoio: 'Apoio Solo',
		menuMapu: 'APU',
		menuMasaFixa: 'Ciclo de Motor',
		menuMatualizaManutencao: 'Atualizar Manutenção',
		menuMatualizada: 'Manutenção atualizada com sucesso',
		menuMcelula: 'Célula',
		menuMciclon1: 'Ciclo N1',
		menuMciclon2: 'Ciclo N2',
		menuMciclosCSN: 'Ciclos CSN',
		menuMciclosNG: 'Ciclos NG',
		menuMciclosT1: 'Ciclos NF',
		menuMcodinome: 'Codinome',
		menuMcontrolComp: 'Controle de Componentes',
		menuMcontrolCompDE: 'Controle de componentes de',
		menuMctm: 'C T M',
		menuMdataPrevista: 'Data Prevista',
		menuMdescricao: 'Descrição',
		menuMdetalhes: 'Atualizar',
		menuMdisponibilidade: 'Disponibilidade',
		menuMescolha: 'Escolha uma opção',
		menuMeventos: 'Eventos',
		menuMf: 'F - FÉRIAS',
		menuMhHomemHora: 'Homens/Hora',
		menuMhorasAtuais: 'Horas Atuais',
		menuMhorasTotais: 'Horas Totais',
		menuMhrsAtuais: 'Horas Atuais',
		menuMinspProg: 'Inspeções Programadas',
		menuMinspProgDE: 'Inspeções programadas de',
		menuMinspProgEquip: 'Inspeções Programadas de Equipamentos',
		menuMinspReg: 'Inspeções Regulamentares',
		menuMmodelo: 'Modelo',
		menuMmotor: 'Motor',
		menuMnumSerie: 'Nº Série',
		menuMpousosAtuais: 'Pousos Atuais',
		menuMrevalidaC: 'Revalidações e Certificações',
		menuMtecnico: 'Técnico de manutenção',
		menuMtotal: 'Total',
		menuMx: 'X - ESTÁ ESCALADO',
		menuNivel: 'Nível',
		menuTipo: 'Tipo',
		menuUltimaDataAtualizacao: 'Data ultima Atualização',
	},
	menuMatricula: {
		assinaturaAluno: 'ASSINATURA DO ALUNO(A)',
		atestadoBonsAntecedentes: 'Atestado de Bons Antecedente',
		cadastroAPU: 'Cadastro APU',
		cadastroCombustiveis: 'Cadastro combustíveis',
		cadastroConfigAeronave: 'Cadastro Configurações da Aeronave',
		candidadoEstrangeiro: 'Candidato Estrangeiro?',
		cartaoIdentidade: 'Cartão de Identidade',
		carteriaIdentidadeEstrangeirosValidade: 'Carteira de identidade para estrangeiros com validade de permanência',
		casoPossuaLicenca: 'Caso Possua licença',
		certidaoCapacidadeFisisca: 'Certidão de Capacidade Física',
		certidaoEscolaridade: 'Certidão de Escolaridade',
		cfg: 'Configuração',
		copiaCertificadoEscolaridadeEstrangeiro: 'Cópia do certificado de escolaridade (traduzido oficialmente) do ensino fundamental',
		copiaDocumentoViagem: 'Cópia do Documento de Viagem',
		copiaLicencaAtividade: 'Cópia da licença da atividade específica ou documento equivalente (traduzido oficialmente)',
		cpf: 'CPF',
		declaracaoSubJudice: 'Declaração do requerimento de que não se encontra SUB-JUDICE',
		documentacaoApresentada: 'Documentação Apresentada (Candidatos)',
		documentacaoApresentadaEstrangeiros: 'Documentação Apresentada (Candidatos Estrangeiros)',
		excluirPontoInteresse: 'EXCLUIR PONTO DE INTERESSE',
		exibirMatricula: 'Exibir Matrícula',
		farol: 'Farol',
		informacoesMatricula: 'Informações sobre a inscrição',
		matriculaSalva: 'Matrícula Salva com sucesso!',
		naoSalva: 'Não Salva',
		numeroMatricula: ' Número da Matricula',
		permissaoResidencia: 'Permissão de Residência',
		qtdDias: 'Qtd. Dias',
		requerimentoDoCantidado: 'Requerimento do Candidato',
		responsavelMatricula: 'RESPONSÁVEL PELA MATRÍCULA',
		termoMatricula: 'Termo de Matrícula',
		termoTexto: 'DECLARO QUE ESTE(A) ALUNO(A) ENCONTRA-SE MATRICULADO(A) NESTE TREINAMENTO, A PARTIR DE <strong>{{dataMatricula}}</strong>, MÁTRICULA <STRONG>{{matricula}}</strong>, JÁ TENDO SIDO ENTREGUES AS CÓPIAS DA DOCUMENTAÇÃO EXIGIDA, ACOMPANHADAS DE <STRONG>{{qtd4x4}}</STRONG> RETRATOS 3X4.',
		tipos: 'Tipos',
		tituloEleitor: 'Título de Eleitor',
		unidadeArmazenamento: 'Unidade de Armazenamento',
	},
	menuMoficina: {
		cadOficinaTitulo: 'Cadastro de Oficinas',
		menuMaddOficina: 'Oficina adicionada',
		menuMattOficina: 'Oficina atualizada',
		menuMcadOficina: 'Nova Oficina',
		menuMeditOficina: 'Editar Oficina',
		menuMresponsavel: 'Responsável',
		menuMtexto1: 'Clique em \'Nova Oficina\'',
		menuMtexto2: 'Clique no ícone',
		menuMtexto3: ' na lista ao lado.',
	},
	menuMonitoramento: {
		horaDia: 'Hora/Dia',
		horaMes: 'Hora/Mês',
		menuAeronaveNaoVoou: 'A aeronave ainda não voou hoje.',
		menuMonitora: 'Monitoramento',
		menuMonitoraAeronaves: 'Aeronaves',
		menuTempoReal: 'Tempo Real',
		nenhumaManutencao: 'Nenhuma manutenção programada.',
		totalCiclosVoadios: 'Total de ciclos voados',
		voosDia: 'Voos do dia',
	},
	menuMsolicitaManutencao: {
		menuMsolicitaAdd: 'Solicitação de Manutenção Atualizada.',
		menuMsolicitaAtt: 'Solicitação de Manutenção Inserida.',
		menuMsolicitaCancelar: 'Deseja Cancelar essa Solicitação de Manutenção?',
		menuMsolicitaDisponibilidade: 'Disponibilidade',
		menuMsolicitaEscolha: 'Escolha as inspeções abaixo',
		menuMsolicitaEvento: 'Evento',
		menuMsolicitaHhora: 'Homens Hora',
		menuMsolicitaHtotais: 'Horas Totais',
		menuMsolicitaInspecoes: 'Inspeções',
		menuMsolicitaManutencoes: 'Solicitações de manutenção',
		menuMsolicitaMesesDias: 'Meses / Dias',
		menuMsolicitaModalidade: 'Modalidade',
		menuMsolicitaNivel: 'Nível',
		menuMsolicitaProxInspecao: 'Próxima Inspeção',
		menuMsolicitaReferente: 'Solicitações referente a aeronave',
		menuMsolicitaSelecione: 'Selecione uma ou mais inspeções abaixo e clique em ADICIONAR',
		menuMsolicitaTipo: 'Tipo',
	},
	menuOpRadio: {
		carregando: 'Carregando escala rádio operador',
	},
	menuOrdemMissao: {
		menuMissao: 'Missão',
		menuNova: 'Nova',
		menuNovaOrdem: 'Nova Ordem',
		menuOrdem: 'Ordem',
		menuOrdemEscolha: 'Escolha',
		menuOrdemSolicitacao: 'Solicitação',
		menuOrdemmissao: 'Ordem Missão',
	},
	menuOrgaoApoiados: {
		orgao: 'Orgão',
		orgaoApoiados: 'Orgão Apoiado',
		orgaoCadastro: 'Cadastrar Orgão',
		orgaosApoiados: 'Orgãos Apoiados',
	},
	menuRGestatisticaVoo: {
		menuAeronave: 'Aeronave',
	},
	menuRGhorasVoadas: {
		menuRGaeronave: 'Aeronave',
		menuRGdataFim: 'Data Fim',
		menuRGdataInicio: 'Data Início',
		menuRGhorasReportadas: 'Horas Reportadas',
		menuRGou: 'Ou',
		menuRGrelatorio: 'Este relatório tem fins operacionais, podendo gerar diferença para mais ou para menos no total de horas voadas se comparado com o diário de bordo.',
	},
	menuRGoperacoes: {
		menuAeronave: 'Aeronave',
		menuRGcomb: 'Comb.',
		menuRGde: 'De',
		menuRGpara: 'Para',
		menuRGpartida: 'Partida',
		menuRGpax: 'Pax.',
		menuRGpousos: 'Pousos',
		menuRGtdec: 'T Dec',
		menuRGtipo: 'Tipo',
		menuRGtvoo: 'T Voo',
		menuRelatorioOp: 'Relatório de Operações',
		menuTipo: 'Tipo',
	},
	menuRGordemmissao: {
		menuOMadicionados: 'Adicionados',
		menuOMcargo: 'Cargo',
		menuOMcoordenador: 'Coordenador',
		menuOMdataInicio: 'O período de Ordem de Missão deve estar entre o período da Solicitação.',
		menuOMdataMaior: 'A data início não pode ser maior que a data fim.',
		menuOMemail: 'E-mail',
		menuOMenviar: 'Enviar e salvar',
		menuOMescolha: 'Escolha',
		menuOMfim: 'Fim',
		menuOMguarnicao: 'Guarnição Aérea',
		menuOMinicio: 'Início',
		menuOMlotacao: 'Lotação',
		menuOMmissao: 'Ordem de missão',
		menuOMnaoDisponivel: 'não disponível nesse momento.',
		menuOMnome: 'Nome',
		menuOMoperacao: 'Operação',
		menuOMordemAdicionada: 'Ordem adicionada com sucesso.',
		menuOMordemAtualizada: 'Ordem atualizada com sucesso.',
		menuOMordemEncerrada: 'Ordem encerrada com sucesso.',
		menuOMorgao: 'Órgão',
		menuOMprioridade: 'Prioridade',
		menuOMsemdados: 'Nenhum dado encontrado.',
		menuOMtelefone: 'Telefone',
		menuOMtripulantes: 'Tripulantes',
	},
	menuRGsolicitacoes: {
		menuRGnome: 'Nome',
		menuRGoperacao: 'Operação',
		menuRGorgao: 'Órgão',
		menuRGprioridade: 'Prioridade',
		menuRGrSolicitacoes: 'Relatório de Solicitações',
		menuRGsemdados: 'Nenhum dado encontrado.',
		menuRGsolicitacao: 'Solicitações',
	},
	menuRastreamento: {
		menuRastrea: 'Rastreamento',
		menuRastreaAeronave: 'Aeronave',
		menuRmudar: 'Mudar',
		menuRtotal: 'Total',
	},
	menuSegurancaOperacional: {
		acaoesMitigatorias: 'Ações Mitigatórias',
		acaoesadicionaisMitigatorias: 'Informações adicionais sobre ações mitigatórias',
		acesso: 'Acesso',
		acionadoOrgaosExternos: 'Houve acionamento dos órgãos externos componentes do <PRE-XXX> e/ou do <PLEM-SXXX>?',
		acoesForamSuficienteFinal: 'Ações mitigadoras foram suficiente?',
		acoesMitigadoras: 'Ações Mitigadoras',
		acoesimplementadas: 'Ações mitigatórias implementadas',
		acoessuficientes: 'Ações mitigatórias foram suficientes',
		acsp: 'Atividade criminal ou uso sw substância proibida',
		analiseEvento: 'Análise do Evento',
		analiseExecucao: 'Análise do evento de ESO',
		analiseFinal: 'Análise Final',
		analiseInicial: 'Análise Inicial',
		ccf: 'Certificado de capacidade técinca - CCF',
		ceanac: 'Certificado emitido pela ANAC',
		cht: 'Certificado de habilitação técnica - CHT',
		cliente: 'Cliente',
		codigo: 'Código',
		codigoControleInterno: 'Código de Controle Interno',
		codigoESO: 'Código ESO',
		codigoOACI: 'Código OACI',
		comoFoiAcionado: 'Como foi acionado',
		condicoesEmQue: 'Condições em que',
		coordenador: 'Coordenador Responsável',
		dataDoOcorrido: 'Data do ocorrido',
		dataEso: 'Data',
		dataOcorrido: 'Data Ocorrido',
		deficienciasIdentificadas: 'Deficiências encontradas nas informações',
		deficienciasPorFaltaRecursos: 'Deficiências identificadas',
		descricao: 'Descrição',
		descricaoEvento: 'Descrição do Evento',
		descricaoSimplificada: 'Descrição Simplificada',
		disponibilizacaoAcomodacoes: 'Houve a disponibilização de acomodações aos familiares e ao público, em geral?',
		documentoOrigem: 'Documento Origem',
		empresa: 'Empresa',
		encaminhado: 'Encaminhado em',
		encaminharEso: 'Encaminhar ESO a ANAC',
		enviarApreciacao: 'Enviar resposta ao resp. pela Apreciação',
		enviarRelator: 'Enviar reposta ao relator',
		evacuacaoTripulantes: 'Descrição da evacuação dos tripulantes/passageiros',
		eventoOperacionalRelatadoAspectos: 'O evento de segurança operacional (ESO) relatado envolve um dos seguintes aspectos',
		executivo: 'Executivo',
		exemplar: 'Exemplar ',
		existiaExemplar: 'Existia exemplar ',
		fase: 'Fase',
		faseApreciacao: 'Fase de Apreciação concluída',
		faseExecucao: 'Fase de Execução concluída',
		faseInclusao: 'Fase de Inclusão concluída',
		fatoresContribuintes: 'Fatores Contribuintes',
		foramAdequados: ' foram adequados e suficientes para a desinterdição da pista?',
		gestorSegurancaOperacional: 'Gestor de Segurança Operacional',
		hora: 'Horas',
		horaDoOcorrido: 'Hora do ocorrido',
		houveDerramamentoCombustivel: 'Houve derramamento de combustível, ou óleo, na pista, ou local da ocorrência?',
		identificacao: 'Identificação',
		identifiqueAsCargas: 'Identifique as cargas perigosas presentes no evento:',
		incidencia: 'Incidências',
		informacoesAtenderam: 'Informações atenderam as necessidades?',
		informante: 'Quem informou',
		localDoOcorrido: 'Local do evento',
		localEvento: 'Local do evento',
		motivosAcoesNaoSuficiente: 'Motivos de não suficiência',
		nao: 'Não',
		notificar: 'Notificar para execução após concluir a apreciação',
		notificarCoordenador: 'Notificar coordenador após inclusão concluída',
		novo: 'Novo',
		numero: 'Número',
		numeroDocumentoOrigem: 'Nº do Documento de Origem',
		opcoes: 'Opções',
		organizacoesEnvolvidas: 'Organizações Envolvidas',
		orgaosEnvolvidos: 'Orgãos externos envolvidos',
		outrasInformacoes: 'Outras informações',
		paralisacaoOperacoes: 'Houve a paralisação das operações?',
		pistaInterditada: 'A pista foi interditada?',
		prazoEnvia: 'Prazo envio a ANAC',
		quaisAcoesAdicionaisAdotadas: 'Quais as ações adicionais a serem adotadas?',
		questionarioGestorSegurancaOperacional: 'Sobre o Gestor de Segurança Operacional',
		recursosDisponiveis: 'Os recursos disponíveis no ',
		remetente: 'Nome do Remetente',
		responasavelExecucoes: 'Responsável pelas ações',
		responsavelApreciacao: 'Responsável pela Apreciação',
		respostaEnviadaAoRelator: 'Resposta Enviada ao Relator?',
		setores: 'Setores',
		setoresResponsaveis: 'Setores responsáveis pela mitigação',
		sim: 'Sim',
		situacao: 'Situacao',
		situacaoRelatada: 'Situação Relatada',
		tempoPistaInterditada: 'Tempo de pista interditada',
		tempoRetomadaOperacoes: 'Tempo em que operações voltaram à normalidade',
		tipoSituacao: 'Tipo de Situação',
	},
	menuSistema: {
		suporteTecnico: 'Suporte Tecnico',
		usuarioSistema: 'Usuario do Sistema',
	},
	menuSolicitaApoio: {
		apoioAereo: 'Apoio aéreo',
		codigoPnapa: 'Código Pnapa',
		corrigirCampos: 'Por favor, corrija os campos em vermelho acima.',
		dadosAtualizados: 'Dados atualizados com sucesso!',
		destino: 'Destino',
		escolhaArquivo: 'Escolha um arquivo e clique em carregar.',
		escolherLocal: 'Você precisa escolher pelo menos um local.',
		menuCargo: 'Cargo',
		menuCoordenador: 'Coordenador Solo',
		menuCoordenadorSolo: 'Coordenador Solo',
		menuDataEfim: 'A data início e fim são obrigatórias.',
		menuEscolha: 'Escolha',
		menuFimOperacao: 'Data Fim Operação',
		menuGrauPrioridade: 'Grau de prioridade',
		menuInicioOperacao: 'Data Início Operação',
		menuLocalOperacao: 'Local da Operação',
		menuMissaoApoio: 'Missão de apoio',
		menuNomeOperacao: 'Nome da Operação',
		menuNovaSolicitacao: 'Nova Solicitação',
		menuOrgaoSolicitante: 'Órgão Solicitante',
		menuSolicitaNova: 'Nova',
		menuSolicitacao: 'Solicitação',
		menuTipoOcorrencia: 'Tipo da Ocorrência',
		naturezaEtipo: 'Você tem que adicionar pelo menos uma Natureza e Tipo.',
		novaOrdemMissao: 'Nova Ordem de Missão',
		ordemMissaoInserida: 'Nova ordem de missão inserida com sucesso.',
		partida: 'Partida',
		removidos: 'Todos removidos.',
		solicitaApoio: 'Solicitação',
		solicitacaoAdicionada: 'Solicitação adicionada com sucesso.',
		solicitacaoAtualizada: 'Solicitação atualizada com sucesso.',
		statusAtualizado: 'Status atualizado com sucesso.',
	},
	menuTripOperacional: {
		carregando: 'Carregando escala operacional',
		escalaD: 'D - NORMAL',
		escalaE: 'E - EXPEDIENTE',
		escalaS: 'S - SOBREAVISO',
	},
	menuUsuarioANAC: {
		codigoAviacao: 'Codigo ANAC',
	},
	menuVoo: {
		menuVaeronave: 'Aeronave',
		menuVaerotatico: 'Op. Aerotático / Sup. Médico',
		menuVatualizaTrechos: 'Atualizar Trechos',
		menuVatualizaTrechos2: 'Ao atualizar os trechos, o sistema irá buscar todos os trechos do dia e incluí-los ao relatório de voo, trechos alterados serão mantidos.',
		menuVbaseArapiraca: 'Base Arapiraca: 3530-3518',
		menuVbaseMaceio: 'Base Maceió: 4009-2040',
		menuVcaesp: 'CAESP',
		menuVchefeCaesp: 'Chefe da CAESP: 98884-7133',
		menuVchefeOp: 'Chefe de Operações: 98824-9657',
		menuVcodigo: 'Código',
		menuVcomb: 'Comb.',
		menuVcontato: 'Contato',
		menuVcorte: 'Corte',
		menuVde: 'De',
		menuVerroVoos: 'Erro ao carregar os voos do mês.',
		menuVescolha: 'Escolha a aeronave para carregar os dias que ela voou.',
		menuVestadoAlagoas: 'Estado de Alagoas',
		menuVfechaRelatorio: 'Fechar Relatório',
		menuVhistorico: 'Histórico dos trechos',
		menuVmapa: 'Mapa dos Trechos',
		menuVmissao: 'Missão',
		menuVmodelo: 'Modelo',
		menuVnaturezaVoo: 'Natureza do Vôo',
		menuVnum: 'Nº',
		menuVnumRelatorio: 'Relatório Nº',
		menuVnumTrecho: 'Trecho Nº',
		menuVocorrencia: 'Ocorrência',
		menuVpara: 'Para',
		menuVpartida: 'Partida',
		menuVpax: 'Pax.',
		menuVpousos: 'Pousos',
		menuVprefixo: 'Prefixo',
		menuVreabreRelatorio: 'Reabrir Relatório',
		menuVrelatorio: 'Relatório de Voo',
		menuVsemMapa: 'Nenhum mapa encontrado.',
		menuVssp: 'SSP',
		menuVtdec: 'T Voo Dec',
		menuVtdesc: 'T Voo Decimo',
		menuVtipoMissao: 'Tipo de Missão',
		menuVtotal: 'Total',
		menuVtrechos: 'Trechos',
		menuVtvoo: 'T Voo',
		menuVvoo: 'T Voo',
	},
	meses: {
		abril: 'Abril',
		agosto: 'Agosto',
		dezembro: 'Dezembo',
		fevereiro: 'Fevereiro',
		janeiro: 'Janeiro',
		julho: 'Julho',
		junho: 'Junho',
		maio: 'Maio',
		marco: 'Março',
		novembro: 'Novembro',
		outubro: 'Outubro',
		setembro: 'Setembro',
	},
	nomesMes: {
		abril: 'Abril',
		agosto: 'Agosto',
		dezembro: 'Dezembro',
		fevereiro: 'Fevereiro',
		janeiro: 'Janeiro',
		julho: 'Julho',
		junho: 'Junho',
		maio: 'Maio',
		marco: 'Março',
		novembro: 'Novembro',
		outubro: 'Outubro',
		setembro: 'Setembro',
	},
	pais: {
		alemao: 'Alemão',
		brasil: 'Português',
		espanhol: 'Espanhol',
		eua: 'Inglês',
		frances: 'Francês',
		ingles: 'Inglês',
		italiano: 'Italiano',
		paraguai: 'Espanhol',
		portugues: 'Português',
	},
	perfil: {
		PerfilInserido: 'Perfil inserido',
		clickEmNovo: 'Cliente em \'Novo\'',
		editarPerfil: 'Editar Perfil',
		nomePerfil: 'Nome do Perfil',
		novoPerfil: 'Novo Perfil',
		paraAdicionar: 'para adicionar',
		perfilAtualizado: 'Perfil atualizado',
		perfilDoUsuario: 'Perfil do Usuário',
	},
	rampa: {
		adicionar: 'Adicionar',
		aeronaves: 'Aeronaves',
		cabecalhoHtml: '<h3>FISCALIZAÇÃO DE</h3><h4 style="cursor: pointer">RAMPA</h4>',
		canac: 'CANAC',
		cpf: 'CPF',
		descricao: 'Descrição',
		digiteODesignativoDesejado: 'Digite o designativo desejado',
		digiteOQueDesejaPesquisar: 'Digite o que deseja pesquisar',
		documentoComDataValida: 'Documento está dentro do prazo de validade',
		documentos: 'Documentos',
		filtrarPor: 'Filtrar por',
		menuHtml: '<div class="sub-text">FISCALIZAÇÃO DE</div><div class="sub-text">RAMPA</div>',
		naoExisteTripulantes: 'Utilize as opções acima para filtrar os tripulantes.',
		nenhumDesignativoEncontrado: 'Não existem designativos para exibição.',
		nenhumDocumentoEncontrado: 'Não existem documentos para exibição.',
		nenhumaAeronaveEncontrada: 'Não existem aeronaves para exibição.',
		publicacoes: 'Publicações',
		selecioneQuaisInformacoes: 'Selecione quais informações serão exibidas',
		selecioneUmaAeronave: 'Selecione uma aeronave',
		semDocumentosTripulante: 'Nenhum documento anexado para este tripulante.',
		status: 'Status',
		tripulacao: 'Tripulação',
		tripulante: 'Tripulante',
		tripulantes: 'Tripulantes',
		ultimoDespachoDoVoo: 'Último Despacho do Voo',
		validade: 'Validade',
		verificarDataDoDocumento: 'Favor verificar a data de validade do documento',
		visualizarDiarioDeBordo: 'Visualizar diário de bordo',
	},
	registroDadosVoo: {
		aceleracaoVertical: 'Aceleração Vertical',
		altitudeAeronave: 'Atitude da Aeronave',
		altitudeTerreno: 'Altitude do Terreno',
		altitudeVoo: 'Altitude do Voo',
		alturaVoo: 'Altura do Voo',
		pressaoDoOleoTurbina: 'Pressão do Óleo da Turbina',
		pressaoOleo: 'Pressão De Óleo',
		proa: 'PROA',
		torque: 'Torque',
		turbina: 'Turbina',
		variacaoTorque: 'Variação de Torque',
		variaveisDeMonitoramento: 'VARIÁVEIS DE MONITORAMENTO',
		velocidadeAeronave: 'Velocidade da Aeronave',
		visualizacaoGraficos: 'Visualização Gráficos',
		visualizacaoInstrumentos: 'Visualização Instrumentos',
	},
	submenu: {
		ControleAtividadeAerea: 'Controle de Atividade Aérea',
		ExtratoCompleto: 'Extrato Completo',
		aeronaves: 'Aeronaves',
		cadAcao: 'Cadastro de Ação',
		cadAfastamento: 'Cadastro de Afastamento',
		cadCargo: 'Cadastro de Cargo',
		cadEscala: 'Cadastro de Escalas',
		cadEvento: 'Cadastro de Eventos',
		cadPosto: 'Cadastro de Posto',
		cadPrevencao: 'Cadastro de Prevenção',
		cadUser: 'Cadastro de Usuário',
		cadastroGrupoInspecao: 'Cadastro de Grupo de Inspeção',
		comunicacaoESO: 'Gerenciamento de risco',
		dataDeConclusao: 'Data de conclusão',
		disciplina: 'Disciplina',
		escala: 'Escala',
		escalas: 'Escalas',
		estatisticaVoo: 'Estatística de Voo',
		eventoSegurancaOperacionalEso: 'Evento Segurança Operacional (ESO)',
		gestaoDeEnsino: 'Gestão de ensino',
		gestaoDeFrequenciaAvaliacao: 'Gestão de Aulas, Frequências e Avaliações',
		gestaoDoEnsino: 'Gestão de Ensino',
		gestaoEscalas: 'Gestão de Escalas',
		horasRastreadas: 'Horas Rastreadas',
		horasVoadas: 'Horas Voadas',
		inscricoesEMatricula: 'Inscrições e Matrículas',
		mostradores: 'Mostradores',
		permutas: 'Permutas, Dispensas Médicas e Liberações',
		prazoParaExecucao: 'Prazo para execução',
		relatorioOperacoes: 'Relatório de Operações',
		relatorioPrevencao: 'Relatório de Prevenção',
		relatorioSolicitacoes: 'Relatório de solicitações',
		relatorioVoo: 'Relatório de Voo',
		segurancaOperacionalEso: 'Gerenciamento de Risco (ESO)',
		segurancaOperacionalRac: 'Relatório de Aviação Civil (RAC)',
		segurancaOperacionalRelPrev: 'Relatório de Prevenção (RelPrev)',
		segurancaOperacionalRire: 'Relatório Inicial de Resposta a Emergências (RIRE)',
		subAdministracao: 'Administração',
		subAtaConclusao: 'Ata de Conclusão',
		subCertificadoConclusao: 'Certificado de Conclusão de Treinamento',
		subEnsino: 'Ensino',
		subEscolar: 'Escolar',
		subFichaDeAvaliacao: 'Ficha de Avaliação de Desempenho em Voo (FADV)',
		subFichaDeAvaliacaoTeorica: 'Ficha de Acompanhamento de Desempenho Teórico (FADT)',
		subOrdem: 'Ordem de Missão',
		subPagamentos: 'Pagamentos',
		subRelatorio: 'Relatórios',
		subRelatorioOrdem: 'Relatório',
		subSolicitacoes: 'Solicitações',
		subTurmas: 'Turmas',
		telaCheia: 'Tela Cheia',
		teoricoEPratico: 'Teórico e Prático',
		treinamento: 'Treinamento',
	},
	uploadfile: {
		arquivoRequired: 'Obrigatório inserir um arquivo',
		download: 'Download',
		erroMSG: 'Esse tipo de arquivo não é permitido.',
		extPermitidas: 'Extensões permitidas',
		foto: 'Foto',
		tituloForm: 'Anexar Arquivo',
	},
}